import * as b from "react";
import { useState as le, useCallback as ht, useLayoutEffect as j_, useEffect as q, createContext as d_, useContext as u_, useMemo as pa, useRef as qt, useReducer as J_, memo as Q_ } from "react";
import m_ from "lodash.debounce";
import { jsx as t, jsxs as g, Fragment as W } from "react/jsx-runtime";
import { ChevronDown as Xt, Check as fa, Close as lt, Block as p_, CheckCircle as $r, Warning as g_, Info as Eo, ChevronRight as Do, VisibilityOn as el, VisibilityOff as tl, Person as al, ChevronUp as ja, DoubleArrowLeft as ol, ChevronLeft as rl, DoubleArrowRight as _l, Error as h_, People as ll, Bot as il, Add as nl, ChatBotColored as cl, PersonAdd as sl, TextLogoFull as dl, LiveChatMono as ul, ChatBotMono as ml, HelpDeskMono as pl, KnowledgeBaseMono as gl, OpenWidgetMono as hl, HelloMono as fl, TextLogo as bl, Calendar as vl, Search as yl, LockBlack as kl, ArrowDownward as Cl, ArrowUpward as wl, ArrowsSort as $l, Call as Sl, OneColored as f_, Refresh as Nl, MoreHoriz as xl } from "@livechat/design-system-icons";
import c from "clsx";
import { useFloatingParentNodeId as Oo, useFloatingNodeId as Ja, useFloating as Qa, autoUpdate as eo, offset as to, flip as Po, size as b_, useClick as ao, useDismiss as oo, useRole as ro, useInteractions as _o, useTransitionStyles as Mo, FloatingNode as ba, FloatingTree as Ro, shift as Sr, arrow as El, hide as Tl, useHover as Bl, safePolygon as Il, useFocus as Al, useTransitionStatus as Dl, FloatingArrow as Ol, FloatingPortal as ha, FloatingFocusManager as br, useListNavigation as Pl, FloatingOverlay as Ml } from "@floating-ui/react";
import * as Rl from "react-dom";
import { flushSync as Fl, createPortal as Gl } from "react-dom";
import { Virtuoso as Ul } from "react-virtuoso";
import { getContrast as Nr } from "polished";
import { DayPicker as Ll } from "react-day-picker";
import { isSameMonth as Wa, subMonths as ta, differenceInCalendarMonths as Or, addMonths as Pr, isSameDay as vr, isAfter as yr, differenceInCalendarDays as v_, isBefore as ql, isPast as Hl, format as io, startOfToday as y_, subDays as no, endOfMonth as zl, startOfMonth as Mr } from "date-fns";
import "react-day-picker/style.css";
import Rr from "lodash.escape";
import { TransitionGroup as k_, CSSTransition as C_ } from "react-transition-group";
import { useFloating as Vl, autoUpdate as Wl, shift as Kl, flip as Yl } from "@floating-ui/react-dom";
const Xl = (e, a) => {
  b.useEffect(() => {
    const o = () => {
      document.visibilityState === "visible" && e();
    };
    return a && document.addEventListener("visibilitychange", o), () => {
      a && document.removeEventListener(
        "visibilitychange",
        o
      );
    };
  }, [e, a]);
}, ra = ({
  isVisible: e,
  elementRef: a,
  includeSleepWakeScenario: o = !1
}) => {
  const [r, _] = b.useState(e), [l, i] = b.useState(e), [n, d] = b.useState(e), u = b.useRef(null), s = () => {
    _(!1), u.current && clearTimeout(u.current);
  };
  return b.useEffect(() => {
    const m = a.current;
    if (!n && m)
      return m.addEventListener("transitionend", s), i(!1), u.current = window.setTimeout(s, 300), () => {
        clearTimeout(u.current), m.removeEventListener(
          "transitionend",
          s
        );
      };
    n && (_(!0), requestAnimationFrame(() => i(!0)));
  }, [n]), b.useEffect(() => {
    d(e);
  }, [e]), Xl(
    () => d(e),
    o
  ), {
    isOpen: l,
    isMounted: r,
    setShouldBeVisible: d
  };
}, Fr = /* @__PURE__ */ (() => {
  let e = null;
  const a = /* @__PURE__ */ new Map();
  return {
    observe: (_, l) => {
      e || (e = new ResizeObserver((i) => {
        i.forEach((n) => {
          const d = n.target, u = a.get(d);
          u && u(n.contentRect);
        });
      })), _ && (a.set(_, l), e.observe(_));
    },
    unobserve: (_) => {
      e && _ && (e.unobserve(_), a.delete(_), a.size === 0 && (e.disconnect(), e = null));
    }
  };
})(), Ya = (e, a) => {
  window.ResizeObserver && (e !== null ? Fr.observe(e, (r) => {
    a(r);
  }) : Fr.unobserve(e));
}, w_ = () => {
  const [e, a] = b.useState(0), o = b.useCallback(
    (r) => Ya(
      r,
      (_) => a(_.height)
    ),
    []
  );
  return {
    size: e,
    handleResizeRef: o
  };
}, Zl = ({
  mobileBreakpoint: e
}) => {
  const [a, o] = b.useState(!1), r = b.useCallback(
    (_) => Ya(
      _,
      (l) => o(l.width <= e)
    ),
    []
  );
  return {
    isMobile: a,
    handleResizeRef: r
  };
}, jl = ["input", "button", "select", "textarea", "a"], Jl = ({
  onClick: e
}) => ({
  handleInteractiveClick: b.useCallback(
    (o) => {
      const r = o.target;
      if (!(r instanceof HTMLElement)) return;
      const _ = r.tagName.toLowerCase();
      jl.includes(_) || e(o);
    },
    [e]
  )
}), Ql = (e = !1) => {
  const [a, o] = le(e);
  return {
    isHovered: a,
    handleMouseOver: () => o(!0),
    handleMouseOut: () => o(!1)
  };
}, ei = (e) => {
  const [a, o] = le(!1), r = ht(() => {
    if (e.current) {
      const l = e.current.scrollHeight > e.current.offsetHeight || e.current.scrollWidth > e.current.offsetWidth;
      o(l);
    }
  }, [e]), _ = m_(() => {
    r();
  }, 100);
  return j_(() => {
    r();
    const l = e.current;
    return l && Ya(l, () => {
      _();
    }), () => {
      Ya(null, () => {
      });
    };
  }, [e, _, r]), q(() => () => {
    _.cancel();
  }, [_]), a;
}, Fd = {
  Background01: "--background-01",
  Background02: "--background-02",
  Background03: "--background-03",
  SurfacePrimaryDefault: "--surface-primary-default",
  SurfaceSecondaryDefault: "--surface-secondary-default",
  SurfaceSecondaryHover: "--surface-secondary-hover",
  SurfaceSecondaryActive: "--surface-secondary-active",
  SurfaceSecondaryDisabled: "--surface-secondary-disabled",
  SurfacePrimaryHover: "--surface-primary-hover",
  SurfacePrimaryActive: "--surface-primary-active",
  SurfacePrimaryActiveColored: "--surface-primary-active-colored",
  SurfacePrimaryDisabled: "--surface-primary-disabled",
  SurfaceTertiaryDefault: "--surface-tertiary-default",
  SurfaceModerateDefault: "--surface-moderate-default",
  SurfaceModerateHover: "--surface-moderate-hover",
  SurfaceModerateActive: "--surface-moderate-active",
  SurfaceTertiaryHover: "--surface-tertiary-hover",
  SurfaceTertiaryActive: "--surface-tertiary-active",
  SurfaceTertiaryDisabled: "--surface-tertiary-disabled",
  SurfaceAccentEmphasisLowInfo: "--surface-accent-emphasis-low-info",
  SurfaceAccentEmphasisLowNegative: "--surface-accent-emphasis-low-negative",
  SurfaceAccentEmphasisLowWarning: "--surface-accent-emphasis-low-warning",
  SurfaceAccentEmphasisLowPositive: "--surface-accent-emphasis-low-positive",
  SurfaceAccentEmphasisLowPurple: "--surface-accent-emphasis-low-purple",
  SurfaceAccentEmphasisMinInfo: "--surface-accent-emphasis-min-info",
  SurfaceAccentEmphasisMinNegative: "--surface-accent-emphasis-min-negative",
  SurfaceAccentEmphasisMinWarning: "--surface-accent-emphasis-min-warning",
  SurfaceAccentEmphasisMinPositive: "--surface-accent-emphasis-min-positive",
  SurfaceAccentEmphasisMinPurple: "--surface-accent-emphasis-min-purple",
  SurfaceAccentOndarkNegativeDefault: "--surface-accent-ondark-negative-default",
  SurfaceAccentOndarkNegativeHover: "--surface-accent-ondark-negative-hover",
  SurfaceAccentOndarkWarningDefault: "--surface-accent-ondark-warning-default",
  SurfaceAccentOndarkWarningHover: "--surface-accent-ondark-warning-hover",
  SurfaceAccentOndarkInfoDefault: "--surface-accent-ondark-info-default",
  SurfaceAccentOndarkInfoHover: "--surface-accent-ondark-info-hover",
  SurfaceAccentOndarkPositiveDefault: "--surface-accent-ondark-positive-default",
  SurfaceAccentOndarkPositiveHover: "--surface-accent-ondark-positive-hover",
  SurfaceAccentEmphasisSubtleNegative: "--surface-accent-emphasis-subtle-negative",
  SurfaceAccentEmphasisSubtleWarning: "--surface-accent-emphasis-subtle-warning",
  SurfaceAccentEmphasisSubtleInfo: "--surface-accent-emphasis-subtle-info",
  SurfaceAccentEmphasisSubtlePositive: "--surface-accent-emphasis-subtle-positive",
  SurfaceInvertPrimary: "--surface-invert-primary",
  SurfaceInvertSecondary: "--surface-invert-secondary",
  SurfaceInvertDisabled: "--surface-invert-disabled",
  SurfaceLockedDefault: "--surface-locked-default",
  SurfaceLockedHover: "--surface-locked-hover",
  SurfaceLockedActive: "--surface-locked-active",
  SurfaceLockedDisabled: "--surface-locked-disabled",
  SurfaceLockedWhite: "--surface-locked-white",
  SurfaceLockedBlack: "--surface-locked-black",
  SurfaceAccentEmphasisMediumNegative: "--surface-accent-emphasis-medium-negative",
  SurfaceAccentEmphasisMediumPositive: "--surface-accent-emphasis-medium-positive",
  SurfaceAccentEmphasisHighInfo: "--surface-accent-emphasis-high-info",
  SurfaceAccentEmphasisHighNegative: "--surface-accent-emphasis-high-negative",
  SurfaceAccentEmphasisHighWarning: "--surface-accent-emphasis-high-warning",
  SurfaceAccentEmphasisHighPositive: "--surface-accent-emphasis-high-positive",
  SurfaceAccentEmphasisHighPurple: "--surface-accent-emphasis-high-purple",
  SurfaceOpacityBasicHover: "--surface-opacity-basic-hover",
  SurfaceOpacityBasicActive: "--surface-opacity-basic-active",
  SurfaceOpacityInvertHover: "--surface-opacity-invert-hover",
  SurfaceOpacityInvertActive: "--surface-opacity-invert-active",
  SurfaceGradient01: "--surface-gradient-01",
  SurfaceGradient02: "--surface-gradient-02",
  SurfaceGradient03: "--surface-gradient-03",
  SurfaceGradient04: "--surface-gradient-04",
  SurfaceGradient05: "--surface-gradient-05",
  SurfaceGradient06: "--surface-gradient-06",
  SurfaceGradient07: "--surface-gradient-07",
  SurfaceGradient08: "--surface-gradient-08",
  SurfaceGradient09: "--surface-gradient-09",
  SurfaceGradient10: "--surface-gradient-10",
  SurfaceGradient11: "--surface-gradient-11",
  SurfaceGradient12: "--surface-gradient-12",
  SurfaceGradient13: "--surface-gradient-13",
  SurfaceGradient14: "--surface-gradient-14",
  SurfaceOtherOverlay: "--surface-other-overlay",
  SurfaceOtherAgent: "--surface-other-agent",
  SurfaceOtherAgentHover: "--surface-other-agent-hover",
  SurfaceOtherSkeleton: "--surface-other-skeleton",
  SurfaceOtherInternalNoteHover: "--surface-other-internal-note-hover",
  SurfaceOtherVisitor: "--surface-other-visitor",
  SurfaceOtherVisitorHover: "--surface-other-visitor-hover",
  ContentBasicPrimary: "--content-basic-primary",
  ContentBasicSecondary: "--content-basic-secondary",
  ContentBasicDisabled: "--content-basic-disabled",
  ContentBasicNegative: "--content-basic-negative",
  ContentBasicWarning: "--content-basic-warning",
  ContentBasicPositive: "--content-basic-positive",
  ContentBasicInfo: "--content-basic-info",
  ContentBasicPurple: "--content-basic-purple",
  ContentBasicGradient01: "--content-basic-gradient-01",
  ContentLockedWhite: "--content-locked-white",
  ContentLockedBlack: "--content-locked-black",
  ContentLockedDefault: "--content-locked-default",
  ContentLockedHover: "--content-locked-hover",
  ContentLockedActive: "--content-locked-active",
  ContentLockedDisabled: "--content-locked-disabled",
  ContentInvertPrimary: "--content-invert-primary",
  ContentInvertSecondary: "--content-invert-secondary",
  ContentInvertDisabled: "--content-invert-disabled",
  ContentInvertGradient01: "--content-invert-gradient-01",
  BorderBasicPrimary: "--border-basic-primary",
  BorderBasicSecondary: "--border-basic-secondary",
  BorderBasicTertiary: "--border-basic-tertiary",
  BorderBasicHover: "--border-basic-hover",
  BorderBasicDisabled: "--border-basic-disabled",
  BorderBasicNegative: "--border-basic-negative",
  BorderBasicWarning: "--border-basic-warning",
  BorderBasicPositive: "--border-basic-positive",
  BorderBasicInfo: "--border-basic-info",
  BorderBasicPurple: "--border-basic-purple",
  BorderBasicContrast: "--border-basic-contrast",
  BorderInvertPrimary: "--border-invert-primary",
  BorderInvertSecondary: "--border-invert-secondary",
  BorderInvertHover: "--border-invert-hover",
  BorderInvertDisabled: "--border-invert-disabled",
  ActionPrimaryActive: "--action-primary-active",
  ActionPrimaryHover: "--action-primary-hover",
  ActionPrimaryDefault: "--action-primary-default",
  ColorActionDefaultRgb: "--color-action-default-rgb",
  ActionPrimaryDisabled: "--action-primary-disabled",
  ActionNegativeActive: "--action-negative-active",
  ActionNegativeHover: "--action-negative-hover",
  ActionNegativeDefault: "--action-negative-default",
  ActionNegativeDisabled: "--action-negative-disabled",
  ActionWarningDefault: "--action-warning-default",
  ActionWarningHover: "--action-warning-hover",
  ActionWarningDisabled: "--action-warning-disabled",
  ActionPositiveDefault: "--action-positive-default",
  ActionPositiveHover: "--action-positive-hover",
  ActionPositiveDisabled: "--action-positive-disabled",
  ActionNeutralDefault: "--action-neutral-default",
  ActionNeutralHover: "--action-neutral-hover",
  ActionNeutralDisabled: "--action-neutral-disabled",
  ActionHighContrastDefault: "--action-high-contrast-default",
  ActionHighContrastHover: "--action-high-contrast-hover",
  ActionHighContrastActive: "--action-high-contrast-active",
  ActionHighContrastDisabled: "--action-high-contrast-disabled",
  SurfaceOtherBot: "--surface-other-bot",
  SurfaceOtherBotHover: "--surface-other-bot-hover",
  ColorBlack: "--color-black",
  ColorWhite: "--color-white",
  DecorBlue900: "--decor-blue900",
  DecorBlue800: "--decor-blue800",
  DecorBlue700: "--decor-blue700",
  DecorBlue600: "--decor-blue600",
  DecorBlue500: "--decor-blue500",
  DecorBlue400: "--decor-blue400",
  DecorBlue300: "--decor-blue300",
  DecorBlue200: "--decor-blue200",
  DecorBlue100: "--decor-blue100",
  DecorBlue50: "--decor-blue50",
  DecorOrange900: "--decor-orange900",
  DecorOrange800: "--decor-orange800",
  DecorOrange700: "--decor-orange700",
  DecorOrange600: "--decor-orange600",
  DecorOrange500: "--decor-orange500",
  DecorOrange400: "--decor-orange400",
  DecorOrange300: "--decor-orange300",
  DecorOrange200: "--decor-orange200",
  DecorOrange100: "--decor-orange100",
  DecorOrange50: "--decor-orange50",
  DecorYellow900: "--decor-yellow900",
  DecorYellow800: "--decor-yellow800",
  DecorYellow700: "--decor-yellow700",
  DecorYellow600: "--decor-yellow600",
  DecorYellow500: "--decor-yellow500",
  DecorYellow400: "--decor-yellow400",
  DecorYellow300: "--decor-yellow300",
  DecorYellow200: "--decor-yellow200",
  DecorYellow100: "--decor-yellow100",
  DecorYellow50: "--decor-yellow50",
  DecorGray950: "--decor-gray950",
  DecorGray900: "--decor-gray900",
  DecorGray800: "--decor-gray800",
  DecorGray700: "--decor-gray700",
  DecorGray600: "--decor-gray600",
  DecorGray500: "--decor-gray500",
  DecorGray400: "--decor-gray400",
  DecorGray300: "--decor-gray300",
  DecorGray200: "--decor-gray200",
  DecorGray150: "--decor-gray150",
  DecorGray100: "--decor-gray100",
  DecorGray75: "--decor-gray75",
  DecorGray50: "--decor-gray50",
  DecorGray40: "--decor-gray40",
  DecorGray20: "--decor-gray20",
  DecorGreen900: "--decor-green900",
  DecorGreen800: "--decor-green800",
  DecorGreen700: "--decor-green700",
  DecorGreen600: "--decor-green600",
  DecorGreen500: "--decor-green500",
  DecorGreen400: "--decor-green400",
  DecorGreen300: "--decor-green300",
  DecorGreen200: "--decor-green200",
  DecorGreen100: "--decor-green100",
  DecorGreen50: "--decor-green50",
  DecorRed900: "--decor-red900",
  DecorRed800: "--decor-red800",
  DecorRed700: "--decor-red700",
  DecorRed600: "--decor-red600",
  DecorRed500: "--decor-red500",
  DecorRed400: "--decor-red400",
  DecorRed300: "--decor-red300",
  DecorRed200: "--decor-red200",
  DecorRed100: "--decor-red100",
  DecorRed50: "--decor-red50",
  DecorPurple900: "--decor-purple900",
  DecorPurple800: "--decor-purple800",
  DecorPurple700: "--decor-purple700",
  DecorPurple600: "--decor-purple600",
  DecorPurple500: "--decor-purple500",
  DecorPurple400: "--decor-purple400",
  DecorPurple300: "--decor-purple300",
  DecorPurple200: "--decor-purple200",
  DecorPurple100: "--decor-purple100",
  DecorPurple50: "--decor-purple50",
  DecorBrown50: "--decor-brown50",
  DecorBrown300: "--decor-brown300",
  ProductsLivechat: "--products-livechat",
  ProductsHelpdesk: "--products-helpdesk",
  ProductsChatbot: "--products-chatbot",
  ProductsKnowledgebase: "--products-knowledgebase",
  IllustrationsPrimary: "--illustrations-primary",
  IllustrationsSecondary: "--illustrations-secondary",
  IllustrationsStroke: "--illustrations-stroke",
  TagSurface01: "--tag-surface-01",
  TagContent01: "--tag-content-01",
  BtnBasicBackgroundEnabled: "--btn-basic-background-enabled",
  BtnBasicBackgroundHover: "--btn-basic-background-hover",
  BtnBasicBackgroundDisabled: "--btn-basic-background-disabled",
  BtnBasicBackgroundActive: "--btn-basic-background-active",
  BtnBasicBackgroundLoading: "--btn-basic-background-loading",
  BtnSecondaryBackgroundEnabled: "--btn-secondary-background-enabled",
  BtnSecondaryBackgroundHover: "--btn-secondary-background-hover",
  BtnSecondaryBackgroundDisabled: "--btn-secondary-background-disabled",
  BtnSecondaryBackgroundActive: "--btn-secondary-background-active",
  BtnSecondaryBackgroundLoading: "--btn-secondary-background-loading",
  BtnPlainIconBackgroundHover: "--btn-plain-icon-background-hover",
  BtnPlainIconBackgroundActive: "--btn-plain-icon-background-active",
  PickerListBackground: "--picker-list-background",
  PickerListGroupBackground: "--picker-list-group-background",
  PickerListOptionBackgroundHover: "--picker-list-option-background-hover",
  PickerListOptionBackgroundActiveHover: "--picker-list-option-background-active-hover",
  PickerListOptionBackgroundFocus: "--picker-list-option-background-focus",
  PickerListOptionBackgroundActive: "--picker-list-option-background-active",
  PopoverBackground: "--popover-background",
  SurfaceAvatar1: "--surface-avatar-1",
  SurfaceAvatar2: "--surface-avatar-2",
  SurfaceAvatar3: "--surface-avatar-3",
  SurfaceAvatar4: "--surface-avatar-4",
  SurfaceAvatar5: "--surface-avatar-5",
  SurfaceAvatar6: "--surface-avatar-6",
  SurfaceAvatar7: "--surface-avatar-7",
  SurfaceAvatar8: "--surface-avatar-8",
  SurfaceAvatar9: "--surface-avatar-9",
  SurfaceAvatar10: "--surface-avatar-10",
  NavbarBackground: "--navbar-background",
  TooltipBackgroundBasic: "--tooltip-background-basic",
  TooltipBackgroundInvert: "--tooltip-background-invert",
  TooltipBorder: "--tooltip-border",
  TooltipBorderForSvg: "--tooltip-border-for-svg",
  AnimatedGradientValue1: "--animated-gradient-value-1",
  AnimatedGradientValue2: "--animated-gradient-value-2",
  AnimatedGradientValue3: "--animated-gradient-value-3",
  ContentBasicInternalNote: "--content-basic-internal-note",
  ContentBasicBot: "--content-basic-bot",
  ActionLockDefault: "--action-lock-default",
  ActionLockHover: "--action-lock-hover",
  ActionLockActive: "--action-lock-active",
  ActionLockDisabled: "--action-lock-disabled",
  SurfaceOtherInternalNoteMessageArea: "--surface-other-internal-note-message-area",
  SurfaceOtherInternalNoteDefault: "--surface-other-internal-note-default",
  ContentBasicInternalNoteMessagePlaceholder: "--content-basic-internal-note-message-placeholder",
  ContentBasicInternalNoteMessageActive: "--content-basic-internal-note-message-active",
  OnePopoverMessageBackgroundDefault: "--one-popover-message-background-default",
  OnePopoverBorderDefault: "--one-popover-border-default",
  OnePopoverBorderActive: "--one-popover-border-active",
  OneTooltipBackground: "--one-tooltip-background",
  ContentBasicAutofill: "--content-basic-autofill",
  ProductsHello: "--products-hello",
  ProductsPlatform: "--products-platform",
  SurfaceCheckListItemOpenBackground: "--surface-check-list-item-open-background",
  SurfaceCheckListBackground: "--surface-check-list-background",
  ContentBasicPlaceholder: "--content-basic-placeholder",
  InputPromoBorderDefault: "--input-promo-border-default",
  InputPromoBorderHover: "--input-promo-border-hover",
  SurfaceAiCopilotBasicDefault: "--surface-ai-copilot-basic-default",
  SurfaceAiCopilotBasicHover: "--surface-ai-copilot-basic-hover",
  SurfaceAiCopilotBasicActive: "--surface-ai-copilot-basic-active",
  SurfaceAiCopilotInvert01: "--surface-ai-copilot-invert-01",
  SurfaceAiCopilotInvert02: "--surface-ai-copilot-invert-02",
  SurfaceAiOther01Default: "--surface-ai-other-01-default",
  SurfaceAiOther01Hover: "--surface-ai-other-01-hover",
  SurfaceAiOther01Active: "--surface-ai-other-01-active",
  SurfaceAiOther02Default: "--surface-ai-other-02-default",
  BorderAiCopilotBasicDefault: "--border-ai-copilot-basic-default",
  BorderAiCopilotBasicHover: "--border-ai-copilot-basic-hover",
  BorderAiCopilotBasicActive: "--border-ai-copilot-basic-active",
  BorderAiOther01: "--border-ai-other-01",
  ContentAiCopilotBasic: "--content-ai-copilot-basic",
  ContentAiCopilotInvert: "--content-ai-copilot-invert",
  ContentAiOther1Default: "--content-ai-other-1-default",
  CategoricalMain1: "--categorical-main-1",
  CategoricalMain2: "--categorical-main-2",
  CategoricalMain3: "--categorical-main-3",
  CategoricalMain4: "--categorical-main-4",
  CategoricalMain5: "--categorical-main-5",
  CategoricalMain6: "--categorical-main-6",
  CategoricalMain7: "--categorical-main-7",
  CategoricalMain8: "--categorical-main-8",
  CategoricalMain9: "--categorical-main-9",
  CategoricalMain10: "--categorical-main-10",
  CategoricalMain11: "--categorical-main-11",
  CategoricalMain12: "--categorical-main-12",
  CategoricalMain13: "--categorical-main-13",
  CategoricalMain14: "--categorical-main-14",
  SequentialBlue25: "--sequential-blue-25",
  SequentialBlue50: "--sequential-blue-50",
  SequentialBlue100: "--sequential-blue-100",
  SequentialBlue200: "--sequential-blue-200",
  SequentialBlue300: "--sequential-blue-300",
  SequentialBlue400: "--sequential-blue-400",
  SequentialBlue500: "--sequential-blue-500",
  SequentialBlue600: "--sequential-blue-600",
  SequentialBlue700: "--sequential-blue-700",
  SequentialBlue800: "--sequential-blue-800",
  SequentialBlue900: "--sequential-blue-900",
  SequentialBlue950: "--sequential-blue-950",
  SequentialYellow25: "--sequential-yellow-25",
  SequentialYellow50: "--sequential-yellow-50",
  SequentialYellow100: "--sequential-yellow-100",
  SequentialYellow200: "--sequential-yellow-200",
  SequentialYellow300: "--sequential-yellow-300",
  SequentialYellow400: "--sequential-yellow-400",
  SequentialYellow500: "--sequential-yellow-500",
  SequentialYellow600: "--sequential-yellow-600",
  SequentialYellow700: "--sequential-yellow-700",
  SequentialYellow800: "--sequential-yellow-800",
  SequentialYellow900: "--sequential-yellow-900",
  SequentialYellow950: "--sequential-yellow-950",
  SequentialGreen25: "--sequential-green-25",
  SequentialGreen50: "--sequential-green-50",
  SequentialGreen100: "--sequential-green-100",
  SequentialGreen200: "--sequential-green-200",
  SequentialGreen300: "--sequential-green-300",
  SequentialGreen400: "--sequential-green-400",
  SequentialGreen500: "--sequential-green-500",
  SequentialGreen600: "--sequential-green-600",
  SequentialGreen700: "--sequential-green-700",
  SequentialGreen800: "--sequential-green-800",
  SequentialGreen900: "--sequential-green-900",
  SequentialGreen950: "--sequential-green-950",
  SequentialMagenta25: "--sequential-magenta-25",
  SequentialMagenta50: "--sequential-magenta-50",
  SequentialMagenta100: "--sequential-magenta-100",
  SequentialMagenta200: "--sequential-magenta-200",
  SequentialMagenta300: "--sequential-magenta-300",
  SequentialMagenta400: "--sequential-magenta-400",
  SequentialMagenta500: "--sequential-magenta-500",
  SequentialMagenta600: "--sequential-magenta-600",
  SequentialMagenta700: "--sequential-magenta-700",
  SequentialMagenta800: "--sequential-magenta-800",
  SequentialMagenta900: "--sequential-magenta-900",
  SequentialMagenta950: "--sequential-magenta-950",
  SequentialOrange25: "--sequential-orange-25",
  SequentialOrange50: "--sequential-orange-50",
  SequentialOrange100: "--sequential-orange-100",
  SequentialOrange200: "--sequential-orange-200",
  SequentialOrange300: "--sequential-orange-300",
  SequentialOrange400: "--sequential-orange-400",
  SequentialOrange500: "--sequential-orange-500",
  SequentialOrange600: "--sequential-orange-600",
  SequentialOrange700: "--sequential-orange-700",
  SequentialOrange800: "--sequential-orange-800",
  SequentialOrange900: "--sequential-orange-900",
  SequentialOrange950: "--sequential-orange-950",
  SequentialPurple25: "--sequential-purple-25",
  SequentialPurple50: "--sequential-purple-50",
  SequentialPurple100: "--sequential-purple-100",
  SequentialPurple200: "--sequential-purple-200",
  SequentialPurple300: "--sequential-purple-300",
  SequentialPurple400: "--sequential-purple-400",
  SequentialPurple500: "--sequential-purple-500",
  SequentialPurple600: "--sequential-purple-600",
  SequentialPurple700: "--sequential-purple-700",
  SequentialPurple800: "--sequential-purple-800",
  SequentialPurple900: "--sequential-purple-900",
  SequentialPurple950: "--sequential-purple-950",
  SequentialRed25: "--sequential-red-25",
  SequentialRed50: "--sequential-red-50",
  SequentialRed100: "--sequential-red-100",
  SequentialRed200: "--sequential-red-200",
  SequentialRed300: "--sequential-red-300",
  SequentialRed400: "--sequential-red-400",
  SequentialRed500: "--sequential-red-500",
  SequentialRed600: "--sequential-red-600",
  SequentialRed700: "--sequential-red-700",
  SequentialRed800: "--sequential-red-800",
  SequentialRed900: "--sequential-red-900",
  SequentialRed950: "--sequential-red-950",
  Categorical1colorColor1: "--categorical-1color-color1",
  Categorical1colorColor2: "--categorical-1color-color2",
  Categorical1colorColor3: "--categorical-1color-color3",
  Categorical1colorColor4: "--categorical-1color-color4",
  Categorical2colorsOption1Color1: "--categorical-2colors-option1-color1",
  Categorical2colorsOption1Color2: "--categorical-2colors-option1-color2",
  Categorical2colorsOption2Color1: "--categorical-2colors-option2-color1",
  Categorical2colorsOption2Color2: "--categorical-2colors-option2-color2",
  Categorical2colorsOption3Color1: "--categorical-2colors-option3-color1",
  Categorical2colorsOption3Color2: "--categorical-2colors-option3-color2",
  Categorical2colorsOption4Color1: "--categorical-2colors-option4-color1",
  Categorical2colorsOption4Color2: "--categorical-2colors-option4-color2",
  Categorical2colorsOption5Color1: "--categorical-2colors-option5-color1",
  Categorical2colorsOption5Color2: "--categorical-2colors-option5-color2",
  Categorical2colorsOption6Color1: "--categorical-2colors-option6-color1",
  Categorical2colorsOption6Color2: "--categorical-2colors-option6-color2",
  Categorical3colorsOption1Color1: "--categorical-3colors-option1-color1",
  Categorical3colorsOption1Color2: "--categorical-3colors-option1-color2",
  Categorical3colorsOption1Color3: "--categorical-3colors-option1-color3",
  Categorical3colorsOption2Color1: "--categorical-3colors-option2-color1",
  Categorical3colorsOption2Color2: "--categorical-3colors-option2-color2",
  Categorical3colorsOption2Color3: "--categorical-3colors-option2-color3",
  Categorical3colorsOption3Color1: "--categorical-3colors-option3-color1",
  Categorical3colorsOption3Color2: "--categorical-3colors-option3-color2",
  Categorical3colorsOption3Color3: "--categorical-3colors-option3-color3",
  Categorical3colorsOption4Color1: "--categorical-3colors-option4-color1",
  Categorical3colorsOption4Color2: "--categorical-3colors-option4-color2",
  Categorical3colorsOption4Color3: "--categorical-3colors-option4-color3",
  Categorical3colorsOption5Color1: "--categorical-3colors-option5-color1",
  Categorical3colorsOption5Color2: "--categorical-3colors-option5-color2",
  Categorical3colorsOption5Color3: "--categorical-3colors-option5-color3",
  Categorical3colorsOption6Color1: "--categorical-3colors-option6-color1",
  Categorical3colorsOption6Color2: "--categorical-3colors-option6-color2",
  Categorical3colorsOption6Color3: "--categorical-3colors-option6-color3",
  Categorical4colorsOption1Color1: "--categorical-4colors-option1-color1",
  Categorical4colorsOption1Color2: "--categorical-4colors-option1-color2",
  Categorical4colorsOption1Color3: "--categorical-4colors-option1-color3",
  Categorical4colorsOption1Color4: "--categorical-4colors-option1-color4",
  Categorical4colorsOption2Color1: "--categorical-4colors-option2-color1",
  Categorical4colorsOption2Color2: "--categorical-4colors-option2-color2",
  Categorical4colorsOption2Color3: "--categorical-4colors-option2-color3",
  Categorical4colorsOption2Color4: "--categorical-4colors-option2-color4",
  Categorical4colorsOption3Color1: "--categorical-4colors-option3-color1",
  Categorical4colorsOption3Color2: "--categorical-4colors-option3-color2",
  Categorical4colorsOption3Color3: "--categorical-4colors-option3-color3",
  Categorical4colorsOption3Color4: "--categorical-4colors-option3-color4",
  Categorical5colorsOption1Color1: "--categorical-5colors-option1-color1",
  Categorical5colorsOption1Color2: "--categorical-5colors-option1-color2",
  Categorical5colorsOption1Color3: "--categorical-5colors-option1-color3",
  Categorical5colorsOption1Color4: "--categorical-5colors-option1-color4",
  Categorical5colorsOption1Color5: "--categorical-5colors-option1-color5",
  Categorical5colorsOption2Color1: "--categorical-5colors-option2-color1",
  Categorical5colorsOption2Color2: "--categorical-5colors-option2-color2",
  Categorical5colorsOption2Color3: "--categorical-5colors-option2-color3",
  Categorical5colorsOption2Color4: "--categorical-5colors-option2-color4",
  Categorical5colorsOption2Color5: "--categorical-5colors-option2-color5",
  UifoundationSurfaceDefault: "--uifoundation-surface-default",
  UifoundationBorderGrid: "--uifoundation-border-grid",
  UifoundationBorderAxis: "--uifoundation-border-axis"
}, Gd = {
  Spacing0: "--spacing-0",
  Spacing05: "--spacing-05",
  Spacing1: "--spacing-1",
  Spacing2: "--spacing-2",
  Spacing3: "--spacing-3",
  Spacing4: "--spacing-4",
  Spacing5: "--spacing-5",
  Spacing6: "--spacing-6",
  Spacing7: "--spacing-7",
  Spacing8: "--spacing-8",
  Spacing9: "--spacing-9",
  Spacing10: "--spacing-10",
  Spacing11: "--spacing-11",
  Spacing12: "--spacing-12",
  Spacing14: "--spacing-14",
  Spacing16: "--spacing-16",
  Spacing18: "--spacing-18",
  Spacing20: "--spacing-20",
  Spacing24: "--spacing-24"
}, Ud = {
  Float: "--shadow-float",
  PopOver: "--shadow-pop-over",
  Modal: "--shadow-modal",
  Tooltip: "--shadow-tooltip",
  TooltipArrowBottom: "--shadow-tooltip-arrow-bottom",
  TooltipArrowTop: "--shadow-tooltip-arrow-top",
  TooltipArrowRight: "--shadow-tooltip-arrow-right",
  TooltipArrowLeft: "--shadow-tooltip-arrow-left",
  TooltipArrow: "--shadow-tooltip-arrow",
  Focus: "--shadow-focus",
  DividerBottom: "--shadow-divider-bottom",
  DividerTop: "--shadow-divider-top",
  DividerRight: "--shadow-divider-right",
  DividerLeft: "--shadow-divider-left",
  DividerBottomLeft: "--shadow-divider-bottom-left",
  DividerTopLeft: "--shadow-divider-top-left",
  DividerTopRight: "--shadow-divider-top-right",
  DividerBottomRight: "--shadow-divider-bottom-right",
  MessageBox: "--shadow-message-box",
  FixedRight: "--shadow-fixed-right",
  FixedLeft: "--shadow-fixed-left",
  FixedTop: "--shadow-fixed-top",
  FixedBottom: "--shadow-fixed-bottom",
  ShadowAiCopilotAnimationStart: "--shadow-ai-copilot-animation-start",
  ShadowAiCopilotAnimationMedium1: "--shadow-ai-copilot-animation-medium1",
  ShadowAiCopilotAnimationMedium2: "--shadow-ai-copilot-animation-medium2",
  ShadowAiCopilotAnimationMedium3: "--shadow-ai-copilot-animation-medium3",
  ShadowAiCopilotAnimationEnd: "--shadow-ai-copilot-animation-end",
  ShadowAiOtherFloat: "--shadow-ai-other-float",
  ShadowAiOtherActiveField: "--shadow-ai-other-active-field",
  ShadowTourAnimationEnd: "--shadow-tour-animation-end"
}, Ld = {
  Radius0: "--radius-0",
  Radius1: "--radius-1",
  Radius2: "--radius-2",
  Radius3: "--radius-3",
  Radius4: "--radius-4",
  UiFoundationRadiusBar: "--uifoundation-radius-bar",
  0: "--radius-0",
  // deprecated
  1: "--radius-1",
  // deprecated
  2: "--radius-2",
  // deprecated
  3: "--radius-3",
  // deprecated
  4: "--radius-4"
  // deprecated
}, qd = {
  Fast1: "--transition-duration-fast-1",
  Fast2: "--transition-duration-fast-2",
  Moderate1: "--transition-duration-moderate-1"
}, Hd = {
  EaseIn: "--transition-timing-ease-in",
  EaseOut: "--transition-timing-ease-out"
}, zd = {
  Instant: "--delay-instant",
  Moderate: "--delay-moderate",
  Slow: "--delay-slow"
};
var Kt = /* @__PURE__ */ ((e) => (e.Dark = "lc-dark-theme", e.Light = "lc-light-theme", e))(Kt || {});
const Vd = (e) => e === "dark" ? Kt.Dark : Kt.Light, $_ = d_(void 0), Wd = () => {
  const e = u_($_);
  if (!e)
    throw new Error("useTheme must be used within a ThemeProvider");
  return e;
}, Kd = ({
  children: e,
  initialTheme: a = "light",
  customVariables: o = {}
}) => {
  const [r, _] = le(a), [l, i] = le(o);
  q(() => {
    document.body.classList.remove(Kt.Light, Kt.Dark), document.body.classList.add(`lc-${r}-theme`);
    for (const [d, u] of Object.entries(l))
      document.body.style.setProperty(d, u);
  }, [r, l]);
  const n = pa(
    () => ({
      theme: r,
      toggleTheme: () => _((d) => d === "light" ? "dark" : "light"),
      setTheme: _,
      setCustomVariables: (d) => {
        i(d);
      }
    }),
    [r, _, i]
  );
  return /* @__PURE__ */ t($_.Provider, { value: n, children: e });
}, S_ = b.createContext(
  void 0
), xr = () => {
  const e = b.useContext(S_);
  if (!e)
    throw new Error("useAppFrame must be used within a AppFrameProvider");
  return e;
}, ti = ({
  children: e,
  isSideNavigationVisible: a = !0,
  isMobileViewVisible: o = !1
}) => {
  const [r, _] = b.useState(a), [l, i] = b.useState(o), n = b.useMemo(
    () => ({
      isSideNavigationVisible: r,
      toggleSideNavigationVisibility: () => _(!r),
      isMobileViewEnabled: l,
      setIsMobileViewEnabled: (d) => i(d)
    }),
    [
      r,
      _,
      l,
      i
    ]
  );
  return /* @__PURE__ */ t(S_.Provider, { value: n, children: e });
}, Yd = (e, a) => `color-mix(in srgb, var(${e}) ${a}, transparent)`, ai = "lc-Icon-module__icon___J5RH5", Gr = {
  icon: ai,
  "icon--primary": "lc-Icon-module__icon--primary___lclud",
  "icon--subtle": "lc-Icon-module__icon--subtle___d17Qj",
  "icon--inverted": "lc-Icon-module__icon--inverted___Cb4ml",
  "icon--inverted-subtle": "lc-Icon-module__icon--inverted-subtle___kw-gq",
  "icon--link": "lc-Icon-module__icon--link___TM17Q",
  "icon--success": "lc-Icon-module__icon--success___Jbdc3",
  "icon--warning": "lc-Icon-module__icon--warning___2xp2W",
  "icon--error": "lc-Icon-module__icon--error___95ah2",
  "icon--negative": "lc-Icon-module__icon--negative___Ds5e2",
  "icon--positive": "lc-Icon-module__icon--positive___Uy-GO",
  "icon--info": "lc-Icon-module__icon--info___sIO63",
  "icon--action-primary": "lc-Icon-module__icon--action-primary___iKKt4",
  "icon--action-negative": "lc-Icon-module__icon--action-negative___n9ONx",
  "icon--action-positive": "lc-Icon-module__icon--action-positive___Xq7UP",
  "icon--action-warning": "lc-Icon-module__icon--action-warning___UsFlk",
  "icon--action-neutral": "lc-Icon-module__icon--action-neutral___Hhno9",
  "icon--disabled--primary": "lc-Icon-module__icon--disabled--primary___M6mL2",
  "icon--disabled--subtle": "lc-Icon-module__icon--disabled--subtle___gs7xm",
  "icon--disabled--inverted": "lc-Icon-module__icon--disabled--inverted___SJMuj",
  "icon--disabled--inverted-subtle": "lc-Icon-module__icon--disabled--inverted-subtle___4YUA4",
  "icon--disabled--link": "lc-Icon-module__icon--disabled--link___sLus3",
  "icon--disabled--success": "lc-Icon-module__icon--disabled--success___XqRSR",
  "icon--disabled--warning": "lc-Icon-module__icon--disabled--warning___72dUP",
  "icon--disabled--error": "lc-Icon-module__icon--disabled--error___-0U0g",
  "icon--disabled--negative": "lc-Icon-module__icon--disabled--negative___V7paN",
  "icon--disabled--positive": "lc-Icon-module__icon--disabled--positive___X0-e0",
  "icon--disabled--info": "lc-Icon-module__icon--disabled--info___IlUe5",
  "icon--disabled--action-primary": "lc-Icon-module__icon--disabled--action-primary___4GYxP",
  "icon--disabled--action-negative": "lc-Icon-module__icon--disabled--action-negative___WP3Hi",
  "icon--disabled--action-positive": "lc-Icon-module__icon--disabled--action-positive___3Gz5e",
  "icon--disabled--action-warning": "lc-Icon-module__icon--disabled--action-warning___GHGY2",
  "icon--disabled--action-neutral": "lc-Icon-module__icon--disabled--action-neutral___a53XD",
  "icon--disabled--lock-black": "lc-Icon-module__icon--disabled--lock-black___JaNzw"
}, oi = {
  xsmall: {
    width: 12,
    height: 12
  },
  small: {
    width: 16,
    height: 16
  },
  medium: {
    width: 20,
    height: 20
  },
  large: {
    width: 24,
    height: 24
  },
  xlarge: {
    width: 32,
    height: 32
  },
  xxlarge: {
    width: 48,
    height: 48
  },
  xxxlarge: {
    width: 64,
    height: 64
  }
}, Ur = "icon", O = (e) => {
  const {
    source: a,
    size: o = "medium",
    kind: r,
    disabled: _,
    className: l,
    customColor: i,
    ...n
  } = e, d = b.createElement(a, {
    ...oi[o],
    ...i ? { color: i } : {}
  }), u = c(
    l,
    Gr[Ur],
    r && Gr[`${Ur}--${_ ? "disabled--" : ""}${r}`]
  );
  return /* @__PURE__ */ t("span", { ...n, className: u, children: d });
}, ot = {
  "heading-xl": "lc-Typography-module__heading-xl___jTpRq",
  "heading-lg": "lc-Typography-module__heading-lg___VGjgP",
  "heading-md": "lc-Typography-module__heading-md___U-DUC",
  "heading-sm": "lc-Typography-module__heading-sm___SgG32",
  "heading-xs": "lc-Typography-module__heading-xs___cKzMb",
  "heading-2xs": "lc-Typography-module__heading-2xs___K6Lmw",
  "heading-3xs": "lc-Typography-module__heading-3xs___roTs0",
  "heading-uppercase": "lc-Typography-module__heading-uppercase___DC8Ro",
  "heading-bold": "lc-Typography-module__heading-bold___5Ez7T",
  "paragraph-lg": "lc-Typography-module__paragraph-lg___KmMBe",
  "paragraph-md": "lc-Typography-module__paragraph-md___Ogs8k",
  "paragraph-sm": "lc-Typography-module__paragraph-sm___5KRhm",
  "paragraph-xs": "lc-Typography-module__paragraph-xs___TlVSn",
  "paragraph--semi-bold": "lc-Typography-module__paragraph--semi-bold___Ya1Sm",
  "paragraph--bold": "lc-Typography-module__paragraph--bold___HVepi",
  "paragraph--underline": "lc-Typography-module__paragraph--underline___M3l4C",
  "paragraph--strike": "lc-Typography-module__paragraph--strike___gmYoG",
  "paragraph--uppercase": "lc-Typography-module__paragraph--uppercase___8bXNL",
  "paragraph--no-margin": "lc-Typography-module__paragraph--no-margin___7wc0Y",
  "display-md": "lc-Typography-module__display-md___i1Zgu",
  "display-sm": "lc-Typography-module__display-sm___f46hM",
  "display-lg": "lc-Typography-module__display-lg___wAcSa",
  "display-max": "lc-Typography-module__display-max___W4YZ0",
  "display--bold": "lc-Typography-module__display--bold___tIiWp"
}, ri = {
  xl: "h1",
  lg: "h2",
  md: "h3",
  sm: "h4",
  xs: "h5",
  "2xs": "h6",
  // HTML only provides h1-h6 elements, so smaller heading sizes reuse h6
  "3xs": "h6"
}, ce = ({
  as: e,
  size: a = "md",
  children: o,
  className: r,
  uppercase: _,
  bold: l,
  customColor: i,
  textAlign: n,
  ...d
}) => b.createElement(
  e || ri[a],
  {
    className: c(
      {
        [ot[`heading-${a}`]]: !0,
        [ot["heading-uppercase"]]: _,
        [ot["heading-bold"]]: l
      },
      r
    ),
    style: {
      ...i && { color: i },
      ...n && { textAlign: n }
    },
    ...d
  },
  o
), T = ({
  as: e = "p",
  size: a = "md",
  caps: o = !1,
  uppercase: r = !1,
  bold: _ = !1,
  semiBold: l = !1,
  underline: i = !1,
  strike: n = !1,
  children: d,
  className: u,
  customColor: s,
  textAlign: m,
  noMargin: h,
  ...y
}) => {
  const p = "paragraph";
  return b.createElement(
    e,
    {
      className: c(
        {
          [ot[`${p}-${a}`]]: !0,
          [ot[`${p}--semi-bold`]]: l && !_,
          [ot[`${p}--bold`]]: _ && !l,
          [ot[`${p}--strike`]]: n,
          [ot[`${p}--underline`]]: i,
          [ot[`${p}--uppercase`]]: r || o,
          [ot[`${p}--no-margin`]]: h
        },
        u
      ),
      style: {
        ...s && { color: s },
        ...m && { textAlign: m }
      },
      ...y
    },
    d
  );
}, Lr = ({
  as: e = "div",
  size: a = "md",
  children: o,
  className: r,
  customColor: _,
  textAlign: l,
  bold: i = !0,
  ...n
}) => b.createElement(
  e,
  {
    className: c(
      ot[`display-${a}`],
      {
        [ot["display--bold"]]: i
      },
      r
    ),
    style: {
      ..._ && { color: _ },
      ...l && { textAlign: l }
    },
    ...n
  },
  o
), Xd = [
  "xl",
  "lg",
  "md",
  "sm",
  "xs",
  "2xs",
  "3xs"
], ya = {
  "accordion-animated-label": "lc-AccordionAnimatedLabel-module__accordion-animated-label___zYrr7",
  "accordion-animated-label__open": "lc-AccordionAnimatedLabel-module__accordion-animated-label__open___l8gMd",
  "accordion-animated-label__close": "lc-AccordionAnimatedLabel-module__accordion-animated-label__close___c5sxF",
  "accordion-animated-label__open--visible": "lc-AccordionAnimatedLabel-module__accordion-animated-label__open--visible___y16mk",
  "accordion-animated-label__close--visible": "lc-AccordionAnimatedLabel-module__accordion-animated-label__close--visible___JWsqj"
}, ka = "accordion-animated-label", _i = ({
  open: e,
  closed: a,
  isOpen: o
}) => {
  const r = b.useRef(null), _ = b.useRef(null), [l, i] = b.useState(void 0), { isOpen: n, isMounted: d } = ra({
    isVisible: o,
    elementRef: r
  }), { isOpen: u, isMounted: s } = ra(
    {
      isVisible: !o,
      elementRef: _
    }
  );
  return b.useEffect(() => {
    const m = o ? r.current : _.current;
    if (m) {
      const h = m.getBoundingClientRect().height;
      i(h);
    }
  }, [o, d, s]), /* @__PURE__ */ g(
    "div",
    {
      className: ya[ka],
      style: { height: l ? `${l}px` : "auto" },
      children: [
        d && /* @__PURE__ */ t(
          "div",
          {
            ref: r,
            className: c(ya[`${ka}__open`], {
              [ya[`${ka}__open--visible`]]: n
            }),
            children: e
          }
        ),
        s && /* @__PURE__ */ t(
          "div",
          {
            ref: _,
            className: c(ya[`${ka}__close`], {
              [ya[`${ka}__close--visible`]]: u
            }),
            children: a
          }
        )
      ]
    }
  );
}, qr = {
  "accordion-multiline": "lc-AccordionMultilineElement-module__accordion-multiline___lXTFn",
  "accordion-multiline__inner": "lc-AccordionMultilineElement-module__accordion-multiline__inner___tu-HW"
}, Hr = "accordion-multiline", li = ({ children: e, isExpanded: a }) => {
  const o = b.useRef(null), { isOpen: r, isMounted: _ } = ra({
    isVisible: !a,
    elementRef: o
  }), { size: l, handleResizeRef: i } = w_();
  return /* @__PURE__ */ t(
    "div",
    {
      className: qr[`${Hr}`],
      style: { maxHeight: r ? l : 0 },
      ref: o,
      children: /* @__PURE__ */ t("div", { ref: i, children: _ && /* @__PURE__ */ t("div", { className: qr[`${Hr}__inner`], children: e }) })
    }
  );
}, ii = (e) => e.open !== void 0 && e.closed !== void 0, ni = (e, a) => {
  if (ii(e)) {
    const o = {
      open: e.open,
      closed: e.closed,
      isOpen: a
    };
    return /* @__PURE__ */ t(_i, { ...o });
  }
  return e;
}, ci = ({
  isControlled: e,
  isExpanded: a,
  setShouldBeVisible: o,
  onOpen: r,
  onClose: _
}) => {
  const l = (n) => {
    n ? _?.() : r?.(), !e && o(!n);
  }, i = b.useCallback(
    (n) => {
      (!a && (n.key === "Enter" || n.key === " ") || a && n.key === "Escape") && l(a);
    },
    [a, l]
  );
  return {
    handleExpandChange: l,
    handleKeyDown: i
  };
}, si = "lc-Accordion-module__accordion___wD27Q", di = "lc-Accordion-module__accordion__chevron___3-rGN", ui = "lc-Accordion-module__accordion__label___1MyYP", mi = "lc-Accordion-module__accordion__content___vfjP2", pi = "lc-Accordion-module__accordion__content__inner___Z-9cB", gi = "lc-Accordion-module__accordion__footer___KHIrl", ue = {
  accordion: si,
  "accordion--warning": "lc-Accordion-module__accordion--warning___PJg4j",
  "accordion--error": "lc-Accordion-module__accordion--error___rage8",
  "accordion--promo": "lc-Accordion-module__accordion--promo___KYLtP",
  "accordion--open": "lc-Accordion-module__accordion--open___q9p79",
  accordion__chevron: di,
  "accordion__chevron--open": "lc-Accordion-module__accordion__chevron--open___Yax5V",
  "accordion__chevron--promo": "lc-Accordion-module__accordion__chevron--promo___VXb92",
  accordion__label: ui,
  "accordion__label--promo": "lc-Accordion-module__accordion__label--promo___SDMpV",
  accordion__content: mi,
  accordion__content__inner: pi,
  "accordion__content__inner--open": "lc-Accordion-module__accordion__content__inner--open___BhKjm",
  "accordion__content__inner--promo": "lc-Accordion-module__accordion__content__inner--promo___o4mw9",
  "accordion__content__inner--full-width": "lc-Accordion-module__accordion__content__inner--full-width___HpIN0",
  accordion__footer: gi,
  "accordion__footer--promo": "lc-Accordion-module__accordion__footer--promo___N1Ebg"
}, N_ = ({
  className: e,
  mainClassName: a,
  children: o,
  label: r,
  multilineElement: _,
  openOnInit: l = !1,
  fullWidthContent: i,
  hideChevron: n,
  isOpen: d,
  isPromo: u,
  footer: s,
  onClose: m,
  onOpen: h,
  ...y
}) => {
  const p = d !== void 0, k = p ? d : l, x = b.useRef(null), {
    isOpen: C,
    isMounted: S,
    setShouldBeVisible: N
  } = ra({
    isVisible: k,
    elementRef: x
  }), { size: $, handleResizeRef: w } = w_(), { handleExpandChange: f, handleKeyDown: v } = ci({
    isControlled: p,
    isExpanded: C,
    setShouldBeVisible: N,
    onOpen: h,
    onClose: m
  }), E = c(
    a,
    {
      [ue[`${me}--open`]]: C
    },
    e
  ), D = (B) => {
    const M = B ? ce : T, I = {
      "aria-expanded": C,
      as: "div",
      className: c(ue[`${me}__label`], {
        [ue[`${me}__label--promo`]]: B
      }),
      onClick: () => f(C),
      bold: B ? void 0 : !0,
      ...B ? { size: "xs" } : {}
    };
    return /* @__PURE__ */ t(M, { ...I, children: ni(r, C) });
  };
  return /* @__PURE__ */ g(
    "div",
    {
      tabIndex: 0,
      "aria-expanded": C,
      className: E,
      onKeyDown: v,
      ...y,
      children: [
        !n && /* @__PURE__ */ t(
          O,
          {
            source: Xt,
            className: c(ue[`${me}__chevron`], {
              [ue[`${me}__chevron--open`]]: C,
              [ue[`${me}__chevron--promo`]]: u
            })
          }
        ),
        D(u),
        _ && /* @__PURE__ */ t(li, { isExpanded: C, children: _ }),
        /* @__PURE__ */ t(
          "div",
          {
            className: ue[`${me}__content`],
            style: { maxHeight: C ? $ : 0 },
            ref: x,
            children: /* @__PURE__ */ t("div", { ref: w, children: S && /* @__PURE__ */ g(W, { children: [
              /* @__PURE__ */ t(
                T,
                {
                  as: "div",
                  className: c(ue[`${me}__content__inner`], {
                    [ue[`${me}__content__inner--open`]]: C,
                    [ue[`${me}__content__inner--promo`]]: u,
                    [ue[`${me}__content__inner--full-width`]]: i
                  }),
                  children: o
                }
              ),
              s && /* @__PURE__ */ t(
                T,
                {
                  as: "div",
                  "aria-label": "Accordion footer",
                  role: "complementary",
                  className: c(ue[`${me}__footer`], {
                    [ue[`${me}__footer--promo`]]: u
                  }),
                  children: s
                }
              )
            ] }) })
          }
        )
      ]
    }
  );
}, me = "accordion", Zd = ({ kind: e, ...a }) => {
  const o = c(ue[me], ue[`${me}--${e}`]);
  return /* @__PURE__ */ t(N_, { mainClassName: o, ...a });
}, hi = `${me}--promo`, jd = (e) => {
  const a = c(ue[me], ue[hi]);
  return /* @__PURE__ */ t(N_, { mainClassName: a, isPromo: !0, ...e });
}, ie = {
  esc: "Escape",
  enter: "Enter",
  backspace: "Backspace",
  delete: "Delete",
  spacebar: " ",
  tab: "Tab",
  semicolon: ";",
  comma: ",",
  arrowUp: "ArrowUp",
  arrowDown: "ArrowDown"
}, bt = {
  "action-menu": "lc-ActionMenu-module__action-menu___tmkcK",
  "action-menu__trigger-button": "lc-ActionMenu-module__action-menu__trigger-button___fTjxP",
  "action-menu__list": "lc-ActionMenu-module__action-menu__list___sEn6L",
  "action-menu__list__group-header": "lc-ActionMenu-module__action-menu__list__group-header___TWiz0",
  "action-menu__list__item": "lc-ActionMenu-module__action-menu__list__item___PhQbO",
  "action-menu__list__item--with-divider": "lc-ActionMenu-module__action-menu__list__item--with-divider___KF1dE",
  "action-menu__list__item--disabled": "lc-ActionMenu-module__action-menu__list__item--disabled___VfZx3",
  "action-menu__list__item--selected": "lc-ActionMenu-module__action-menu__list__item--selected___aT2Ab",
  "action-menu__list__item__icon": "lc-ActionMenu-module__action-menu__list__item__icon___f3k8k",
  "action-menu__list--with-footer": "lc-ActionMenu-module__action-menu__list--with-footer___21-ar",
  "action-menu__footer": "lc-ActionMenu-module__action-menu__footer___pb-RE"
}, vt = "action-menu", Er = ({
  className: e,
  triggerClassName: a,
  options: o,
  triggerRenderer: r,
  placement: _ = "bottom-end",
  openedOnInit: l = !1,
  keepOpenOnClick: i,
  flipOptions: n,
  visible: d,
  onClose: u,
  onOpen: s,
  floatingStrategy: m,
  selectedOptions: h,
  footer: y,
  ...p
}) => {
  const k = d !== void 0, [x, C] = b.useState(l), [S, N] = b.useState(null), $ = b.useRef(-1), w = Oo(), f = Ja(), v = b.useRef(null), E = k ? d : x, D = () => {
    E ? (u?.(), !k && C(!1)) : (s?.(), !k && C(!0));
  }, { x: B, y: M, strategy: I, refs: P, context: A } = Qa({
    nodeId: f,
    middleware: [
      to(4),
      Po(n),
      b_({
        apply({ availableHeight: G }) {
          Fl(() => N(G));
        }
      })
    ],
    placement: _,
    open: E,
    strategy: m,
    onOpenChange: D,
    whileElementsMounted: eo
  }), F = ao(A), R = oo(A, {
    enabled: E
  }), U = ro(A), { getReferenceProps: ge, getFloatingProps: oe } = _o([
    F,
    R,
    U
  ]), { styles: se } = Mo(A, {
    initial: ({ side: G }) => ({
      opacity: 0,
      ...G === "bottom" && {
        marginTop: -10
      } || G === "top" && {
        marginTop: 10
      } || G === "left" && {
        marginLeft: 10
      } || G === "right" && {
        marginLeft: -10
      }
    })
  }), Q = (G) => {
    const fe = $.current;
    let be = fe + G;
    for (; o[be]?.disabled || o[be]?.groupHeader; )
      if (be += G, be === -1) {
        be = fe;
        break;
      }
    return be;
  }, K = (G) => {
    $.current = Q(G);
    const fe = v.current?.children;
    return (fe && fe[$.current]?.children[0])?.focus();
  }, he = (G) => {
    G.key === ie.arrowUp && $.current > 0 && (G.preventDefault(), K(-1)), G.key === ie.arrowDown && $.current + 1 < o.length && (G.preventDefault(), K(1));
  };
  b.useEffect(() => {
    if (E)
      return document.addEventListener("keydown", he), () => document.removeEventListener("keydown", he);
    $.current = -1;
  }, [E, he]);
  const Ve = (G, fe) => {
    $.current = G, fe?.(), !k && !i && (C(!1), u?.());
  }, We = (G, fe) => G.groupHeader ? /* @__PURE__ */ t(
    "li",
    {
      role: "none",
      className: bt[`${vt}__list__group-header`],
      children: G.element
    },
    G.key
  ) : /* @__PURE__ */ t("li", { role: "none", children: /* @__PURE__ */ g(
    "button",
    {
      "data-testid": G.key,
      tabIndex: -1,
      disabled: G.disabled,
      onClick: () => Ve(fe, G.onClick),
      role: "menuitem",
      className: c(bt[`${vt}__list__item`], {
        [bt[`${vt}__list__item--disabled`]]: G.disabled,
        [bt[`${vt}__list__item--with-divider`]]: G.withDivider,
        [bt[`${vt}__list__item--selected`]]: h?.includes(G.key)
      }),
      children: [
        G.element,
        h?.includes(G.key) && /* @__PURE__ */ t(
          "div",
          {
            "data-testid": `${G.key}-selected-icon`,
            className: bt[`${vt}__list__item__icon`],
            children: /* @__PURE__ */ t(O, { source: fa, kind: "action-primary" })
          }
        )
      ]
    },
    G.key
  ) }, G.key), it = /* @__PURE__ */ g(W, { children: [
    /* @__PURE__ */ t(
      "div",
      {
        "aria-label": "Toggle menu",
        "data-testid": "action-menu-trigger-button",
        ref: P.setReference,
        ...ge(),
        className: a,
        children: r
      }
    ),
    /* @__PURE__ */ t(ba, { id: f, children: E && /* @__PURE__ */ g(
      "div",
      {
        ref: P.setFloating,
        className: bt[vt],
        style: {
          position: I,
          top: M ?? "",
          left: B ?? "",
          ...!!S && { maxHeight: S },
          ...se
        },
        ...oe(),
        children: [
          o.length > 0 && /* @__PURE__ */ t(
            "ul",
            {
              ...p,
              className: c(
                bt[`${vt}__list`],
                {
                  [bt[`${vt}__list--with-footer`]]: y
                },
                e
              ),
              role: "menu",
              ref: v,
              children: o.map(We)
            }
          ),
          y && /* @__PURE__ */ t(
            T,
            {
              size: "sm",
              as: "div",
              className: bt[`${vt}__footer`],
              children: y
            }
          )
        ]
      }
    ) })
  ] });
  return w === null ? /* @__PURE__ */ t(Ro, { children: it }) : it;
}, fi = "lc-Loader-module__loader___Ukoov", bi = "lc-Loader-module__loader__spinner___cp5N7", vi = "lc-Loader-module__rotate___p-j1x", yi = "lc-Loader-module__loader__label___CF5-C", Ca = {
  loader: fi,
  loader__spinner: bi,
  "loader__spinner--small": "lc-Loader-module__loader__spinner--small___9XXkz",
  "loader__spinner--medium": "lc-Loader-module__loader__spinner--medium___oTzt2",
  "loader__spinner--large": "lc-Loader-module__loader__spinner--large___vDCTc",
  "loader__spinner-circle": "lc-Loader-module__loader__spinner-circle___LyuTm",
  rotate: vi,
  loader__label: yi
}, x_ = "loader", zr = `${x_}__spinner`, Tr = ({
  primaryColor: e,
  secondaryColor: a,
  label: o,
  className: r,
  size: _ = "medium",
  ...l
}) => /* @__PURE__ */ g("div", { className: c(Ca[x_], r), ...l, children: [
  /* @__PURE__ */ t(
    "div",
    {
      className: c(Ca[zr], Ca[`${zr}--${_}`]),
      children: /* @__PURE__ */ t(
        "div",
        {
          role: "status",
          className: Ca["loader__spinner-circle"],
          style: {
            /* stylelint-disable */
            borderColor: a,
            borderTopColor: e
          }
        }
      )
    }
  ),
  o && /* @__PURE__ */ t(T, { as: "div", size: "md", className: Ca.loader__label, children: o })
] }), ki = (e) => {
  if (e === "primary" || e === "destructive")
    return {
      primaryColor: "var(--action-primary-default)",
      secondaryColor: "var(--border-invert-primary)"
    };
  if (e === "link-inverted")
    return {
      primaryColor: "var(--content-invert-primary)",
      secondaryColor: "var(--surface-invert-secondary)"
    };
}, Vr = (e, a, o) => {
  a(), o?.(e);
}, Ci = (e, a, o) => {
  a(), o?.(e);
}, wi = (e, a) => {
  const o = e?.offsetWidth;
  o && a(o);
}, $i = "lc-Button-module__btn___daEdK", Si = "lc-Button-module__btn__loader___L9GCi", Ni = "lc-Button-module__btn__icon___-CG5y", xi = "lc-Button-module__btn__content___rMx0W", ve = {
  btn: $i,
  "btn--disabled": "lc-Button-module__btn--disabled___ATZwt",
  "btn--full-width": "lc-Button-module__btn--full-width___ViUNm",
  "btn--xcompact": "lc-Button-module__btn--xcompact___0AZjf",
  "btn--with-left-icon": "lc-Button-module__btn--with-left-icon___32jlN",
  "btn--with-right-icon": "lc-Button-module__btn--with-right-icon___MnSZq",
  "btn--compact": "lc-Button-module__btn--compact___230yl",
  "btn--medium": "lc-Button-module__btn--medium___7lzYn",
  "btn--large": "lc-Button-module__btn--large___D38zo",
  "btn--basic": "lc-Button-module__btn--basic___r7FM2",
  "btn--primary": "lc-Button-module__btn--primary___RKxUy",
  "btn--secondary": "lc-Button-module__btn--secondary___-lgbN",
  "btn--destructive": "lc-Button-module__btn--destructive___frCNL",
  "btn--destructive-outline": "lc-Button-module__btn--destructive-outline___3Q-D2",
  "btn--text": "lc-Button-module__btn--text___lb44N",
  "btn--link": "lc-Button-module__btn--link___Q-xHu",
  "btn--link-light": "lc-Button-module__btn--link-light___s-d01",
  "btn--link-inverted": "lc-Button-module__btn--link-inverted___xOUjH",
  "btn--plain": "lc-Button-module__btn--plain___BOFMA",
  "btn--float": "lc-Button-module__btn--float___3O7kc",
  "btn--dotted": "lc-Button-module__btn--dotted___kFW2N",
  "btn--high-contrast": "lc-Button-module__btn--high-contrast___IZkuG",
  "btn--loading": "lc-Button-module__btn--loading___kGPe4",
  btn__loader: Si,
  btn__icon: Ni,
  "btn__icon--left": "lc-Button-module__btn__icon--left___Xke3Q",
  "btn__icon--right": "lc-Button-module__btn__icon--right___c-N-B",
  "btn__icon--small": "lc-Button-module__btn__icon--small___2gmZG",
  "btn--icon-only": "lc-Button-module__btn--icon-only___7J-XP",
  "btn--icon-only--bg": "lc-Button-module__btn--icon-only--bg___Kn-y-",
  "btn--plain-lock-black": "lc-Button-module__btn--plain-lock-black___EsXu7",
  "btn--text-lock-black": "lc-Button-module__btn--text-lock-black___r4V6e",
  "btn--animated-label": "lc-Button-module__btn--animated-label___8uZTa",
  btn__content: xi,
  "btn--animated-label--expanded": "lc-Button-module__btn--animated-label--expanded___dTfmD"
}, ye = "btn", L = b.forwardRef(
  ({
    loading: e = !1,
    disabled: a = !1,
    type: o = "button",
    fullWidth: r = !1,
    kind: _ = "secondary",
    size: l = "medium",
    icon: i = null,
    iconPosition: n = "left",
    loaderLabel: d,
    className: u,
    children: s,
    href: m,
    onClick: h,
    animatedLabel: y,
    ...p
  }, k) => {
    const [x, C] = b.useState(0), [S, N] = b.useState(!1), $ = e || a, w = !s && i, f = y && s && i, v = ["text", "link", "link-light"].includes(_), E = m ? "a" : "button", D = c(
      ve[ye],
      ve[`${ye}--${_}`],
      ve[`${ye}--${l}`],
      {
        [ve[`${ye}--loading`]]: e,
        [ve[`${ye}--full-width`]]: r,
        [ve[`${ye}--with-${n}-icon`]]: i && !w && !v,
        [ve[`${ye}--icon-only`]]: w,
        [ve[`${ye}--icon-only--bg`]]: w && v,
        [ve[`${ye}--disabled`]]: $,
        [ve[`${ye}--animated-label`]]: f,
        [ve[`${ye}--animated-label--expanded`]]: f && S
      },
      u
    );
    return /* @__PURE__ */ g(
      E,
      {
        ref: k,
        className: D,
        "aria-disabled": $,
        type: o,
        disabled: $,
        ...!$ && { href: m, onClick: h },
        ...p,
        ...f && {
          onMouseEnter: (B) => Vr(
            B,
            () => N(!0),
            p?.onMouseEnter
          ),
          onMouseLeave: (B) => Vr(
            B,
            () => N(!1),
            p?.onMouseLeave
          ),
          onBlur: (B) => Ci(
            B,
            () => N(!1),
            p?.onBlur
          ),
          onKeyUp: (B) => {
            (B.key === "Enter" || B.key === " ") && N(!0), B.key === "Escape" && N(!1), p?.onKeyUp?.(B);
          }
        },
        children: [
          e && /* @__PURE__ */ t(
            Tr,
            {
              "data-testid": "button-loader",
              size: "small",
              label: d,
              className: ve[`${ye}__loader`],
              ...ki(_)
            }
          ),
          i && b.cloneElement(i, {
            className: c(
              // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
              i.props.className,
              ve[`${ye}__icon`],
              ve[`${ye}__icon--${n}`],
              {
                [ve[`${ye}__icon--small`]]: l === "xcompact"
              }
            ),
            disabled: a,
            size: l === "xcompact" ? "small" : "medium"
          }),
          /* @__PURE__ */ t(
            "div",
            {
              className: ve[`${ye}__content`],
              style: f ? { maxWidth: S ? x : 0 } : void 0,
              children: f ? /* @__PURE__ */ t("span", { ref: (B) => wi(B, C), children: s }) : s
            }
          )
        ]
      }
    );
  }
), wa = {
  "list-item": "lc-ListItem-module__list-item___22kWE",
  "list-item__left-node": "lc-ListItem-module__list-item__left-node___EIetr",
  "list-item__right-node": "lc-ListItem-module__list-item__right-node___An9i9",
  "list-item__label": "lc-ListItem-module__list-item__label___E8L87",
  "list-item--warning": "lc-ListItem-module__list-item--warning___-yfsq"
}, $a = "list-item", Xa = ({
  leftNode: e,
  rightNode: a,
  children: o,
  kind: r
}) => /* @__PURE__ */ g(
  "div",
  {
    className: c(wa[$a], {
      [wa[`${$a}--warning`]]: r === "warning"
    }),
    children: [
      e && /* @__PURE__ */ t("div", { className: wa[`${$a}__left-node`], children: e }),
      /* @__PURE__ */ t(T, { as: "div", className: wa[`${$a}__label`], children: o }),
      a && /* @__PURE__ */ t("div", { className: wa[`${$a}__right-node`], children: a })
    ]
  }
), Jd = (e) => (q(() => {
  console.warn("`ActionMenuItem` is deprecated. Use `ListItem` instead.");
}, []), /* @__PURE__ */ t(Xa, { ...e }));
function E_(e) {
  switch (e) {
    case "invert":
      return "inverted";
    case "important":
      return "lock-black";
    default:
      return "primary";
  }
}
function Ei(e, a, o, r) {
  if (o)
    return {
      top: e ? o + e : o
    };
  if (r)
    return {
      left: a ? r + a : r
    };
}
const Ti = (e) => {
  switch (e) {
    case "invert":
      return {
        stroke: "var(--tooltip-background-invert)",
        fill: "var(--tooltip-background-invert)"
      };
    case "important":
      return {
        stroke: "var(--surface-accent-emphasis-high-warning)",
        fill: "var(--surface-accent-emphasis-high-warning)"
      };
    default:
      return {
        stroke: "var(--tooltip-border-for-svg)",
        fill: "var(--tooltip-background-basic)"
      };
  }
}, Bi = "lc-Tooltip-module__tooltip___LjRUX", Ii = "lc-Tooltip-module__tooltip__content___cxaIe", Ai = "lc-Tooltip-module__tooltip__arrow___vLFFP", Di = "lc-Tooltip-module__tooltip__interactive___WTll9", V = {
  tooltip: Bi,
  tooltip__content: Ii,
  "tooltip--invert": "lc-Tooltip-module__tooltip--invert___J4i3t",
  tooltip__arrow: Ai,
  "tooltip--important": "lc-Tooltip-module__tooltip--important___7KDXC",
  tooltip__interactive: Di,
  "tooltip__user-guide-step": "lc-Tooltip-module__tooltip__user-guide-step___zwAvq",
  "tooltip--full-space": "lc-Tooltip-module__tooltip--full-space___YXy-C",
  "tooltip-header": "lc-Tooltip-module__tooltip-header___gnWkw",
  "tooltip-header--info": "lc-Tooltip-module__tooltip-header--info___VLXJo",
  "tooltip-media-container": "lc-Tooltip-module__tooltip-media-container___82zyJ",
  "tooltip-media": "lc-Tooltip-module__tooltip-media___F81U-",
  "tooltip-text--info": "lc-Tooltip-module__tooltip-text--info___eFPj0",
  "tooltip-close": "lc-Tooltip-module__tooltip-close___3t8it",
  "tooltip-step": "lc-Tooltip-module__tooltip-step___WnQFV",
  "tooltip-footer": "lc-Tooltip-module__tooltip-footer___Ila6T",
  "tooltip-footer--interactive": "lc-Tooltip-module__tooltip-footer--interactive___8WwVX",
  "tooltip-footer--user-guide-step": "lc-Tooltip-module__tooltip-footer--user-guide-step___hIsO4",
  "guide-tooltip": "lc-Tooltip-module__guide-tooltip___lBG0P",
  "guide-tooltip--slide": "lc-Tooltip-module__guide-tooltip--slide___XuCdK",
  "guide-tooltip__overlay": "lc-Tooltip-module__guide-tooltip__overlay___BAueg",
  "guide-tooltip__overlay--slide": "lc-Tooltip-module__guide-tooltip__overlay--slide___uYqoN",
  "guide-tooltip__overlay--visible": "lc-Tooltip-module__guide-tooltip__overlay--visible___Tk1Yr",
  "reports-tooltip": "lc-Tooltip-module__reports-tooltip___g6vxb",
  "reports-tooltip__heading": "lc-Tooltip-module__reports-tooltip__heading___TxORk",
  "reports-tooltip__heading__title": "lc-Tooltip-module__reports-tooltip__heading__title___0foO-",
  "reports-tooltip__heading__description": "lc-Tooltip-module__reports-tooltip__heading__description___E6Gb3",
  "reports-tooltip__content": "lc-Tooltip-module__reports-tooltip__content___yfOcf"
}, co = "tooltip", Yt = ({
  children: e,
  className: a,
  triggerClassName: o,
  triggerRenderer: r,
  theme: _,
  kind: l,
  placement: i = "bottom",
  isVisible: n,
  fullSpaceContent: d,
  onClose: u,
  onOpen: s,
  withFadeAnimation: m = !0,
  transitionDuration: h = 200,
  hoverOnDuration: y,
  hoverOffDuration: p,
  transitionDelay: k = 0,
  hoverOnDelay: x,
  hoverOffDelay: C,
  triggerOnClick: S = !1,
  triggerOnHover: N = !0,
  offsetMainAxis: $ = 8,
  offsetCrossAxis: w = 0,
  referenceElement: f,
  activationThreshold: v = 0,
  useDismissHookProps: E,
  useClickHookProps: D,
  hoverOutDelayTimeout: B = 100,
  arrowOffsetY: M,
  arrowOffsetX: I,
  closeOnTriggerBlur: P = !1,
  floatingStrategy: A,
  portal: F,
  portalProps: R,
  hideWhenReferenceHidden: U = !1
}) => {
  const ge = n !== void 0, [oe, se] = b.useState(!1), Q = b.useRef(null), K = ge ? n : oe, he = l || _, Ve = Oo(), We = Ja(), it = c(
    V[co],
    a,
    he && V[`${co}--${he}`],
    d && V[`${co}--full-space`]
  ), G = typeof r == "function", fe = (Zt) => {
    Zt !== K && (Zt ? s?.() : u?.(), !ge && se(Zt));
  }, be = (Zt) => m ? Zt ?? h : 0, _a = (Zt) => Zt ?? k, {
    floatingStyles: la,
    refs: Bt,
    context: z,
    middlewareData: { arrow: { x: Ht, y: Uo } = {}, hide: Lo }
  } = Qa({
    nodeId: We,
    middleware: [
      to({ mainAxis: $, crossAxis: w }),
      Sr(),
      Po(),
      El({ element: Q, padding: 8 }),
      U ? Tl() : void 0
    ],
    placement: i,
    open: K,
    strategy: A,
    onOpenChange: fe,
    whileElementsMounted: eo
  }), qo = Bl(z, {
    move: !1,
    restMs: v,
    delay: {
      open: _a(x),
      close: _a(C || B)
    },
    enabled: N,
    handleClose: P ? null : Il()
  }), Ho = Al(z), zo = oo(z, E), Vo = ro(z, { role: "tooltip" }), Wo = ao(z, {
    enabled: S,
    ...D
  }), { isMounted: Ko, styles: Yo } = Mo(z, {
    duration: {
      open: be(y),
      close: be(p)
    }
  }), { status: Xo } = Dl(z), { getReferenceProps: Zo, getFloatingProps: jo } = _o([
    qo,
    Ho,
    zo,
    Vo,
    Wo
  ]);
  b.useEffect(() => {
    f && Bt.setReference(f);
  }, [Bt.setReference, f]);
  const ft = /* @__PURE__ */ t(ba, { id: We, children: Ko && /* @__PURE__ */ g(
    "div",
    {
      ref: Bt.setFloating,
      style: {
        ...la,
        ...Yo,
        visibility: Lo?.referenceHidden ? "hidden" : "visible"
      },
      className: it,
      ...jo(),
      "data-status": Xo,
      children: [
        /* @__PURE__ */ t(T, { as: "div", className: V[`${co}__content`], children: e }),
        /* @__PURE__ */ t(
          Ol,
          {
            ref: Q,
            context: z,
            strokeWidth: 1,
            width: 10,
            height: 5,
            style: {
              ...Ei(
                M,
                I,
                Uo,
                Ht
              )
            },
            ...Ti(he)
          }
        )
      ]
    }
  ) }), lo = () => Ve === null ? /* @__PURE__ */ t(Ro, { children: F ? /* @__PURE__ */ t(ha, { ...R, children: ft }) : ft }) : F ? /* @__PURE__ */ t(ha, { ...R, children: ft }) : ft;
  return /* @__PURE__ */ g(W, { children: [
    /* @__PURE__ */ t(
      "div",
      {
        "data-testid": "tooltip-trigger",
        ref: Bt.setReference,
        ...Zo(),
        className: o,
        children: G ? r() : r
      }
    ),
    lo()
  ] });
}, Qd = ({ text: e }) => /* @__PURE__ */ t("div", { children: e }), Sa = "tooltip", eu = ({
  className: e,
  header: a,
  text: o,
  closeWithX: r,
  theme: _,
  handleCloseAction: l
}) => /* @__PURE__ */ g("div", { className: e, children: [
  (r || l) && /* @__PURE__ */ t(
    "button",
    {
      type: "button",
      "aria-label": "Close tooltip",
      className: V[`${Sa}-close`],
      onClick: l,
      children: /* @__PURE__ */ t(O, { source: lt, kind: _ ? E_(_) : "primary" })
    }
  ),
  a && /* @__PURE__ */ t(
    ce,
    {
      as: "div",
      size: "xs",
      className: c(V[`${Sa}-header`], {
        [V[`${Sa}-header--info`]]: r
      }),
      children: a
    }
  ),
  /* @__PURE__ */ t(
    T,
    {
      as: "div",
      className: c({
        [V[`${Sa}-text`]]: r,
        [V[`${Sa}-text--info`]]: r
      }),
      children: o
    }
  )
] }), yt = "tooltip", Oi = ({
  header: e,
  text: a,
  image: o,
  video: r,
  closeWithX: _,
  theme: l,
  handleCloseAction: i,
  primaryButton: n,
  secondaryButton: d
}) => {
  const u = (h) => h === "invert" ? "secondary" : h === "important" ? "plain-lock-black" : "high-contrast", s = (h) => h === "invert" ? "link-inverted" : h === "important" ? "text-lock-black" : "text", m = (h, y = !0) => {
    if (!h) return null;
    if (b.isValidElement(h))
      return h;
    const p = h, k = y ? p.kind || u(l) : p.kind || s(l);
    return /* @__PURE__ */ t(
      L,
      {
        ...p,
        kind: k,
        onClick: p.handleClick,
        children: p.label
      }
    );
  };
  return /* @__PURE__ */ g("div", { className: V[`${yt}__interactive`], children: [
    (_ || i) && /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        "aria-label": "Close tooltip",
        className: V[`${yt}-close`],
        onClick: i,
        children: /* @__PURE__ */ t(O, { source: lt, kind: l ? E_(l) : "primary" })
      }
    ),
    o && /* @__PURE__ */ t("div", { className: V[`${yt}-media-container`], children: /* @__PURE__ */ t(
      "img",
      {
        className: V[`${yt}-media`],
        src: o.src,
        alt: o.alt
      }
    ) }),
    r && /* @__PURE__ */ t("div", { className: V[`${yt}-media-container`], children: /* @__PURE__ */ t(
      "video",
      {
        className: V[`${yt}-media`],
        autoPlay: !0,
        loop: !0,
        muted: !0,
        playsInline: !0,
        controls: !1,
        children: /* @__PURE__ */ t("source", { src: r })
      }
    ) }),
    e && /* @__PURE__ */ t(ce, { as: "div", size: "xs", className: V[`${yt}-header`], children: e }),
    /* @__PURE__ */ t("div", { className: V[`${yt}-text`], children: a }),
    /* @__PURE__ */ g(
      "div",
      {
        className: c(
          V[`${yt}-footer`],
          V[`${yt}-footer--interactive`]
        ),
        children: [
          m(n, !0),
          m(d, !1)
        ]
      }
    )
  ] });
}, Na = "reports-tooltip", tu = ({
  title: e,
  description: a,
  children: o
}) => /* @__PURE__ */ g("div", { className: V[Na], children: [
  /* @__PURE__ */ g("div", { className: V[`${Na}__heading`], children: [
    /* @__PURE__ */ t(T, { as: "div", className: V[`${Na}__heading__title`], children: e }),
    /* @__PURE__ */ t(
      T,
      {
        as: "div",
        size: "xs",
        className: V[`${Na}__heading__description`],
        children: a
      }
    )
  ] }),
  /* @__PURE__ */ t("div", { className: V[`${Na}__content`], children: /* @__PURE__ */ t(T, { as: "div", children: o }) })
] }), ae = {
  "action-bar": "lc-ActionBar-module__action-bar___yfLdO",
  "action-bar__items": "lc-ActionBar-module__action-bar__items___E8fX6",
  "action-bar__items--scroll": "lc-ActionBar-module__action-bar__items--scroll___izP27",
  "action-bar__items__button-wrapper": "lc-ActionBar-module__action-bar__items__button-wrapper___sgdUc",
  "action-bar__items__button-wrapper--active": "lc-ActionBar-module__action-bar__items__button-wrapper--active___TZteM",
  "action-bar__items__button-wrapper--hidden": "lc-ActionBar-module__action-bar__items__button-wrapper--hidden___43H6t",
  "action-bar__items__button-wrapper--vertical": "lc-ActionBar-module__action-bar__items__button-wrapper--vertical___8Aq0c",
  "action-bar__items__button-wrapper__button": "lc-ActionBar-module__action-bar__items__button-wrapper__button___r5jpx",
  "action-bar__items__button-wrapper__button--with-divider": "lc-ActionBar-module__action-bar__items__button-wrapper__button--with-divider___bTyao",
  "action-bar__items__button-wrapper__button--with-vertical-divider": "lc-ActionBar-module__action-bar__items__button-wrapper__button--with-vertical-divider___DkEFm",
  "action-bar__items__tooltip": "lc-ActionBar-module__action-bar__items__tooltip___BxN2p",
  "action-bar__menu-wrapper": "lc-ActionBar-module__action-bar__menu-wrapper___y26Bl",
  "action-bar__menu-wrapper--active": "lc-ActionBar-module__action-bar__menu-wrapper--active___E4iCs",
  "action-bar__menu-wrapper--vertical": "lc-ActionBar-module__action-bar__menu-wrapper--vertical___wU4tc",
  "action-bar__menu-wrapper__button": "lc-ActionBar-module__action-bar__menu-wrapper__button___0Nluq",
  "action-bar__menu-wrapper__button--active": "lc-ActionBar-module__action-bar__menu-wrapper__button--active___-NlsX",
  "action-bar__menu-wrapper__button__with-item": "lc-ActionBar-module__action-bar__menu-wrapper__button__with-item___Nvb-H",
  "fade-in": "lc-ActionBar-module__fade-in___NlmMy",
  "action-bar__menu-wrapper__button__icon": "lc-ActionBar-module__action-bar__menu-wrapper__button__icon___dFIfe",
  "action-bar__menu-wrapper__button__icon--open": "lc-ActionBar-module__action-bar__menu-wrapper__button__icon--open___shQMz",
  "action-bar__menu-wrapper__trigger-vertical": "lc-ActionBar-module__action-bar__menu-wrapper__trigger-vertical___yaJyY",
  "action-bar--vertical": "lc-ActionBar-module__action-bar--vertical___9uO-q",
  "action-bar__items--with-menu": "lc-ActionBar-module__action-bar__items--with-menu___OfqL0",
  "action-bar__items__button": "lc-ActionBar-module__action-bar__items__button___N1Qtp",
  "action-bar__items__button--active": "lc-ActionBar-module__action-bar__items__button--active___adIVs"
}, T_ = "action-bar__items", ia = `${T_}__button-wrapper`, Pi = ({
  option: e,
  isActive: a,
  vertical: o
}) => {
  const r = c(ae[ia], {
    [ae[`${ia}--active`]]: a,
    [ae[`${ia}--vertical`]]: o
  }), _ = /* @__PURE__ */ t(
    L,
    {
      id: e.key,
      title: e?.showTooltip ? void 0 : e.label,
      kind: "plain",
      onClick: e.onClick,
      icon: e.element,
      className: c(ae[`${ia}__button`], {
        [ae[`${ia}__button--with-vertical-divider`]]: o && e.withDivider,
        [ae[`${ia}__button--with-divider`]]: !o && e.withDivider
      })
    },
    e.key
  );
  return e.showTooltip ? /* @__PURE__ */ t(
    "div",
    {
      "data-testid": e.key,
      className: r,
      children: /* @__PURE__ */ t(
        Yt,
        {
          kind: "invert",
          placement: o ? "left" : "bottom",
          triggerClassName: ae[`${T_}__tooltip`],
          triggerRenderer: () => _,
          floatingStrategy: "fixed",
          useClickHookProps: {
            ignoreMouse: !0
          },
          hoverOnDelay: 800,
          hoverOffDelay: 0,
          children: /* @__PURE__ */ t("div", { children: e.label })
        }
      )
    },
    e.key
  ) : /* @__PURE__ */ t("div", { "data-testid": e.key, className: r, children: _ });
}, so = "action-bar", It = "action-bar__menu-wrapper", Mi = 44, au = ({
  className: e,
  id: a = "action-bar-area",
  type: o = "menu",
  options: r,
  activeOptionKey: _,
  vertical: l,
  menuFooter: i
}) => {
  const [n, d] = b.useState(
    r.length
  ), [u, s] = b.useState([]), [m, h] = b.useState(!1), y = o === "scroll", p = c(
    ae[so],
    e,
    l && ae[`${so}--vertical`]
  ), k = !y && u.length !== 0;
  b.useEffect(() => {
    y || (r.length > n ? s(r.slice(n, r.length)) : s([]));
  }, [r, n]), b.useEffect(() => {
    const S = !!window.ResizeObserver;
    if (!y && S) {
      const N = new ResizeObserver(($) => {
        const { width: w, height: f } = $[0].contentRect, v = l ? f : w, E = u.length > 0 ? 60 : 0, D = Math.floor(
          (v - E) / Mi
        );
        D >= 0 && D !== n && d(D);
      });
      return N.observe(document.querySelector(`#${a}`)), () => N.disconnect();
    }
  }, [u, y, n]);
  const x = b.useCallback(() => u.reduce(
    (S, N) => {
      if (!N.hideInMenu) {
        const $ = {
          key: N.key,
          element: /* @__PURE__ */ t(Xa, { leftNode: N.element, children: N.label }),
          withDivider: N.withDivider,
          onClick: N.onClick
        };
        S.push($);
      }
      return S;
    },
    []
  ), [u]), C = u.find((S) => S.key === _);
  return /* @__PURE__ */ g("div", { id: a, className: p, children: [
    /* @__PURE__ */ t(
      "div",
      {
        className: c(ae[`${so}__items`], {
          [ae[`${so}__items--scroll`]]: y
        }),
        children: r.slice(0, n).map((S) => /* @__PURE__ */ t(
          Pi,
          {
            option: S,
            isActive: S.key === _,
            vertical: l
          }
        ))
      }
    ),
    k && /* @__PURE__ */ t(
      "div",
      {
        className: c(
          ae[It],
          C && ae[`${It}--active`],
          l && ae[`${It}--vertical`]
        ),
        children: /* @__PURE__ */ t(
          Er,
          {
            selectedOptions: _ ? [_] : [],
            onOpen: () => h(!0),
            onClose: () => h(!1),
            floatingStrategy: "fixed",
            placement: l ? "left-start" : "bottom-end",
            options: x(),
            triggerClassName: c(
              l && ae[`${It}__trigger-vertical`]
            ),
            triggerRenderer: /* @__PURE__ */ t(
              L,
              {
                id: `${a}-menu-button`,
                className: c(
                  ae[`${It}__button`],
                  C && ae[`${It}__button--active`]
                ),
                kind: "plain",
                icon: /* @__PURE__ */ t(
                  O,
                  {
                    source: Xt,
                    kind: "primary",
                    className: c(
                      ae[`${It}__button__icon`],
                      m && ae[`${It}__button__icon--open`]
                    )
                  }
                ),
                iconPosition: "right",
                children: C && /* @__PURE__ */ t(
                  "div",
                  {
                    className: c(
                      ae[`${It}__button__with-item`]
                    ),
                    children: C.element
                  }
                )
              }
            ),
            footer: i
          }
        )
      }
    )
  ] });
}, Ri = "lc-ActionCard-module__loading___biGIO", At = {
  "visually-hidden": "lc-ActionCard-module__visually-hidden___hE6De",
  "main-wrapper": "lc-ActionCard-module__main-wrapper___-LUjH",
  "action-card--loading": "lc-ActionCard-module__action-card--loading___Ql9-s",
  "action-card": "lc-ActionCard-module__action-card___gPaoW",
  "action-card--loading--animated": "lc-ActionCard-module__action-card--loading--animated___lpz9i",
  loading: Ri,
  "action-card__column": "lc-ActionCard-module__action-card__column___KgMRx",
  "action-card__column--first": "lc-ActionCard-module__action-card__column--first___BWQwi",
  "action-card__column--second": "lc-ActionCard-module__action-card__column--second___-X-gO"
}, Dt = "action-card", ou = ({
  className: e,
  children: a,
  secondColumn: o,
  firstColumnClassName: r,
  secondColumnClassName: _,
  onClick: l,
  isLoading: i = !1,
  isLoadingAnimated: n = !1
}) => {
  const d = c(At[Dt], e), u = c(At["main-wrapper"], {
    [At[`${Dt}--loading`]]: i,
    [At[`${Dt}--loading--animated`]]: n
  }), s = (h) => {
    i || h.currentTarget === document.activeElement && l?.();
  }, m = (h) => {
    i || h.currentTarget === document.activeElement && (h.key === "Enter" || h.key === " " || h.key === "Spacebar" || h.key === "Space") && (h.preventDefault(), l?.());
  };
  return /* @__PURE__ */ g("div", { className: u, children: [
    /* @__PURE__ */ t("div", { "aria-live": "polite", className: At["visually-hidden"], children: i ? "Loading content" : null }),
    /* @__PURE__ */ t(
      "div",
      {
        role: i ? "presentation" : "button",
        "aria-label": "Action Card",
        "aria-busy": i,
        tabIndex: i ? -1 : 0,
        className: d,
        onClick: s,
        onKeyDown: m,
        children: !i && /* @__PURE__ */ g(W, { children: [
          /* @__PURE__ */ t(
            "div",
            {
              "data-testid": `${Dt}-first-column`,
              className: c(
                At[`${Dt}__column`],
                At[`${Dt}__column--first`],
                r
              ),
              children: a
            }
          ),
          o && /* @__PURE__ */ t(
            "div",
            {
              "data-testid": `${Dt}-second-column`,
              className: c(
                At[`${Dt}__column`],
                At[`${Dt}__column--second`],
                _
              ),
              children: o
            }
          )
        ] })
      }
    )
  ] });
}, Fi = 8, Gi = 100, kr = ({
  text: e,
  typingAnimation: a = !0,
  typingDelay: o = Gi,
  typingSpeed: r = Fi,
  onTypingEnd: _
}) => {
  const [l, i] = le(""), n = qt(0);
  return q(() => {
    if (!e) return;
    if (!a && _)
      return _();
    const u = setTimeout(() => {
      const s = setInterval(() => {
        const m = n.current;
        m < e.length ? (i((h) => h + e[m]), n.current = m + 1) : (clearInterval(s), _?.());
      }, r);
    }, o);
    return () => {
      clearTimeout(u);
    };
  }, [e, a]), /* @__PURE__ */ t(W, { children: a ? l : e });
}, Ui = "lc-Alert-module__alert___zP4AL", Li = "lc-Alert-module__alert__icon___1SDHT", qi = "lc-Alert-module__alert__content___wwP8E", Hi = "lc-Alert-module__alert__content__wrapper___gw9Mg", zi = "lc-Alert-module__alert__content__wrapper__text___2x5d-", Vi = "lc-Alert-module__alert__content__wrapper__cta___ocxGq", Wi = "lc-Alert-module__alert__content__wrapper__cta__link___ZqOjp", Ke = {
  alert: Ui,
  alert__icon: Li,
  alert__content: qi,
  alert__content__wrapper: Hi,
  alert__content__wrapper__text: zi,
  alert__content__wrapper__cta: Vi,
  alert__content__wrapper__cta__link: Wi,
  "alert__close-icon": "lc-Alert-module__alert__close-icon___jbDQJ",
  "alert--small": "lc-Alert-module__alert--small___GsHEV",
  "alert--medium": "lc-Alert-module__alert--medium___5PGR3",
  "alert--large": "lc-Alert-module__alert--large___068A5",
  "alert--info": "lc-Alert-module__alert--info___GLCTZ",
  "alert--warning": "lc-Alert-module__alert--warning___y0-zK",
  "alert--success": "lc-Alert-module__alert--success___RXWVi",
  "alert--error": "lc-Alert-module__alert--error___EK-vJ"
}, Ki = {
  info: {
    source: Eo,
    kind: "link"
  },
  warning: {
    source: g_,
    kind: "warning"
  },
  success: {
    source: $r,
    kind: "success"
  },
  error: {
    source: p_,
    kind: "error"
  }
}, Ye = "alert", ru = ({
  children: e,
  className: a,
  primaryButton: o,
  secondaryButton: r,
  kind: _ = "info",
  onClose: l,
  ...i
}) => {
  const n = b.useRef(null), [d, u] = b.useState(null), s = c(
    Ke[Ye],
    Ke[`${Ye}--${_}`],
    d === "large" && Ke[`${Ye}--large`],
    d === "medium" && Ke[`${Ye}--medium`],
    d === "small" && Ke[`${Ye}--small`],
    a
  );
  return b.useEffect(() => {
    const m = () => n.current && n.current.offsetWidth <= 400 ? u("small") : n.current && n.current.offsetWidth > 400 && n.current.offsetWidth <= 800 ? u("medium") : u("large"), h = m_(() => {
      m();
    }, 500);
    return window.addEventListener("resize", h), m(), () => window.removeEventListener("resize", h);
  }), /* @__PURE__ */ g("div", { ref: n, className: s, ...i, children: [
    /* @__PURE__ */ g("div", { className: Ke[`${Ye}__content`], children: [
      /* @__PURE__ */ g("div", { className: Ke[`${Ye}__content__wrapper`], children: [
        /* @__PURE__ */ t(
          O,
          {
            ...Ki[_],
            size: "large",
            className: Ke[`${Ye}__icon`]
          }
        ),
        /* @__PURE__ */ t(
          T,
          {
            as: "div",
            className: Ke[`${Ye}__content__wrapper__text`],
            children: e
          }
        )
      ] }),
      (o || r) && /* @__PURE__ */ g("div", { className: Ke[`${Ye}__content__wrapper__cta`], children: [
        o && /* @__PURE__ */ t(
          L,
          {
            kind: "high-contrast",
            onClick: o.handleClick,
            ...o,
            children: o.label
          }
        ),
        r && /* @__PURE__ */ t(
          L,
          {
            className: c(
              Ke[`${Ye}__content__wrapper__cta__link`],
              r.className
            ),
            kind: "text",
            onClick: r.handleClick,
            ...r,
            children: r.label
          }
        )
      ] })
    ] }),
    l && /* @__PURE__ */ t(
      L,
      {
        "aria-label": "Close alert",
        className: Ke[`${Ye}__close-icon`],
        size: "compact",
        kind: "plain",
        icon: /* @__PURE__ */ t(O, { source: lt }),
        onClick: l
      }
    )
  ] });
}, Yi = 705, Xi = 751, Xe = {
  "app-frame": "lc-AppFrame-module__app-frame___LeOAC",
  "app-frame__page-content-container": "lc-AppFrame-module__app-frame__page-content-container___XhCPO",
  "app-frame__page-content-container--mobile": "lc-AppFrame-module__app-frame__page-content-container--mobile___2HnOq",
  "app-frame__page-content-container__top-bar": "lc-AppFrame-module__app-frame__page-content-container__top-bar___cl5Ek",
  "app-frame__page-content-container__top-bar--visible": "lc-AppFrame-module__app-frame__page-content-container__top-bar--visible___ZfcRZ",
  "app-frame__page-content-container__content-wrapper": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper___V0yIo",
  "app-frame__page-content-container__content-wrapper--mobile": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper--mobile___iUDnN",
  "app-frame__page-content-container__content-wrapper__nav-bar-wrapper": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper__nav-bar-wrapper___eAkwB",
  "app-frame__page-content-container__content-wrapper__nav-bar-wrapper--open": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper__nav-bar-wrapper--open___-rAxE",
  "app-frame__page-content-container__content-wrapper__content": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper__content___zHmoo",
  "app-frame__page-content-container__content-wrapper__content--mobile": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper__content--mobile___HKy-9",
  "app-frame__page-content-container__content-wrapper__mobile-top-bar": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper__mobile-top-bar___JeGo3"
}, B_ = "app-frame", nt = `${B_}__page-content-container`, Zi = (e) => {
  const {
    children: a,
    className: o,
    navigation: r,
    mobileNavigation: _,
    sideNavigation: l,
    topBar: i,
    topBarClassName: n,
    sideNavigationContainerClassName: d,
    contentClassName: u
  } = e, s = c(Xe[B_], o), {
    isSideNavigationVisible: m,
    setIsMobileViewEnabled: h,
    isMobileViewEnabled: y
  } = xr(), p = b.useRef(null), { isOpen: k, isMounted: x } = ra({
    isVisible: m,
    elementRef: p
  }), { isMobile: C, handleResizeRef: S } = Zl({
    mobileBreakpoint: Yi
  });
  return b.useEffect(() => {
    h(C);
  }, [C]), /* @__PURE__ */ g("div", { className: s, ref: S, children: [
    !y && r,
    /* @__PURE__ */ g(
      "div",
      {
        className: c(Xe[nt], {
          [Xe[`${nt}--mobile`]]: y
        }),
        children: [
          !y && /* @__PURE__ */ t(
            "div",
            {
              className: c(
                Xe[`${nt}__top-bar`],
                {
                  [Xe[`${nt}__top-bar--visible`]]: i
                },
                n
              ),
              children: i
            }
          ),
          /* @__PURE__ */ g(
            "div",
            {
              className: c(Xe[`${nt}__content-wrapper`], {
                [Xe[`${nt}__content-wrapper--mobile`]]: y
              }),
              children: [
                !y && l && /* @__PURE__ */ t(
                  "div",
                  {
                    ref: p,
                    className: c(
                      Xe[`${nt}__content-wrapper__nav-bar-wrapper`],
                      "lc-dark-theme",
                      d,
                      {
                        [Xe[`${nt}__content-wrapper__nav-bar-wrapper--open`]]: k
                      }
                    ),
                    children: x && l
                  }
                ),
                y && /* @__PURE__ */ t(
                  "div",
                  {
                    className: Xe[`${nt}__content-wrapper__mobile-top-bar`],
                    children: i
                  }
                ),
                /* @__PURE__ */ t(
                  "div",
                  {
                    className: c(
                      Xe[`${nt}__content-wrapper__content`],
                      u,
                      {
                        [Xe[`${nt}__content-wrapper__content--mobile`]]: y
                      }
                    ),
                    children: a
                  }
                ),
                y && _
              ]
            }
          )
        ]
      }
    )
  ] });
}, _u = (e) => {
  const { isSideNavigationVisible: a, ...o } = e;
  return /* @__PURE__ */ t(ti, { isSideNavigationVisible: a, children: /* @__PURE__ */ t(Zi, { ...o }) });
}, na = {
  "side-navigation": "lc-SideNavigation-module__side-navigation___FuFGb",
  "side-navigation__header": "lc-SideNavigation-module__side-navigation__header___du0Jr",
  "side-navigation__header__title": "lc-SideNavigation-module__side-navigation__header__title___2dGWf",
  "side-navigation__footer": "lc-SideNavigation-module__side-navigation__footer___9LLon",
  "side-navigation__nav-wrapper": "lc-SideNavigation-module__side-navigation__nav-wrapper___8Opuh",
  "side-navigation__nav-wrapper--no-gaps": "lc-SideNavigation-module__side-navigation__nav-wrapper--no-gaps___1ApnT"
}, ca = "side-navigation", lu = ({
  children: e,
  className: a,
  title: o,
  customHeader: r,
  customFooter: _,
  noGaps: l,
  rightNode: i
}) => {
  const n = r || /* @__PURE__ */ g("div", { className: na[`${ca}__header`], children: [
    /* @__PURE__ */ t(ce, { size: "sm", className: na[`${ca}__header__title`], children: o }),
    i
  ] });
  return /* @__PURE__ */ g(
    "div",
    {
      "data-testid": "side-navigation",
      className: c(na[ca], a),
      children: [
        n,
        /* @__PURE__ */ t(
          "div",
          {
            className: c(na[`${ca}__nav-wrapper`], {
              [na[`${ca}__nav-wrapper--no-gaps`]]: l
            }),
            children: e
          }
        ),
        _ && /* @__PURE__ */ t("div", { className: na[`${ca}__footer`], children: _ })
      ]
    }
  );
};
function Za() {
}
const ji = "side-navigation-item-test-id", Ji = "side-navigation-active-item-test-id", Qi = "side-navigation-parent-icon", Ze = {
  "side-navigation-item": "lc-SideNavigationItem-module__side-navigation-item___QCTSQ",
  "side-navigation-item__anchor": "lc-SideNavigationItem-module__side-navigation-item__anchor___PI--g",
  "side-navigation-item__custom-label": "lc-SideNavigationItem-module__side-navigation-item__custom-label___ATpTF",
  "side-navigation-item__anchor--main-entry": "lc-SideNavigationItem-module__side-navigation-item__anchor--main-entry___h9Lwx",
  "side-navigation-item__anchor--active": "lc-SideNavigationItem-module__side-navigation-item__anchor--active___iXojJ",
  "side-navigation-item__anchor--icon-hidden": "lc-SideNavigationItem-module__side-navigation-item__anchor--icon-hidden___KlK37",
  "side-navigation-item__left-node": "lc-SideNavigationItem-module__side-navigation-item__left-node___otK1S",
  "side-navigation-item__left-node--active": "lc-SideNavigationItem-module__side-navigation-item__left-node--active___5PNWM",
  "side-navigation-item__right-node": "lc-SideNavigationItem-module__side-navigation-item__right-node___MOwqj",
  "side-navigation-item__label": "lc-SideNavigationItem-module__side-navigation-item__label___dpMyX",
  "side-navigation-item__label--active": "lc-SideNavigationItem-module__side-navigation-item__label--active___4vImp",
  "side-navigation-item__custom-label--active": "lc-SideNavigationItem-module__side-navigation-item__custom-label--active___UWDu9"
}, je = "side-navigation-item", en = ({
  leftNode: e,
  shouldKeepIconSpace: a = !0,
  url: o,
  label: r,
  className: _,
  rightNode: l,
  onClick: i,
  isActive: n,
  isMainEntry: d,
  onItemHover: u,
  isIconHidden: s,
  ...m
}) => {
  const h = typeof r == "string", y = (k) => {
    k.preventDefault(), i?.();
  }, p = (k) => {
    k.key === "Enter" && (k.preventDefault(), i?.());
  };
  return /* @__PURE__ */ t(
    "li",
    {
      className: c([Ze[je], _]),
      "data-testid": n ? Ji : ji,
      "data-active": n,
      ...m,
      children: /* @__PURE__ */ g(
        "a",
        {
          tabIndex: 0,
          className: c(Ze[`${je}__anchor`], {
            [Ze[`${je}__anchor--active`]]: n,
            [Ze[`${je}__anchor--main-entry`]]: d,
            [Ze[`${je}__anchor--icon-hidden`]]: s
          }),
          href: o,
          onClick: y,
          onKeyDown: p,
          onMouseEnter: u || Za,
          onFocus: u || Za,
          children: [
            a && /* @__PURE__ */ t(
              "span",
              {
                className: c(Ze[`${je}__left-node`], {
                  [Ze[`${je}__left-node--active`]]: n || d
                }),
                "data-testid": Qi,
                children: e
              }
            ),
            h ? /* @__PURE__ */ t(
              T,
              {
                bold: n || d,
                className: c(Ze[`${je}__label`], {
                  [Ze[`${je}__label--active`]]: n || d
                }),
                children: r
              }
            ) : /* @__PURE__ */ t(
              "span",
              {
                className: c(Ze[`${je}__custom-label`], {
                  [Ze[`${je}__custom-label--active`]]: n || d
                }),
                children: r
              }
            ),
            l && /* @__PURE__ */ t("span", { className: Ze[`${je}__right-node`], children: l })
          ]
        }
      )
    }
  );
}, tn = "side-navigation-link-label-test-id", kt = {
  "side-navigation-group": "lc-SideNavigationGroup-module__side-navigation-group___Cgruk",
  "side-navigation-group__chevron": "lc-SideNavigationGroup-module__side-navigation-group__chevron___4wv4s",
  "side-navigation-group__chevron--active": "lc-SideNavigationGroup-module__side-navigation-group__chevron--active___v7QK7",
  "side-navigation-group__label": "lc-SideNavigationGroup-module__side-navigation-group__label___pDDzF",
  "side-navigation-group__simple-label-wrapper": "lc-SideNavigationGroup-module__side-navigation-group__simple-label-wrapper___PJwbR",
  "side-navigation-group__simple-label": "lc-SideNavigationGroup-module__side-navigation-group__simple-label___-KO5t",
  "side-navigation-group__right-node": "lc-SideNavigationGroup-module__side-navigation-group__right-node___I90bd",
  "side-navigation-group__list-wrapper": "lc-SideNavigationGroup-module__side-navigation-group__list-wrapper___moivM",
  "side-navigation-group__list-wrapper--expanded": "lc-SideNavigationGroup-module__side-navigation-group__list-wrapper--expanded___cwPUQ",
  "side-navigation-group__list": "lc-SideNavigationGroup-module__side-navigation-group__list___Srb-J"
}, Ct = "side-navigation-group", an = 34, iu = ({
  label: e,
  rightNode: a,
  className: o,
  labelClassName: r,
  labelWrapperClassName: _,
  listWrapperClassName: l,
  children: i,
  isCollapsible: n,
  isLinkLabel: d,
  isActive: u,
  isOpen: s,
  isMounted: m,
  setShouldBeVisible: h,
  onItemHover: y,
  onClick: p,
  listWrapperRef: k,
  shouldOpenOnInit: x = !1
}) => {
  const [C, S] = b.useState(!1), [N, $] = b.useState(0), w = b.useRef(!1), f = b.useRef(null), v = k ?? f, { isOpen: E, isMounted: D, setShouldBeVisible: B } = ra({
    isVisible: !n || x,
    elementRef: v
  }), M = s ?? E, I = m ?? D, P = h ?? B, A = typeof a == "function" ? a(M) : a, F = typeof e == "function" ? e(M) : e, R = () => P(!0), U = () => {
    n && P((oe) => !oe);
  }, ge = () => p ? p({ toggle: U }) : U();
  return b.useEffect(() => {
    if (!i || !n)
      return;
    const oe = b.Children.toArray(
      i
    ), se = !!oe?.some(
      (K) => K.props?.isActive
    );
    S(se);
    const Q = (oe?.length || 0) * an;
    $(Q);
  }, [i]), b.useEffect(() => {
    !w.current && C && R(), w.current = C;
  }, [C, w.current, x]), /* @__PURE__ */ g("div", { "data-testid": "side-navigation-group", className: kt[Ct], children: [
    n || d ? /* @__PURE__ */ t(
      en,
      {
        leftNode: /* @__PURE__ */ t(
          "div",
          {
            className: c(kt[`${Ct}__chevron`], {
              [kt[`${Ct}__chevron--active`]]: M
            }),
            children: n ? /* @__PURE__ */ t(O, { source: Do, size: "small" }) : null
          }
        ),
        label: /* @__PURE__ */ t(
          T,
          {
            className: c(kt[`${Ct}__label`], r),
            bold: !0,
            children: F
          }
        ),
        isActive: u,
        isMainEntry: !0,
        onClick: ge,
        onItemHover: y,
        rightNode: A,
        className: _,
        "data-testid": d ? tn : void 0
      }
    ) : /* @__PURE__ */ g(
      "span",
      {
        className: c(
          kt[`${Ct}__simple-label-wrapper`],
          _
        ),
        children: [
          /* @__PURE__ */ t(
            T,
            {
              bold: !0,
              className: c(kt[`${Ct}__simple-label`], r),
              onMouseEnter: y || Za,
              children: F
            }
          ),
          A && /* @__PURE__ */ t("span", { className: kt[`${Ct}__right-node`], children: A })
        ]
      }
    ),
    /* @__PURE__ */ t(
      "div",
      {
        ref: v,
        className: c([
          kt[`${Ct}__list-wrapper`],
          {
            [kt[`${Ct}__list-wrapper--expanded`]]: M
          },
          l
        ]),
        style: n ? { maxHeight: M ? N : 0 } : void 0,
        children: I && /* @__PURE__ */ t("ul", { className: c(kt[`${Ct}__list`], o), children: i })
      }
    )
  ] });
}, Wr = {
  "navigation-group": "lc-NavigationGroup-module__navigation-group___61JTX",
  "navigation-group--scrollable": "lc-NavigationGroup-module__navigation-group--scrollable___BL8-e"
}, Kr = "navigation-group", nu = ({
  children: e,
  className: a,
  scrollable: o,
  ...r
}) => /* @__PURE__ */ t(
  "ul",
  {
    className: c(
      Wr[Kr],
      {
        [Wr[`${Kr}--scrollable`]]: o
      },
      a
    ),
    ...r,
    children: e
  }
);
function on(e, a) {
  return e > a ? `${a}+` : `${e}`;
}
const rn = "lc-Badge-module__badge___ZbEBU", _n = "lc-Badge-module__badge__dot___MSVVf", uo = {
  badge: rn,
  badge__dot: _n,
  "badge--large": "lc-Badge-module__badge--large___P4qtE",
  "badge--medium": "lc-Badge-module__badge--medium___5HFVb",
  "badge--compact": "lc-Badge-module__badge--compact___AUaWg",
  "badge--primary": "lc-Badge-module__badge--primary___wOrp-",
  "badge--secondary": "lc-Badge-module__badge--secondary___mAh3w",
  "badge--tertiary": "lc-Badge-module__badge--tertiary___rFqKw"
}, mo = "badge", To = ({
  className: e,
  count: a = 0,
  max: o = 99,
  kind: r = "primary",
  size: _ = "medium",
  type: l = "counter",
  ...i
}) => {
  const n = c(
    e,
    uo[mo],
    uo[`${mo}--${r}`],
    uo[`${mo}--${_}`]
  ), d = {
    counter: on(a, o),
    alert: "!",
    dot: /* @__PURE__ */ t("span", { "data-testid": "badge-dot", className: uo[`${mo}__dot`] })
  }[l];
  return /* @__PURE__ */ t("span", { className: n, ...i, children: d });
}, Gt = {
  "navigation-item": "lc-NavigationItem-module__navigation-item___KVL3Y",
  "navigation-item--disabled": "lc-NavigationItem-module__navigation-item--disabled___VY8pA",
  "navigation-item__badge": "lc-NavigationItem-module__navigation-item__badge___6RiK5",
  "navigation-item__button": "lc-NavigationItem-module__navigation-item__button___g-pAI",
  "navigation-item__button--disabled": "lc-NavigationItem-module__navigation-item__button--disabled___POYlQ",
  "navigation-item__button--active": "lc-NavigationItem-module__navigation-item__button--active___zsO2E",
  "navigation-item__button--opacity": "lc-NavigationItem-module__navigation-item__button--opacity___buZjS",
  "navigation-item__button--mobile": "lc-NavigationItem-module__navigation-item__button--mobile___GqQwP"
}, Ut = "navigation-item", ln = (e, a) => typeof e == "number" ? /* @__PURE__ */ t(
  To,
  {
    "data-testid": `${a}-badge-count`,
    className: Gt[`${Ut}__badge`],
    size: "compact",
    count: e
  }
) : /* @__PURE__ */ t(
  To,
  {
    "data-testid": `${a}-badge`,
    className: Gt[`${Ut}__badge`],
    size: "compact",
    type: e
  }
), cu = ({
  id: e,
  label: a,
  icon: o,
  url: r,
  disableOpacity: _,
  disabled: l = !1,
  badge: i,
  isActive: n,
  onClick: d,
  className: u,
  ...s
}) => {
  const { isMobileViewEnabled: m } = xr();
  return /* @__PURE__ */ t(
    "li",
    {
      id: e,
      className: c(
        Gt[Ut],
        {
          [Gt[`${Ut}--disabled`]]: l
        },
        u
      ),
      children: /* @__PURE__ */ t(
        Yt,
        {
          floatingStrategy: "fixed",
          placement: "right",
          kind: "invert",
          isVisible: m || !a || l ? !1 : void 0,
          offsetMainAxis: 12,
          hoverOnDelay: 400,
          useClickHookProps: { ignoreMouse: !0 },
          useDismissHookProps: {
            referencePress: !0,
            referencePressEvent: "click"
          },
          triggerRenderer: /* @__PURE__ */ g(W, { children: [
            /* @__PURE__ */ g(
              "a",
              {
                tabIndex: l ? -1 : 0,
                "aria-label": a,
                className: c(
                  Gt[`${Ut}__button`],
                  {
                    [Gt[`${Ut}__button--active`]]: n,
                    [Gt[`${Ut}__button--opacity`]]: _,
                    [Gt[`${Ut}__button--disabled`]]: l,
                    [Gt[`${Ut}__button--mobile`]]: m
                  },
                  "lc-dark-theme"
                ),
                onClick: (h) => !l && d(h, e),
                href: r,
                ...s,
                children: [
                  o,
                  m && a
                ]
              }
            ),
            !!i && ln(i, e)
          ] }),
          children: a
        }
      )
    },
    e
  );
}, nn = "lc-Navigation-module__navigation___oNBOL", cn = {
  navigation: nn
}, sn = "navigation", su = ({
  children: e,
  className: a,
  ...o
}) => /* @__PURE__ */ t("nav", { className: c(cn[sn], a), ...o, children: e }), gt = {
  "navigation-top-bar": "lc-NavigationTopBar-module__navigation-top-bar___WJzyv",
  "navigation-top-bar__title": "lc-NavigationTopBar-module__navigation-top-bar__title___ROYDp",
  "navigation-top-bar__alerts-wrapper": "lc-NavigationTopBar-module__navigation-top-bar__alerts-wrapper___wkJlE",
  "navigation-top-bar__alert": "lc-NavigationTopBar-module__navigation-top-bar__alert___x2xOO",
  "navigation-top-bar__alert--open": "lc-NavigationTopBar-module__navigation-top-bar__alert--open___ESpyQ",
  "navigation-top-bar__alert__wrapper": "lc-NavigationTopBar-module__navigation-top-bar__alert__wrapper___rOnri",
  "navigation-top-bar__alert__wrapper--open": "lc-NavigationTopBar-module__navigation-top-bar__alert__wrapper--open___v-NG3",
  "navigation-top-bar__alert--info": "lc-NavigationTopBar-module__navigation-top-bar__alert--info___kfakN",
  "navigation-top-bar__alert--success": "lc-NavigationTopBar-module__navigation-top-bar__alert--success___s3tbr",
  "navigation-top-bar__alert--warning": "lc-NavigationTopBar-module__navigation-top-bar__alert--warning___giSMt",
  "navigation-top-bar__alert--error": "lc-NavigationTopBar-module__navigation-top-bar__alert--error___N4jFl",
  "navigation-top-bar__alert__children-wrapper": "lc-NavigationTopBar-module__navigation-top-bar__alert__children-wrapper___cfSYX",
  "navigation-top-bar__alert__close-button": "lc-NavigationTopBar-module__navigation-top-bar__alert__close-button___odqcf",
  "navigation-top-bar__alert__cta-wrapper": "lc-NavigationTopBar-module__navigation-top-bar__alert__cta-wrapper___0QtM0"
}, Bo = "navigation-top-bar", zt = `${Bo}__alert`, I_ = ({
  children: e,
  className: a,
  additionalNodes: o,
  id: r
}) => {
  const { isMobileViewEnabled: _ } = xr();
  return /* @__PURE__ */ g("div", { className: c(gt[Bo], a), id: r, children: [
    /* @__PURE__ */ t("div", { className: gt[`${Bo}__alerts-wrapper`], children: e }),
    !_ && o
  ] });
}, dn = ({
  children: e,
  className: a,
  "data-testid": o
}) => /* @__PURE__ */ t(
  "div",
  {
    className: c(gt[`${Bo}__title`], a),
    "data-testid": o,
    children: e
  }
), un = ({
  className: e,
  kind: a = "info",
  closeButton: o,
  children: r,
  primaryCta: _,
  secondaryCta: l,
  isVisible: i = !0,
  id: n
}) => {
  const [d, u] = b.useState(!1), s = b.useRef(null), { isMounted: m, isOpen: h } = ra({
    isVisible: i,
    elementRef: s,
    includeSleepWakeScenario: !0
  }), y = b.useCallback(
    ($) => Ya(
      $,
      (w) => u(w.width < Xi)
    ),
    []
  ), p = a === "warning" ? "link-inverted" : "text", k = a === "warning" ? "secondary" : "high-contrast", x = _?.kind, C = l?.kind, S = _ || l ? /* @__PURE__ */ g("div", { className: gt[`${zt}__cta-wrapper`], children: [
    _ && /* @__PURE__ */ t(
      L,
      {
        size: "compact",
        ..._,
        kind: d ? p : x || k,
        children: _.label
      }
    ),
    l && /* @__PURE__ */ t(
      L,
      {
        size: "compact",
        ...l,
        kind: d ? p : C || k,
        children: l.label
      }
    )
  ] }) : null, N = /* @__PURE__ */ g(W, { children: [
    /* @__PURE__ */ g("div", { className: gt[`${zt}__children-wrapper`], children: [
      r,
      S
    ] }),
    o && /* @__PURE__ */ t(
      "button",
      {
        className: gt[`${zt}__close-button`],
        ...o,
        children: /* @__PURE__ */ t(O, { source: lt })
      }
    )
  ] });
  return /* @__PURE__ */ t(W, { children: m && /* @__PURE__ */ t("div", { ref: y, children: /* @__PURE__ */ t(
    "div",
    {
      className: c(
        gt[`${zt}__wrapper`],
        {
          [gt[`${zt}__wrapper--open`]]: h
        },
        "lc-dark-theme"
        // Alerts are forced into dark mode to maintain consistency of the colors
      ),
      ref: s,
      role: "status",
      children: /* @__PURE__ */ t(
        "div",
        {
          id: n,
          "data-testid": "navigation-top-bar-alert",
          className: c(
            gt[zt],
            gt[`${zt}--${a}`],
            {
              [gt[`${zt}--open`]]: h
            },
            e
          ),
          children: N
        }
      )
    }
  ) }) });
};
I_.Alert = un;
I_.Title = dn;
function Io(e, a, o, r) {
  return e === 1 ? a : o;
}
const po = {
  "expiration-counter": "lc-ExpirationCounter-module__expiration-counter___ro9nL",
  "expiration-counter__button": "lc-ExpirationCounter-module__expiration-counter__button___Xv5Nx",
  "expiration-counter__button__number": "lc-ExpirationCounter-module__expiration-counter__button__number___9hZV4",
  "expiration-counter__button__label": "lc-ExpirationCounter-module__expiration-counter__button__label___nJAOv"
}, go = "expiration-counter", du = ({
  id: e,
  daysLeft: a,
  url: o,
  onClick: r,
  className: _,
  ...l
}) => /* @__PURE__ */ t("li", { className: c(po[go], _), children: /* @__PURE__ */ g(
  "a",
  {
    id: e,
    tabIndex: 0,
    href: o,
    onClick: (i) => r(i, e),
    className: po[`${go}__button`],
    ...l,
    children: [
      /* @__PURE__ */ t("span", { className: po[`${go}__button__number`], children: a }),
      /* @__PURE__ */ t("span", { className: po[`${go}__button__label`], children: Io(a, "day", "days") })
    ]
  }
) }, e), mn = {
  "mobile-navigation": "lc-MobileNavigation-module__mobile-navigation___a--p5"
}, pn = "mobile-navigation", uu = ({
  children: e,
  className: a,
  ...o
}) => /* @__PURE__ */ t("nav", { className: c(mn[pn], a), ...o, children: e }), A_ = d_({
  readOnly: !1,
  isEmpty: !1,
  setIsEmpty: () => {
  }
}), gn = ({ children: e, readOnly: a = !1, defaultIsEmpty: o = !1 }) => {
  const [r, _] = le(o);
  return /* @__PURE__ */ t(
    A_.Provider,
    {
      value: {
        readOnly: a,
        isEmpty: r,
        setIsEmpty: _
      },
      children: e
    }
  );
}, Tt = () => u_(A_), va = ({
  value: e,
  noDataFallbackText: a = "No data"
}) => {
  const { setIsEmpty: o } = Tt();
  return q(() => {
    o(!e);
  }, [e, o]), /* @__PURE__ */ t(
    T,
    {
      noMargin: !0,
      semiBold: !!e,
      customColor: e ? void 0 : "var(--content-basic-secondary)",
      role: "textbox",
      "aria-readonly": "true",
      children: e || a
    }
  );
}, hn = "lc-Input-module__input___505b7", rt = {
  input: hn,
  "input--promo": "lc-Input-module__input--promo___5hf0s",
  "input--focused": "lc-Input-module__input--focused___rmg2U",
  "input--disabled": "lc-Input-module__input--disabled___QA4ie",
  "input--crop": "lc-Input-module__input--crop___63BIX",
  "input--error": "lc-Input-module__input--error___d2Aqj",
  "input--xsmall": "lc-Input-module__input--xsmall___6hLud",
  "input--compact": "lc-Input-module__input--compact___9Sw7d",
  "input--medium": "lc-Input-module__input--medium___gb5Z2",
  "input--large": "lc-Input-module__input--large___hfmAH",
  "input__icon--disabled": "lc-Input-module__input__icon--disabled___uTYsP",
  "input__icon--left": "lc-Input-module__input__icon--left___IBzj8",
  "input__icon--right": "lc-Input-module__input__icon--right___lw1xQ",
  "input__visibility-button": "lc-Input-module__input__visibility-button___lmD5H"
}, _t = "input", Yr = (e, a) => b.cloneElement(e.source, {
  "data-testid": `input-icon-${e.place}`,
  className: c(
    rt[`${_t}__icon`],
    rt[`${_t}__icon--${e.place}`],
    {
      [rt[`${_t}__icon--disabled`]]: a
    }
  )
}), D_ = b.forwardRef(
  ({
    error: e = !1,
    disabled: a,
    icon: o = null,
    className: r,
    mainClassName: _,
    isPromo: l = !1,
    cropOnBlur: i = !0,
    noDataFallbackText: n = "No data",
    ...d
  }, u) => {
    const s = b.useRef(null), { readOnly: m } = Tt(), h = m || d.readOnly;
    b.useImperativeHandle(u, () => s.current, []);
    const [y, p] = b.useState(!1), [k, x] = b.useState(!1), { type: C, onFocus: S, onBlur: N } = d, $ = c(
      _,
      {
        [rt[`${_t}--disabled`]]: a,
        [rt[`${_t}--focused`]]: y,
        [rt[`${_t}--error`]]: e,
        [rt[`${_t}--crop`]]: i
      },
      r
    ), w = a ? "var(--content-basic-disabled)" : "var(--content-basic-primary)", f = k ? el : tl, v = o && o.place === "left", E = o && C !== "password" && o.place === "right", D = () => {
      s.current?.focus();
    };
    return h ? /* @__PURE__ */ t(
      va,
      {
        value: d.value?.toString(),
        noDataFallbackText: n
      }
    ) : /* @__PURE__ */ g(
      T,
      {
        as: "div",
        size: l ? "lg" : "md",
        className: $,
        "aria-disabled": a,
        "tab-index": "0",
        onClick: D,
        children: [
          v && Yr(o, a),
          /* @__PURE__ */ t(
            "input",
            {
              ...d,
              ref: s,
              onFocus: (B) => {
                p(!0), S?.(B);
              },
              onBlur: (B) => {
                p(!1), N?.(B);
              },
              disabled: a,
              type: C && !k ? C : "text"
            }
          ),
          E && Yr(o, a),
          C === "password" && /* @__PURE__ */ t(
            L,
            {
              disabled: a,
              kind: "text",
              size: "compact",
              icon: /* @__PURE__ */ t(O, { customColor: w, source: f }),
              onClick: () => x((B) => !B),
              className: rt[`${_t}__visibility-button`]
            }
          )
        ]
      }
    );
  }
), fn = b.forwardRef(
  ({ inputSize: e = "medium", ...a }, o) => {
    const r = c(
      rt[_t],
      rt[`${_t}--${e}`]
    );
    return /* @__PURE__ */ t(D_, { mainClassName: r, ...a, ref: o });
  }
), bn = `${_t}--promo`, mu = b.forwardRef(
  (e, a) => {
    const o = c(rt[_t], rt[bn]);
    return /* @__PURE__ */ t(
      D_,
      {
        mainClassName: o,
        isPromo: !0,
        ...e,
        ref: a
      }
    );
  }
), vn = 2, O_ = 200, P_ = 400;
[
  ...[...Array(100)].map((e, a) => ({
    key: `option${a + 8}`,
    name: `Option #${a + 8}`,
    disabled: a % 4 === 0
  }))
];
const ga = "select-all", yn = (e, a) => {
  const o = [];
  return e.forEach((r, _) => {
    a(r) && o.push(_);
  }), o;
}, Cr = (e) => e.filter(
  ({ key: a, disabled: o, groupHeader: r }) => !(a === ga || o || r)
), Xr = ({ key: e }) => e, kn = (e, a) => e.includes(a) ? e.filter((o) => o !== a) : [...e, a], Zr = Array.from(
  { length: 10 },
  (e, a) => `--surface-avatar-${a + 1}`
);
function Cn(e) {
  if (!e)
    return;
  const a = e.split("").reduce((o, r) => o + r.charCodeAt(0), 0);
  return `var(${Zr[a % Zr.length]})`;
}
function wn(e = "", a = 2) {
  const o = e.trim().split(/\s+/), r = o.map((l) => [...l][0]);
  if (a < 1) return "";
  if (o.length <= a)
    return r.join("").toUpperCase();
  const _ = [r[0]];
  for (let l = o.length - a + 1; l < o.length; l++)
    _.push(r[l]);
  return _.join("").toUpperCase();
}
function $n(e) {
  let a = e;
  if (e.startsWith("var(--") && e.endsWith(")")) {
    const o = e.slice(4, -1);
    a = window.getComputedStyle(document.documentElement).getPropertyValue(o).trim();
  }
  return a && Nr(a, "#FFFFFF") > 3 ? "var(--color-white)" : "var(--color-black)";
}
const Sn = "lc-Avatar-module__avatar___5-kP8", Nn = "lc-Avatar-module__avatar__status___HNURz", xn = "lc-Avatar-module__avatar__rim___2AzYM", En = "lc-Avatar-module__avatar__image___OeTCV", Fe = {
  avatar: Sn,
  avatar__status: Nn,
  "avatar__status--available": "lc-Avatar-module__avatar__status--available___e8YYH",
  "avatar__status--unavailable": "lc-Avatar-module__avatar__status--unavailable___EZN8K",
  "avatar__status--unknown": "lc-Avatar-module__avatar__status--unknown___ig3u2",
  "avatar__status--xxxsmall": "lc-Avatar-module__avatar__status--xxxsmall___ywnfb",
  "avatar__status--circle": "lc-Avatar-module__avatar__status--circle___hluXh",
  "avatar__status--xxsmall": "lc-Avatar-module__avatar__status--xxsmall___1cyef",
  "avatar__status--xsmall": "lc-Avatar-module__avatar__status--xsmall___oamOI",
  "avatar__status--small": "lc-Avatar-module__avatar__status--small___mXtgJ",
  "avatar__status--medium": "lc-Avatar-module__avatar__status--medium___itZ--",
  "avatar__status--large": "lc-Avatar-module__avatar__status--large___xhFK7",
  "avatar__status--xlarge": "lc-Avatar-module__avatar__status--xlarge___Tt--f",
  "avatar__status--xxlarge": "lc-Avatar-module__avatar__status--xxlarge___nlhY4",
  "avatar__status--xxxlarge": "lc-Avatar-module__avatar__status--xxxlarge___jOQH-",
  "avatar__status--rounded-square": "lc-Avatar-module__avatar__status--rounded-square___vbnS3",
  avatar__rim: xn,
  "avatar__rim--xxxsmall": "lc-Avatar-module__avatar__rim--xxxsmall___i9Sfv",
  "avatar__rim--xxsmall": "lc-Avatar-module__avatar__rim--xxsmall___oTxsG",
  "avatar__rim--xsmall": "lc-Avatar-module__avatar__rim--xsmall___EP67J",
  "avatar__rim--small": "lc-Avatar-module__avatar__rim--small___GO4DE",
  "avatar__rim--medium": "lc-Avatar-module__avatar__rim--medium___PwmzG",
  "avatar__rim--large": "lc-Avatar-module__avatar__rim--large___uvcTs",
  "avatar__rim--xlarge": "lc-Avatar-module__avatar__rim--xlarge___bjiXr",
  "avatar__rim--xxlarge": "lc-Avatar-module__avatar__rim--xxlarge___YjUzl",
  "avatar__rim--xxxlarge": "lc-Avatar-module__avatar__rim--xxxlarge___KvgAh",
  avatar__image: En,
  "avatar__icon--xxxsmall": "lc-Avatar-module__avatar__icon--xxxsmall___wMbtg",
  "avatar__icon--xxsmall": "lc-Avatar-module__avatar__icon--xxsmall___x736T",
  "avatar__icon--xsmall": "lc-Avatar-module__avatar__icon--xsmall___FEY-4",
  "avatar__icon--small": "lc-Avatar-module__avatar__icon--small___2YWc9",
  "avatar__icon--medium": "lc-Avatar-module__avatar__icon--medium___zNzZn",
  "avatar__icon--large": "lc-Avatar-module__avatar__icon--large___xKot9",
  "avatar__icon--xlarge": "lc-Avatar-module__avatar__icon--xlarge___SaIEW",
  "avatar__icon--xxlarge": "lc-Avatar-module__avatar__icon--xxlarge___nKxnM",
  "avatar__icon--xxxlarge": "lc-Avatar-module__avatar__icon--xxxlarge___2MVJa",
  "avatar--circle": "lc-Avatar-module__avatar--circle___Ys84D",
  "avatar--rounded-square": "lc-Avatar-module__avatar--rounded-square___awk7U",
  "avatar--xxxsmall": "lc-Avatar-module__avatar--xxxsmall___S5mVR",
  "avatar--xxsmall": "lc-Avatar-module__avatar--xxsmall___i7spO",
  "avatar--xsmall": "lc-Avatar-module__avatar--xsmall___WWgCM",
  "avatar--small": "lc-Avatar-module__avatar--small___KH6pw",
  "avatar--medium": "lc-Avatar-module__avatar--medium___un4U9",
  "avatar--large": "lc-Avatar-module__avatar--large___C8hm4",
  "avatar--xlarge": "lc-Avatar-module__avatar--xlarge___hjIy5",
  "avatar--xxlarge": "lc-Avatar-module__avatar--xxlarge___AjkHw",
  "avatar--xxxlarge": "lc-Avatar-module__avatar--xxxlarge___4Hhp9"
}, ke = "avatar", Br = ({
  alt: e,
  className: a,
  color: o,
  shape: r = "circle",
  size: _ = "medium",
  src: l,
  status: i,
  text: n,
  type: d,
  withRim: u = !1,
  style: s,
  ...m
}) => {
  const h = d === "image" && !l, [y, p] = b.useState(h), k = d === "image" && !!l && !y, x = d === "text", C = ["xxxsmall", "xxsmall", "xsmall"].includes(_) ? 1 : 2, S = wn(n, C), N = ["xxxsmall", "xxsmall", "xsmall", "small"].includes(_), $ = o || Cn(n), w = $ ? $n($) : void 0, f = x ? { backgroundColor: $ } : {}, v = c({
    [Fe[ke]]: !0,
    [Fe[`${ke}--${r}`]]: !0,
    [Fe[`${ke}--${_}`]]: !0,
    [Fe[`${ke}--with-rim`]]: u,
    ...a ? { [`${a}`]: a } : {}
  }), E = c(
    Fe[`${ke}__status`],
    Fe[`${ke}__status--${r}`],
    Fe[`${ke}__status--${_}`],
    ...i ? [Fe[`${ke}__status--${i}`]] : []
  ), D = c(
    Fe[`${ke}__icon`],
    Fe[`${ke}__icon--${_}`]
  ), B = c(
    Fe[`${ke}__rim`],
    Fe[`${ke}__rim--${_}`]
  ), M = (P) => N ? "2xs" : ["medium"].includes(P) ? "xs" : ["large", "xlarge"].includes(P) ? "sm" : ["xxlarge"].includes(P) ? "lg" : "xl", I = b.useCallback(() => p(!0), []);
  return b.useEffect(() => {
    p(h);
  }, [h]), /* @__PURE__ */ g(
    "div",
    {
      className: v,
      style: { ...f, ...s },
      ...m,
      children: [
        u && /* @__PURE__ */ t(
          "div",
          {
            "data-testid": `${ke}__rim`,
            className: B
          }
        ),
        i && /* @__PURE__ */ t(
          "div",
          {
            "data-testid": `${ke}__status`,
            className: E
          }
        ),
        k && /* @__PURE__ */ t(
          "img",
          {
            className: Fe[`${ke}__image`],
            src: l,
            alt: e,
            onError: I
          }
        ),
        x && /* @__PURE__ */ t(
          ce,
          {
            as: "span",
            size: M(_),
            style: { color: w },
            bold: N,
            uppercase: N,
            children: S
          }
        ),
        y && /* @__PURE__ */ t(
          O,
          {
            "data-testid": `${ke}__icon`,
            className: D,
            source: al
          }
        )
      ]
    }
  );
}, Tn = {
  "field-description": "lc-FieldDescription-module__field-description___x5rXY"
}, Bn = "field-description", Fo = ({ children: e, className: a = "", ...o }) => {
  const r = c(Tn[Bn], a);
  return /* @__PURE__ */ t(T, { as: "span", size: "sm", ...o, className: r, children: e });
}, In = "lc-Checkbox-module__checkbox___D0D4S", An = "lc-Checkbox-module__checkbox__label___I472A", Dn = "lc-Checkbox-module__checkbox__text___Ex7K1", On = "lc-Checkbox-module__checkbox__input___3krUF", Pn = "lc-Checkbox-module__checkbox__checkmark___eZIG1", Mn = "lc-Checkbox-module__checkbox__helper___hwxAV", Rn = "lc-Checkbox-module__checkbox__square___yjtrH", Ot = {
  checkbox: In,
  checkbox__label: An,
  checkbox__text: Dn,
  checkbox__input: On,
  checkbox__checkmark: Pn,
  "checkbox--read-only": "lc-Checkbox-module__checkbox--read-only___zeYW7",
  checkbox__helper: Mn,
  "checkbox--selected": "lc-Checkbox-module__checkbox--selected___pU3Xh",
  checkbox__square: Rn,
  "checkbox--disabled": "lc-Checkbox-module__checkbox--disabled___kRNDo"
}, Pt = "checkbox", Go = b.forwardRef(
  ({
    checked: e,
    indeterminate: a = !1,
    disabled: o,
    children: r,
    description: _,
    className: l,
    ...i
  }, n) => {
    const { readOnly: d } = Tt(), u = d || i.readOnly;
    return /* @__PURE__ */ g(
      "div",
      {
        className: c(Ot[Pt], l, {
          [Ot[`${Pt}--selected`]]: e,
          [Ot[`${Pt}--disabled`]]: o,
          [Ot[`${Pt}--indeterminate`]]: a,
          [Ot[`${Pt}--read-only`]]: u
        }),
        children: [
          /* @__PURE__ */ g("label", { className: Ot[`${Pt}__label`], children: [
            /* @__PURE__ */ t(
              "input",
              {
                ...i,
                ref: (s) => {
                  s && (s.indeterminate = a, typeof n == "function" ? n(s) : n && (n.current = s));
                },
                checked: e,
                disabled: o,
                className: Ot[`${Pt}__input`],
                type: "checkbox"
              }
            ),
            r && /* @__PURE__ */ t(T, { as: "div", size: "md", className: Ot[`${Pt}__text`], children: r })
          ] }),
          _ && /* @__PURE__ */ t(Fo, { className: Ot[`${Pt}__helper`], children: _ })
        ]
      }
    );
  }
), Ee = {
  "item-wrapper": "lc-PickerListItem-module__item-wrapper___xIByl",
  "item-wrapper__first": "lc-PickerListItem-module__item-wrapper__first___qcOML",
  "item-wrapper__last": "lc-PickerListItem-module__item-wrapper__last___Ac2Y-",
  "picker-list__item": "lc-PickerListItem-module__picker-list__item___Pvh-4",
  "picker-list__item--select-all": "lc-PickerListItem-module__picker-list__item--select-all___P0GzV",
  "picker-list__item__header": "lc-PickerListItem-module__picker-list__item__header___Besp-",
  "picker-list__item__custom": "lc-PickerListItem-module__picker-list__item__custom___UbY70",
  "picker-list__item__checkbox": "lc-PickerListItem-module__picker-list__item__checkbox___d5uLj",
  "picker-list__item__avatar": "lc-PickerListItem-module__picker-list__item__avatar___9AS0i",
  "picker-list__item__icon": "lc-PickerListItem-module__picker-list__item__icon___x6wiv",
  "picker-list__item__label-container": "lc-PickerListItem-module__picker-list__item__label-container___emTD1",
  "picker-list__item__label": "lc-PickerListItem-module__picker-list__item__label___kAkZc",
  "picker-list__item__main-label": "lc-PickerListItem-module__picker-list__item__main-label___8CJdc",
  "picker-list__item__secondary-label": "lc-PickerListItem-module__picker-list__item__secondary-label___i-DOd"
}, ct = "picker-list__item", Fn = ({
  index: e,
  isActive: a,
  isSelected: o,
  listElementsRef: r,
  onSelect: _,
  getItemProps: l,
  item: i,
  numberOfItems: n
}) => {
  const d = (s) => {
    if (s?.customElement?.listItemBody)
      return /* @__PURE__ */ t("div", { className: Ee[`${ct}__custom`], children: s.customElement.listItemBody });
    const m = (h) => h.avatar?.type || (h.avatarSrc ? "image" : "text");
    return /* @__PURE__ */ g(W, { children: [
      s.showCheckbox && /* @__PURE__ */ t(
        Go,
        {
          className: Ee[`${ct}__checkbox`],
          checked: o
        }
      ),
      s.icon && /* @__PURE__ */ t(
        O,
        {
          className: Ee[`${ct}__icon`],
          kind: "link",
          source: s.icon
        }
      ),
      (s.avatar || s.avatarSrc) && /* @__PURE__ */ t(
        Br,
        {
          className: Ee[`${ct}__avatar`],
          src: s.avatar?.src || s.avatarSrc,
          type: m(s),
          text: s.name,
          alt: s.name,
          size: "xxsmall"
        }
      ),
      /* @__PURE__ */ g("div", { className: Ee[`${ct}__label-container`], children: [
        /* @__PURE__ */ t(
          T,
          {
            as: "span",
            className: c([Ee[`${ct}__label`]], {
              [Ee[`${ct}__main-label`]]: s.secondaryText
            }),
            "aria-disabled": s.disabled,
            children: s.name
          }
        ),
        s.secondaryText && /* @__PURE__ */ t("span", { className: Ee[`${ct}__secondary-label`], children: s.secondaryText })
      ] })
    ] });
  };
  if (i.groupHeader)
    return /* @__PURE__ */ t(
      "div",
      {
        id: `item-${e}`,
        role: "group",
        className: Ee[`${ct}__header`],
        ...l(),
        children: /* @__PURE__ */ t(ce, { size: "2xs", uppercase: !0, bold: !0, as: "div", children: i.name })
      },
      i.key
    );
  const u = (s) => {
    !i.disabled && _(s);
  };
  return /* @__PURE__ */ t(
    "div",
    {
      id: i.key,
      tabIndex: a ? 0 : -1,
      ref: (s) => {
        s && (r.current[e] = s);
      },
      role: "option",
      "aria-setsize": n,
      "aria-posinset": e + 1,
      ...l({
        onClick: () => u(i.key)
      }),
      className: c(Ee["item-wrapper"], {
        [Ee["item-wrapper__first"]]: e === 0 && !i.groupHeader,
        [Ee["item-wrapper__last"]]: e === n - 1 && !i.groupHeader
      }),
      children: /* @__PURE__ */ g(
        "div",
        {
          "aria-selected": o,
          "aria-disabled": i.disabled,
          "aria-current": a && !i.disabled,
          className: c(Ee[ct], {
            [Ee[`${ct}--select-all`]]: i.key === ga
          }),
          children: [
            d(i),
            o && !i.showCheckbox && /* @__PURE__ */ t(
              O,
              {
                kind: "link",
                source: fa,
                customColor: "var(--content-basic-info)"
              }
            )
          ]
        }
      )
    },
    i.key
  );
}, Gn = "lc-PickerList-module__listbox___GgFk0", xa = {
  listbox: Gn,
  "no-results": "lc-PickerList-module__no-results___JSeou",
  "listbox-wrapper": "lc-PickerList-module__listbox-wrapper___1mIgW",
  "no-results-text": "lc-PickerList-module__no-results-text___r-f51"
}, M_ = ({
  context: e,
  setFloating: a,
  floatingStyles: o,
  maxHeight: r,
  options: _,
  activeIndex: l,
  selectedKeys: i,
  listElementsRef: n,
  isPositioned: d,
  searchDisabled: u,
  onItemRemove: s,
  setPointer: m,
  onSelect: h,
  getFloatingProps: y,
  getItemProps: p,
  emptyStateText: k = "No results found",
  hideWhenEmpty: x = !1,
  pickerType: C = "single",
  listClassName: S,
  virtuosoProps: N
}) => {
  const [$, w] = b.useState(0), f = qt(null), v = _.length, E = b.useCallback(
    (M) => {
      M !== $ && (M < r ? w(M + (v - 1) * vn) : w(r));
    },
    [v]
  );
  if (q(() => {
    u && d && l !== null && f.current?.focus();
  }, [u, d, l]), q(() => {
    n.current = new Array(_.length);
  }, [_.length]), _.length === 0)
    return x ? null : /* @__PURE__ */ t(br, { context: e, modal: !1, initialFocus: -1, children: /* @__PURE__ */ t(
      "div",
      {
        className: c(xa.listbox, xa["no-results"]),
        ref: a,
        tabIndex: -1,
        style: o,
        children: /* @__PURE__ */ t("div", { className: xa["no-results-text"], children: k })
      }
    ) });
  const D = (M) => i.includes(M) || M === ga && i.length === Cr(_).length, B = () => {
    C === "multi" && s(i[i.length - 1]);
  };
  return /* @__PURE__ */ t(br, { context: e, modal: !1, initialFocus: -1, children: /* @__PURE__ */ t(
    "div",
    {
      "data-testid": "picker-list",
      ref: a,
      tabIndex: -1,
      className: c(xa.listbox, S),
      style: {
        ...o,
        maxHeight: r
      },
      children: /* @__PURE__ */ t(
        "div",
        {
          ref: f,
          tabIndex: 0,
          "aria-multiselectable": C === "multi",
          className: xa["listbox-wrapper"],
          ...y({
            onKeyDown(M) {
              m(!1), M.key === "Enter" && l !== null && h(_[l].key), (M.key === "Backspace" || M.key === "Delete") && B(), M.key === " " && M.preventDefault();
            },
            onKeyUp(M) {
              M.key === " " && l !== null && h(_[l].key);
            },
            onPointerMove() {
              m(!0);
            }
          }),
          children: /* @__PURE__ */ t(
            Ul,
            {
              totalListHeightChanged: E,
              style: { height: `${$}px`, maxHeight: r },
              totalCount: _.length,
              data: _,
              increaseViewportBy: 200,
              ...N,
              itemContent: (M, I) => /* @__PURE__ */ t(
                Fn,
                {
                  index: M,
                  getItemProps: p,
                  listElementsRef: n,
                  isActive: l === M,
                  isSelected: D(I.key),
                  onSelect: h,
                  item: I,
                  numberOfItems: v
                }
              )
            }
          )
        }
      )
    }
  ) });
}, Te = {
  "picker-trigger": "lc-PickerTrigger-module__picker-trigger___nSDgb",
  "picker-trigger--multi-select": "lc-PickerTrigger-module__picker-trigger--multi-select___XCt1K",
  "picker-trigger--multi-select--with-items": "lc-PickerTrigger-module__picker-trigger--multi-select--with-items___0VU14",
  "picker-trigger__content": "lc-PickerTrigger-module__picker-trigger__content___tAfyM",
  "picker-trigger__content--compact": "lc-PickerTrigger-module__picker-trigger__content--compact___iudK8",
  "picker-trigger__content--medium": "lc-PickerTrigger-module__picker-trigger__content--medium___1TZtT",
  "picker-trigger__content--large": "lc-PickerTrigger-module__picker-trigger__content--large___VUVXl",
  "picker-trigger__content--with-items": "lc-PickerTrigger-module__picker-trigger__content--with-items___6R0wr",
  "picker-trigger__controls": "lc-PickerTrigger-module__picker-trigger__controls___W7nRe",
  "picker-trigger__controls--compact": "lc-PickerTrigger-module__picker-trigger__controls--compact___y9w3B",
  "picker-trigger__controls--medium": "lc-PickerTrigger-module__picker-trigger__controls--medium___FYWxm",
  "picker-trigger__controls--large": "lc-PickerTrigger-module__picker-trigger__controls--large___jHbAJ",
  "picker-trigger__clear-icon": "lc-PickerTrigger-module__picker-trigger__clear-icon___Jgz6U",
  "picker-trigger__chevron-icon": "lc-PickerTrigger-module__picker-trigger__chevron-icon___Itnmh",
  "picker-trigger--disabled": "lc-PickerTrigger-module__picker-trigger--disabled___PKfb-",
  "picker-trigger--focused": "lc-PickerTrigger-module__picker-trigger--focused___xbQpR",
  "picker-trigger--error": "lc-PickerTrigger-module__picker-trigger--error___As8hf"
}, Ce = "picker-trigger", Un = ({
  setReference: e,
  getReferenceProps: a,
  testId: o,
  size: r = "medium",
  isMultiSelect: _,
  isItemSelected: l,
  hideClearButton: i,
  isDisabled: n,
  isRequired: d,
  isOpen: u,
  isError: s,
  onClear: m,
  children: h,
  setTriggerFocus: y,
  onToggle: p
}) => {
  const k = c(
    Te[Ce],
    Te[`${Ce}--${r}`],
    _ && Te[`${Ce}--multi-select`],
    _ && l && Te[`${Ce}--multi-select--with-items`],
    n && Te[`${Ce}--disabled`],
    u && Te[`${Ce}--focused`],
    s && Te[`${Ce}--error`]
  ), x = !i && l && !n && !d, C = (N) => {
    N.stopPropagation(), m();
  }, S = (N) => {
    !n && !(u && N.target.tagName === "BUTTON") && p();
  };
  return b.useEffect(() => {
    u || y(!1);
  }, [u]), /* @__PURE__ */ g(
    "button",
    {
      tabIndex: n ? -1 : 0,
      "aria-disabled": n,
      disabled: n,
      className: k,
      "data-testid": o,
      ref: e,
      type: "button",
      ...a(),
      onFocus: () => y(!0),
      onBlur: () => y(!1),
      onClick: S,
      children: [
        /* @__PURE__ */ t(
          T,
          {
            as: "div",
            className: c(
              Te[`${Ce}__content`],
              Te[`${Ce}__content--${r}`],
              _ && l && Te[`${Ce}__content--with-items`]
            ),
            children: h
          }
        ),
        /* @__PURE__ */ g(
          "div",
          {
            className: c(
              Te[`${Ce}__controls`],
              Te[`${Ce}__controls--${r}`]
            ),
            children: [
              x && /* @__PURE__ */ t(
                "div",
                {
                  "data-testid": `${Ce}__clear-icon`,
                  className: Te[`${Ce}__clear-icon`],
                  onClick: C,
                  children: /* @__PURE__ */ t(O, { kind: "primary", size: "small", source: lt })
                }
              ),
              /* @__PURE__ */ t(
                O,
                {
                  "data-testid": `${Ce}__chevron-icon`,
                  className: Te[`${Ce}__chevron-icon`],
                  source: u ? ja : Xt,
                  size: "medium",
                  disabled: n
                }
              )
            ]
          }
        )
      ]
    }
  );
}, Ln = "lc-Tag-module__tag___0Cfjz", qn = "lc-Tag-module__tag__remove___dYHt9", Hn = "lc-Tag-module__tag__node___3hHHq", zn = "lc-Tag-module__tag__content___w-HK1", Ge = {
  tag: Ln,
  "tag__content-wrapper": "lc-Tag-module__tag__content-wrapper___QrjSg",
  "tag--success": "lc-Tag-module__tag--success___Jr03z",
  tag__remove: qn,
  "tag--error": "lc-Tag-module__tag--error___zAr59",
  "tag--warning": "lc-Tag-module__tag--warning___6FwV2",
  "tag--info": "lc-Tag-module__tag--info___Zk-om",
  "tag--purple": "lc-Tag-module__tag--purple___8cY3y",
  "tag--black": "lc-Tag-module__tag--black___hGskP",
  "tag--outline": "lc-Tag-module__tag--outline___d-iCv",
  "tag--gray": "lc-Tag-module__tag--gray___EKXt6",
  "tag--gradient01": "lc-Tag-module__tag--gradient01___MStHW",
  "tag--gradient02": "lc-Tag-module__tag--gradient02___9tDwp",
  "tag--gradient03": "lc-Tag-module__tag--gradient03___-Sy8M",
  "tag--gradient04": "lc-Tag-module__tag--gradient04___WA5o6",
  "tag--gradient05": "lc-Tag-module__tag--gradient05___RUXqI",
  "tag--gradient06": "lc-Tag-module__tag--gradient06___FucnK",
  "tag--gradient07": "lc-Tag-module__tag--gradient07___d4-hS",
  "tag--gradient08": "lc-Tag-module__tag--gradient08___cSb8n",
  "tag--gradient09": "lc-Tag-module__tag--gradient09___rqbii",
  "tag--gradient10": "lc-Tag-module__tag--gradient10___5GHLp",
  "tag--gradient11": "lc-Tag-module__tag--gradient11___c6LfC",
  "tag--medium": "lc-Tag-module__tag--medium___lxV77",
  "tag--small": "lc-Tag-module__tag--small___plGiu",
  "tag--icon-only": "lc-Tag-module__tag--icon-only___WYMzu",
  "tag--large": "lc-Tag-module__tag--large___IUzeG",
  "tag--xlarge": "lc-Tag-module__tag--xlarge___2i2T7",
  "tag--text-white": "lc-Tag-module__tag--text-white___Gc3-T",
  "tag--text-black": "lc-Tag-module__tag--text-black___0UD4h",
  "tag--dismissible-on-hover": "lc-Tag-module__tag--dismissible-on-hover___Id-yT",
  "tag__remove--hover": "lc-Tag-module__tag__remove--hover___tILiT",
  tag__node: Hn,
  tag__content: zn
}, Ue = "tag", Vn = (e) => e ? Nr(e, "#FFFFFF") > 4.5 ? "text-white" : "text-black" : "", R_ = ({
  className: e = "",
  children: a,
  dismissibleOnHover: o = !1,
  disabled: r = !1,
  size: _ = "medium",
  kind: l = "default",
  onRemove: i,
  outline: n = !1,
  leftNode: d,
  rightNode: u,
  customColor: s,
  iconOnly: m = !1,
  value: h,
  ...y
}) => {
  const p = o || i && m, k = c(
    Ge[Ue],
    e,
    Ge[`${Ue}--${_}`],
    Ge[`${Ue}--${l}`],
    {
      [Ge[`${Ue}--outline`]]: n,
      [Ge[`${Ue}--${Vn(s)}`]]: !!s,
      [Ge[`${Ue}--icon-only`]]: m,
      [Ge[`${Ue}--dismissible-on-hover`]]: p
    }
  ), x = _ === "small" ? "small" : "medium", C = _ === "small" ? "sm" : "md", S = () => s ? n ? {
    style: {
      backgroundColor: "transparent",
      color: s,
      borderColor: s
    }
  } : { style: { backgroundColor: s } } : {}, N = () => {
    if (s)
      return n ? s : Nr(s, "#FFFFFF") > 4.5 ? "#FFFFFF" : "#000000";
  };
  return /* @__PURE__ */ g(
    T,
    {
      className: k,
      ...y,
      ...S(),
      as: "div",
      size: C,
      children: [
        /* @__PURE__ */ g("div", { className: Ge[`${Ue}__content-wrapper`], children: [
          d && !m && /* @__PURE__ */ t(
            "div",
            {
              "data-testid": "lc-tag-left-node",
              className: Ge[`${Ue}__node`],
              style: { color: N() },
              children: d
            }
          ),
          /* @__PURE__ */ t("div", { className: Ge[`${Ue}__content`], children: h || a }),
          u && !m && /* @__PURE__ */ t(
            "div",
            {
              "data-testid": "lc-tag-right-node",
              className: Ge[`${Ue}__node`],
              style: { color: N() },
              children: u
            }
          )
        ] }),
        i && !r && /* @__PURE__ */ t(
          "span",
          {
            tabIndex: -1,
            title: "Remove",
            onClick: i,
            role: "button",
            "aria-label": "Remove tag",
            className: c(Ge[`${Ue}__remove`], {
              [Ge[`${Ue}__remove--hover`]]: p
            }),
            children: /* @__PURE__ */ t(
              O,
              {
                "data-dismiss-icon": !0,
                source: lt,
                size: x,
                customColor: N()
              }
            )
          }
        )
      ]
    }
  );
}, Be = {
  "picker-trigger-body": "lc-PickerTriggerBody-module__picker-trigger-body___598fZ",
  "picker-trigger-body--single": "lc-PickerTriggerBody-module__picker-trigger-body--single___irxmq",
  "picker-trigger-body__item-container": "lc-PickerTriggerBody-module__picker-trigger-body__item-container___AnGk3",
  "picker-trigger-body__item": "lc-PickerTriggerBody-module__picker-trigger-body__item___k1S-g",
  "picker-trigger-body__item__content": "lc-PickerTriggerBody-module__picker-trigger-body__item__content___SKkl7",
  "picker-trigger-body__item__avatar": "lc-PickerTriggerBody-module__picker-trigger-body__item__avatar___gW6Qa",
  "picker-trigger-body__item__icon": "lc-PickerTriggerBody-module__picker-trigger-body__item__icon___TQrP2",
  "picker-trigger-body__placeholder": "lc-PickerTriggerBody-module__picker-trigger-body__placeholder___IdI0e",
  "picker-trigger-body__placeholder--disabled": "lc-PickerTriggerBody-module__picker-trigger-body__placeholder--disabled___24BT1",
  "picker-trigger-body__input": "lc-PickerTriggerBody-module__picker-trigger-body__input___O7ypn",
  "picker-trigger-body__input--compact": "lc-PickerTriggerBody-module__picker-trigger-body__input--compact___0ml2Q",
  "picker-trigger-body__input--medium": "lc-PickerTriggerBody-module__picker-trigger-body__input--medium___Hstke",
  "picker-trigger-body__input--large": "lc-PickerTriggerBody-module__picker-trigger-body__input--large___jQE7Q",
  "picker-trigger-body__tag": "lc-PickerTriggerBody-module__picker-trigger-body__tag___usvP3",
  "picker-trigger-body__tag--compact": "lc-PickerTriggerBody-module__picker-trigger-body__tag--compact___o4dKd",
  "picker-trigger-body__tag--medium": "lc-PickerTriggerBody-module__picker-trigger-body__tag--medium___uU1CL",
  "picker-trigger-body__tag--large": "lc-PickerTriggerBody-module__picker-trigger-body__tag--large___IBtox"
}, Ie = "picker-trigger-body", Wn = ({
  isOpen: e,
  isSearchDisabled: a,
  isDisabled: o,
  placeholder: r,
  selectedItems: _,
  type: l,
  clearSearchAfterSelection: i,
  size: n = "medium",
  onItemRemove: d,
  onSelect: u,
  onFilter: s,
  onClear: m,
  searchPhrase: h,
  virtualItemRef: y,
  isTriggerFocused: p,
  inputRef: k,
  inputProps: x
}) => {
  const C = e && !a;
  b.useEffect(() => {
    i && k?.current && k.current.focus();
  }, [_, i]);
  const S = (v) => {
    v.key === "Backspace" && _ && _.length > 0 && (v.preventDefault(), l === "multi" ? d(_[_.length - 1].key) : m()), v.key === "Delete" && (v.preventDefault(), m());
  };
  b.useEffect(() => (!e && p ? document.addEventListener("keydown", S) : document.removeEventListener("keydown", S), () => document.removeEventListener("keydown", S)), [e, _, p]);
  const N = (v) => l === "single" && e && !a ? null : v?.customElement?.selectedItemBody ? /* @__PURE__ */ t("div", { className: Be[`${Ie}__item`], children: v.customElement.selectedItemBody }) : /* @__PURE__ */ g("div", { className: Be[`${Ie}__item`], children: [
    v.icon && /* @__PURE__ */ t(
      O,
      {
        source: v.icon,
        className: Be[`${Ie}__item__icon`]
      }
    ),
    v.avatarSrc && /* @__PURE__ */ t(
      "img",
      {
        src: v.avatarSrc,
        alt: "",
        className: Be[`${Ie}__item__avatar`]
      }
    ),
    /* @__PURE__ */ t("div", { className: Be[`${Ie}__item__content`], children: v.name })
  ] }), $ = (v) => s(v.target.value), w = (v) => {
    y.current?.id && v.key === "Enter" && u(y.current?.id), l === "multi" && (v.key === "Backspace" || v.key === "Delete") && !h && _ && _?.length > 0 && d(_[_.length - 1].key);
  }, f = () => /* @__PURE__ */ t(
    "input",
    {
      ...x,
      ref: k,
      className: c(
        Be[`${Ie}__input`],
        Be[`${Ie}__input--${n}`]
      ),
      placeholder: r,
      onChange: $,
      onKeyDown: w,
      autoFocus: !0,
      value: h
    }
  );
  return !_ || _.length === 0 ? C ? f() : /* @__PURE__ */ t(
    "div",
    {
      className: c({
        [Be[`${Ie}__placeholder`]]: !0,
        [Be[`${Ie}__placeholder--disabled`]]: o
      }),
      children: r
    }
  ) : /* @__PURE__ */ g(
    "div",
    {
      className: c(Be[Ie], {
        [Be[`${Ie}--single`]]: l === "single"
      }),
      children: [
        /* @__PURE__ */ t("div", { className: Be[`${Ie}__item-container`], children: l === "single" ? N(_[0]) : _.map((v) => /* @__PURE__ */ t(
          R_,
          {
            className: c(
              Be[`${Ie}__tag`],
              Be[`${Ie}__tag--${n}`]
            ),
            disabled: o,
            onRemove: (E) => {
              E.stopPropagation(), d(v.key);
            },
            ...v.selectedTagOptions,
            children: N(v)
          },
          v.key
        )) }),
        C && f()
      ]
    }
  );
}, Kn = 10, F_ = ({
  disabled: e,
  items: a,
  placement: o,
  minListHeight: r,
  maxListHeight: _,
  floatingStrategy: l,
  useDismissHookProps: i,
  useClickHookProps: n,
  isOpen: d,
  onVisibilityChange: u,
  searchPhrase: s
}) => {
  const m = Ja(), [h, y] = b.useState(!1), [p, k] = b.useState(null), [x, C] = b.useState(_), S = b.useRef([]), N = b.useRef(null);
  b.useEffect(() => {
    N.current = null, k(null);
  }, [s]);
  const { refs: $, floatingStyles: w, context: f, isPositioned: v } = Qa({
    nodeId: m,
    open: d,
    strategy: l,
    onOpenChange: u,
    whileElementsMounted: eo,
    placement: o,
    middleware: [
      to(4),
      Po({ padding: 10 }),
      Sr(),
      b_({
        apply({ availableHeight: F, rects: R, elements: U }) {
          Rl.flushSync(() => {
            C(
              Math.max(
                Math.min(_, Number(F)),
                r
              )
            );
          }), Object.assign(U.floating.style, {
            width: `${R.reference.width}px`
          });
        },
        padding: Kn
      })
    ]
  }), E = ao(f, {
    enabled: !e,
    keyboardHandlers: !1,
    toggle: !1,
    ...n
  }), D = ro(f, { role: "listbox" }), B = oo(f, i), M = Pl(f, {
    enabled: a.length > 0 && !e,
    listRef: S,
    activeIndex: p,
    onNavigate: k,
    virtual: !0,
    virtualItemRef: N,
    disabledIndices: yn(
      a,
      (F) => !!F.disabled || !!F.groupHeader
    )
  }), { getReferenceProps: I, getFloatingProps: P, getItemProps: A } = _o(
    [E, B, D, M]
  );
  return !d && h && y(!1), {
    getReferenceProps: I,
    getFloatingProps: P,
    getItemProps: A,
    setReference: $.setReference,
    floatingStyles: w,
    isPositioned: v,
    context: f,
    nodeId: m,
    setFloating: $.setFloating,
    activeIndex: p,
    listElementsRef: S,
    virtualItemRef: N,
    maxHeight: x,
    pointer: h,
    setPointer: y
  };
}, G_ = ({
  selected: e,
  options: a,
  type: o,
  selectAllOptionText: r,
  onSelect: _,
  setOpen: l,
  clearSearchAfterSelection: i,
  inputRef: n
}) => {
  const [d, u] = b.useState(
    () => e?.map(Xr) || []
  ), s = e !== void 0, m = s ? e?.map(Xr) || [] : d, [h, y] = b.useState(""), p = ($) => y($), k = ($) => {
    o === "single" ? N($) : (u(m.filter((w) => w !== $)), _(e?.filter(({ key: w }) => w !== $) || null));
  }, x = () => {
    !s && u([]), _(null), y(""), l(!1);
  }, C = () => {
    p(""), n.current && (n.current.value = "");
  }, S = b.useMemo(() => {
    const $ = o === "multi" && r;
    let w = a;
    return h && (w = w.filter((f) => {
      if (f.groupHeader)
        return !0;
      const v = h.toLowerCase(), E = f.name.toLowerCase(), D = f.secondaryText?.toLowerCase();
      return E.includes(v) || D?.includes(v);
    }).filter(
      (f, v, E) => !(f.groupHeader && (E[v + 1]?.groupHeader || v === E.length - 1))
    )), $ && w.length > 1 && (w = [
      {
        key: ga,
        name: r
      },
      ...w
    ]), w;
  }, [h, a, o, r]), N = ($) => {
    const w = a.find((f) => f.key === $);
    (!w || w.disabled) && $ !== ga || (o === "single" ? (u(() => (w && _([w]), [$])), l(!1), i && C()) : $ === ga ? m.length === Cr(a).length ? u(() => (_(null), [])) : u(() => {
      const f = Cr(a);
      return _(f), f.map(({ key: v }) => v);
    }) : (s ? m.includes($) ? (_(
      e?.filter(({ key: f }) => f !== $) || null
    ), u((f) => f.filter((v) => v !== $))) : (_([...e || [], w]), u((f) => [...f, $])) : u((f) => {
      const v = kn(f, $);
      return _(a.filter(({ key: E }) => v.includes(E))), v;
    }), i && C()));
  };
  return {
    selectedKeys: m,
    items: S,
    searchPhrase: h,
    handleSelect: N,
    handleOnFilter: p,
    handleItemRemove: k,
    handleClear: x
  };
}, Yn = {
  "picker-wrapper": "lc-Picker-module__picker-wrapper___uaLHq"
}, pu = ({
  id: e,
  className: a,
  listClassName: o,
  minListHeight: r = O_,
  maxListHeight: _ = P_,
  disabled: l,
  error: i,
  options: n,
  selected: d,
  size: u = "medium",
  placeholder: s = "Select option",
  isRequired: m,
  noSearchResultText: h = "No results found",
  selectAllOptionText: y,
  type: p = "single",
  searchDisabled: k = !1,
  hideClearButton: x,
  isVisible: C,
  onOpen: S,
  onClose: N,
  openedOnInit: $ = !1,
  clearSearchAfterSelection: w = !0,
  onSelect: f,
  placement: v,
  floatingStrategy: E,
  root: D,
  useDismissHookProps: B,
  useClickHookProps: M,
  virtuosoProps: I,
  inputProps: P,
  noDataFallbackText: A = "No data",
  ...F
}) => {
  const [R, U] = b.useState($), [ge, oe] = b.useState(!1), se = C !== void 0, Q = se ? C : R, K = b.useRef(null), { readOnly: he } = Tt(), Ve = he || P?.readOnly, We = (ft, lo) => {
    ft ? !Q && S?.(lo) : Q && N?.(lo), !se && U(ft);
  }, {
    selectedKeys: it,
    items: G,
    searchPhrase: fe,
    handleSelect: be,
    handleOnFilter: _a,
    handleItemRemove: la,
    handleClear: Bt
  } = G_({
    selected: d,
    options: n,
    type: p,
    selectAllOptionText: y,
    onSelect: f,
    setOpen: We,
    clearSearchAfterSelection: w,
    inputRef: K
  }), {
    context: z,
    nodeId: Ht,
    getReferenceProps: Uo,
    setReference: Lo,
    getFloatingProps: qo,
    getItemProps: Ho,
    setFloating: zo,
    floatingStyles: Vo,
    listElementsRef: Wo,
    virtualItemRef: Ko,
    activeIndex: Yo,
    maxHeight: Xo,
    setPointer: Zo,
    isPositioned: jo
  } = F_({
    disabled: l,
    items: G,
    placement: v,
    minListHeight: r,
    maxListHeight: _,
    floatingStrategy: E,
    useClickHookProps: M,
    useDismissHookProps: B,
    isOpen: Q,
    onVisibilityChange: We,
    searchPhrase: fe
  });
  return Ve ? /* @__PURE__ */ t(
    va,
    {
      value: d?.map((ft) => ft.groupHeader ? null : ft.name).filter(Boolean).join(", "),
      noDataFallbackText: A
    }
  ) : /* @__PURE__ */ g("div", { id: e, className: c(Yn["picker-wrapper"], a), children: [
    /* @__PURE__ */ t(
      Un,
      {
        getReferenceProps: Uo,
        setReference: Lo,
        testId: F["data-testid"],
        isItemSelected: it.length > 0,
        isOpen: Q,
        onClear: Bt,
        hideClearButton: x,
        isDisabled: l,
        isError: i,
        isRequired: m,
        isMultiSelect: p === "multi",
        size: u,
        setTriggerFocus: oe,
        onToggle: () => We(!Q),
        children: /* @__PURE__ */ t(
          Wn,
          {
            isOpen: Q,
            isSearchDisabled: k,
            isDisabled: l,
            placeholder: s,
            selectedItems: d,
            type: p,
            size: u,
            clearSearchAfterSelection: w,
            inputRef: K,
            onItemRemove: la,
            onSelect: be,
            onFilter: _a,
            onClear: Bt,
            searchPhrase: fe,
            virtualItemRef: Ko,
            isTriggerFocused: ge,
            inputProps: P
          }
        )
      }
    ),
    /* @__PURE__ */ t(ba, { id: Ht, children: Q && /* @__PURE__ */ t(ha, { root: D, children: /* @__PURE__ */ t(
      M_,
      {
        pickerType: p,
        options: G,
        listClassName: o,
        context: z,
        setFloating: zo,
        floatingStyles: Vo,
        maxHeight: Xo,
        activeIndex: Yo,
        selectedKeys: it,
        listElementsRef: Wo,
        searchDisabled: k,
        isPositioned: jo,
        onItemRemove: la,
        setPointer: Zo,
        onSelect: be,
        getFloatingProps: qo,
        getItemProps: Ho,
        emptyStateText: h,
        virtuosoProps: I
      }
    ) }) })
  ] });
}, Xn = (e) => e !== void 0 && typeof e[0] == "string", Zn = (e) => e.map((a) => ({ name: a, key: a })), jn = (e) => e.map(({ customElement: a, name: o, ...r }) => ({
  name: o,
  key: o,
  ...a && {
    customElement: {
      listItemBody: a,
      selectedItemBody: /* @__PURE__ */ t(W, {})
    }
  },
  ...r
})), Jn = (e, a, o, r) => {
  const _ = e.length === 1 && e[0].name === r, l = a ? e.slice(0, 1) : e;
  return o && _ ? [] : l;
}, gu = b.forwardRef(
  ({
    disabled: e,
    minListHeight: a = O_,
    maxListHeight: o = P_,
    autocompleteOpenOnInit: r = !1,
    placement: _,
    options: l,
    readOnly: i,
    floatingStrategy: n,
    single: d,
    alwaysShowAllOptions: u,
    hideIfExactMatch: s = !0,
    noDataFallbackText: m = "No data",
    ...h
  }, y) => {
    const p = b.useRef(null), { readOnly: k } = Tt(), x = k || i;
    b.useImperativeHandle(y, () => p.current, []);
    const [C, S] = b.useState(""), $ = h.value !== void 0 ? h.value : C, [w, f] = b.useState(
      r
    ), v = (z) => {
      f(z);
    }, E = (z) => {
      F(z);
    }, D = (z) => {
      h.onChange?.(z), S(z.target.value), u || E(z.target.value), p.current?.focus();
    }, B = (z) => {
      const Ht = z.key === "Enter";
      be.current?.id && Ht && (M([{ key: be.current?.id }]), z.preventDefault()), Ht || v(!0), h.onKeyDown?.(z);
    }, M = (z) => {
      if (z) {
        const Ht = z[0].key;
        D({
          target: { value: Ht }
        }), setTimeout(() => {
          v(!1);
        }, 0);
      }
    }, I = b.useMemo(() => l ? Xn(l) ? Zn(l) : jn(l) : [], [l]), { items: P, searchPhrase: A, handleOnFilter: F, handleSelect: R, selectedKeys: U } = G_({
      selected: [],
      options: I,
      type: "single",
      onSelect: M,
      setOpen: f,
      clearSearchAfterSelection: !0,
      inputRef: p
    }), ge = Jn(
      P,
      d || !1,
      s || !1,
      $?.toString() || ""
    ), {
      nodeId: oe,
      context: se,
      setFloating: Q,
      getReferenceProps: K,
      getItemProps: he,
      getFloatingProps: Ve,
      floatingStyles: We,
      maxHeight: it,
      setPointer: G,
      setReference: fe,
      virtualItemRef: be,
      listElementsRef: _a,
      activeIndex: la,
      isPositioned: Bt
    } = F_({
      disabled: e || i,
      items: P,
      searchPhrase: u ? "" : A,
      isOpen: w,
      onVisibilityChange: v,
      minListHeight: a,
      maxListHeight: o,
      placement: _,
      floatingStrategy: n
    });
    return x ? /* @__PURE__ */ t(
      va,
      {
        value: $?.toString(),
        noDataFallbackText: m
      }
    ) : /* @__PURE__ */ g("div", { ref: fe, ...K(), children: [
      /* @__PURE__ */ t(
        fn,
        {
          ...h,
          ref: p,
          onChange: D,
          onKeyDown: B,
          value: $,
          disabled: e,
          readOnly: i,
          type: "text"
        }
      ),
      /* @__PURE__ */ t(ba, { id: oe, children: w && /* @__PURE__ */ t(ha, { children: /* @__PURE__ */ t(
        M_,
        {
          context: se,
          options: ge,
          setFloating: Q,
          getFloatingProps: Ve,
          floatingStyles: We,
          maxHeight: it,
          listElementsRef: _a,
          activeIndex: la,
          selectedKeys: U,
          setPointer: G,
          hideWhenEmpty: !0,
          getItemProps: he,
          onSelect: R,
          isPositioned: Bt,
          searchDisabled: !1,
          onItemRemove: Za
        }
      ) }) })
    ] });
  }
), Qn = "lc-SegmentedControl-module__btn___pG309", ho = {
  "segmented-control": "lc-SegmentedControl-module__segmented-control___v3EXg",
  btn: Qn,
  "btn--active": "lc-SegmentedControl-module__btn--active___n93GT",
  "btn--compact": "lc-SegmentedControl-module__btn--compact___grlBl",
  "btn--medium": "lc-SegmentedControl-module__btn--medium___YGzgQ",
  "btn--large": "lc-SegmentedControl-module__btn--large___DCJ-p"
}, ec = "segmented-control", hu = ({
  size: e = "medium",
  buttons: a,
  className: o,
  initialId: r,
  currentId: _,
  fullWidth: l = !1,
  onButtonClick: i = Za
}) => {
  const n = c(ho[ec], o), [d, u] = b.useState(() => r), s = typeof _ == "string";
  b.useEffect(() => {
    s && u(_);
  }, [_]);
  const m = (y, p) => {
    s || u(y), i(y, p);
  }, h = a.map(({ id: y, label: p, loading: k, disabled: x, icon: C }) => {
    const S = y === d, N = S ? ho["btn--active"] : "";
    return /* @__PURE__ */ t(
      L,
      {
        fullWidth: l,
        loading: S ? !1 : k,
        disabled: x,
        "aria-pressed": S,
        kind: "secondary",
        icon: C,
        className: c(ho.btn, ho[`btn--${e}`], N),
        onClick: (w) => {
          m(y, w);
        },
        children: p
      },
      y
    );
  });
  return /* @__PURE__ */ t("div", { role: "group", className: n, children: h });
}, tc = "lc-Card-module__card___LzN-3", ac = "lc-Card-module__card__header___SRONR", oc = "lc-Card-module__card__header__image___93pD4", rc = "lc-Card-module__card__header__heading___jK55U", _c = "lc-Card-module__card__header__heading__title___5090w", lc = "lc-Card-module__card__header__heading__description___iVYoq", ic = "lc-Card-module__card__content___9G1YM", nc = "lc-Card-module__card__actions___gp-xf", cc = "lc-Card-module__card__actions__line___C6TI0", sc = "lc-Card-module__card__actions__buttons___XJlFJ", Le = {
  card: tc,
  card__header: ac,
  card__header__image: oc,
  card__header__heading: rc,
  card__header__heading__title: _c,
  card__header__heading__description: lc,
  "card__header__no-image": "lc-Card-module__card__header__no-image___2gPx6",
  card__content: ic,
  "card__expanded-content": "lc-Card-module__card__expanded-content___WBjEn",
  card__actions: nc,
  card__actions__line: cc,
  card__actions__buttons: sc,
  "card__actions__buttons-expander": "lc-Card-module__card__actions__buttons-expander___I--MQ"
}, Ka = "card", Ao = `${Ka}__header`, Jo = `${Ao}__heading`, fo = `${Ka}__actions`, dc = `${Ao}__no-image`, fu = ({
  alt: e,
  buttonsOptions: a = [],
  children: o,
  className: r,
  description: _,
  expandableContent: l,
  src: i,
  title: n,
  ...d
}) => {
  const [u, s] = b.useState(!1), m = u ? ja : Xt, h = u ? "Hide" : "Show more", y = a?.length > 0, p = !!l, k = y || p, x = n, C = i, S = C ? "" : Le[dc];
  return /* @__PURE__ */ g("div", { className: c(Le[Ka], r), ...d, children: [
    x && /* @__PURE__ */ g("div", { className: c(Le[Ao], S), children: [
      C && /* @__PURE__ */ t(
        "img",
        {
          alt: e,
          className: Le[`${Ao}__image`],
          src: i
        }
      ),
      /* @__PURE__ */ g("div", { className: Le[Jo], children: [
        /* @__PURE__ */ t(ce, { size: "xs", className: Le[`${Jo}__title`], children: n }),
        _ && /* @__PURE__ */ t(
          T,
          {
            size: "sm",
            className: Le[`${Jo}__description`],
            children: _
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ t(T, { as: "div", size: "md", className: Le[`${Ka}__content`], children: o }),
    u && /* @__PURE__ */ t(
      T,
      {
        as: "div",
        size: "md",
        className: Le[`${Ka}__expanded-content`],
        children: l
      }
    ),
    k && /* @__PURE__ */ g("div", { className: Le[fo], children: [
      /* @__PURE__ */ t("div", { className: Le[`${fo}__line`] }),
      /* @__PURE__ */ g("div", { className: Le[`${fo}__buttons`], children: [
        y && a.map(
          ({ kind: N, onClick: $, children: w }, f) => /* @__PURE__ */ t(
            L,
            {
              size: "compact",
              kind: N,
              onClick: $,
              children: w
            },
            f
          )
        ),
        p && /* @__PURE__ */ t(
          L,
          {
            className: Le[`${fo}__buttons-expander`],
            kind: "link",
            iconPosition: "right",
            icon: /* @__PURE__ */ t(O, { source: m }),
            onClick: () => s(!u),
            children: h
          }
        )
      ] })
    ] })
  ] });
}, Qo = {
  "date-picker-custom-navigation": "lc-DatePickerCustomNavigation-module__date-picker-custom-navigation___B7uEJ"
}, er = "date-picker-custom-navigation", uc = ({ currentMonth: e, setMonth: a, startMonth: o, endMonth: r, numberOfMonths: _ }) => {
  const l = o && Wa(e, o), i = r && Wa(e, r), n = () => {
    const m = new Date(e);
    m.setMonth(e.getMonth() - 1), a(m);
  }, d = () => {
    const m = new Date(e);
    m.setMonth(e.getMonth() + 1), a(m);
  }, u = () => {
    if (!o) {
      const y = ta(e, 12);
      return a(y);
    }
    const m = Math.abs(Or(e, o)), h = ta(
      e,
      !Number.isNaN(m) && m > 12 ? 12 : m
    );
    return a(h);
  }, s = () => {
    if (!r) {
      const y = Pr(e, 12);
      return a(y);
    }
    const m = Math.abs(Or(r, e)), h = Pr(
      e,
      !Number.isNaN(m) && m > 12 ? 12 : m
    );
    return _ === 2 && Wa(h, r) ? a(ta(h, 1)) : a(h);
  };
  return /* @__PURE__ */ g("div", { className: Qo[er], children: [
    /* @__PURE__ */ g("div", { className: Qo[`${er}__nav-wrapper`], children: [
      /* @__PURE__ */ t(
        L,
        {
          "data-testid": "date-picker-prev-year-button",
          kind: "plain",
          size: "xcompact",
          icon: /* @__PURE__ */ t(O, { source: ol }),
          onClick: u,
          disabled: l
        }
      ),
      /* @__PURE__ */ t(
        L,
        {
          "data-testid": "date-picker-prev-month-button",
          kind: "plain",
          size: "xcompact",
          icon: /* @__PURE__ */ t(O, { source: rl }),
          onClick: n,
          disabled: l
        }
      )
    ] }),
    /* @__PURE__ */ g("div", { className: Qo[`${er}__nav-wrapper`], children: [
      /* @__PURE__ */ t(
        L,
        {
          "data-testid": "date-picker-next-month-button",
          kind: "plain",
          size: "xcompact",
          icon: /* @__PURE__ */ t(O, { source: Do }),
          onClick: d,
          disabled: i
        }
      ),
      /* @__PURE__ */ t(
        L,
        {
          "data-testid": "date-picker-next-year-button",
          kind: "plain",
          size: "xcompact",
          icon: /* @__PURE__ */ t(O, { source: _l }),
          onClick: s,
          disabled: i
        }
      )
    ] })
  ] });
}, U_ = (e, a) => {
  const { from: o, to: r } = a;
  return !(r && !vr(e, r) && yr(e, r) || o && !vr(e, o) && !yr(e, o));
}, L_ = (e, a, o) => a ? e && !Wa(e, a) || o && Wa(a, o) ? ta(a, 1) : a : ta(o || /* @__PURE__ */ new Date(), 1), za = (e, a) => {
  const o = a?.find((r) => r.id === e);
  return o || void 0;
}, jr = (e, a) => !!(!e || e && a), mc = (e) => {
  const a = {};
  if (!e.initialSelectedItemKey)
    return a;
  const o = za(
    e.initialSelectedItemKey,
    e.options
  );
  return o ? (a.selectedItem = e.initialSelectedItemKey, o.isManual && (e.initialFromDate && (a.from = e.initialFromDate), e.initialToDate && (a.to = e.initialToDate, a.temporaryTo = e.initialToDate)), a) : {};
}, Pe = {
  "date-picker": "lc-DatePicker-module__date-picker___MOZFY",
  "date-picker__wrapper": "lc-DatePicker-module__date-picker__wrapper___aOFS3",
  "date-picker__weekday": "lc-DatePicker-module__date-picker__weekday___bdNjp",
  "date-picker__day": "lc-DatePicker-module__date-picker__day___L1YZn",
  "date-picker__day-button": "lc-DatePicker-module__date-picker__day-button___vy3Hd",
  "date-picker__today": "lc-DatePicker-module__date-picker__today___w404B",
  "date-picker__selected": "lc-DatePicker-module__date-picker__selected___FEDMB",
  "date-picker__month-caption": "lc-DatePicker-module__date-picker__month-caption___lMrSe",
  "date-picker__range-start": "lc-DatePicker-module__date-picker__range-start___-VnVk",
  "date-picker__range-middle": "lc-DatePicker-module__date-picker__range-middle___Xvj7k",
  "date-picker__range-end": "lc-DatePicker-module__date-picker__range-end___ux1xQ",
  "date-picker__disabled": "lc-DatePicker-module__date-picker__disabled___A8sSm"
}, qe = "date-picker", pc = ({
  month: e,
  weekStartsOn: a = 1,
  fromMonth: o,
  startMonth: r,
  toMonth: _,
  endMonth: l,
  onMonthChange: i,
  ...n
}) => {
  const [d, u] = b.useState(e || /* @__PURE__ */ new Date());
  b.useEffect(() => {
    e && e !== d && u(e);
  }, [e, d]), b.useEffect(() => {
    _ && e !== d && (U_(d, { from: o, to: _ }) || u(_));
  }, [e, d, _, o]);
  const s = b.useCallback(
    (m) => {
      if (i) {
        i(m);
        return;
      }
      u(m);
    },
    [e, i]
  );
  return /* @__PURE__ */ t("div", { className: Pe[`${qe}`], children: /* @__PURE__ */ t(
    Ll,
    {
      classNames: {
        weekday: c(
          Pe[`${qe}__wrapper`],
          Pe[`${qe}__weekday`]
        ),
        day: c(Pe[`${qe}__wrapper`], Pe[`${qe}__day`]),
        day_button: c(Pe[`${qe}__day-button`]),
        today: c(Pe[`${qe}__today`]),
        selected: c(Pe[`${qe}__selected`]),
        month_caption: c(Pe[`${qe}__month-caption`]),
        range_start: c(Pe[`${qe}__range-start`]),
        range_middle: c(Pe[`${qe}__range-middle`]),
        range_end: c(Pe[`${qe}__range-end`]),
        disabled: c(Pe[`${qe}__disabled`])
      },
      onMonthChange: s,
      month: d,
      components: {
        CaptionLabel: ({ children: m }) => /* @__PURE__ */ t(T, { as: "span", bold: !0, children: m }),
        Nav: () => /* @__PURE__ */ t(
          uc,
          {
            currentMonth: d,
            setMonth: s,
            startMonth: r || o,
            endMonth: l || _
          }
        )
      },
      startMonth: r || o,
      endMonth: l || _,
      weekStartsOn: a,
      ...n
    }
  ) });
};
var H = /* @__PURE__ */ ((e) => (e.NEW_SELECTED_ITEM = "NEW_SELECTED_ITEM", e.NEW_TEMPORARY_FROM_VALUE = "NEW_TEMPORARY_FROM_VALUE", e.NEW_TEMPORARY_TO_VALUE = "NEW_TEMPORARY_TO_VALUE", e.CLEAR = "CLEAR", e.SET_FROM = "SET_FROM", e.SET_TO = "SET_TO", e.SELECT_FIRST_DAY = "SELECT_FIRST_DAY", e.SELECT_SECOND_DAY_AS_FROM = "SELECT_SECOND_DAY_AS_FROM", e.SELECT_SECOND_DAY_AS_TO = "SELECT_SECOND_DAY_AS_TO", e.CURRENT_MONTH_CHANGE = "CURRENT_MONTH_CHANGE", e.SET_CUSTOM_TEMP_RANGE = "SET_CUSTOM_TEMP_RANGE", e))(H || {});
const gc = (e) => {
  const a = L_(
    e.initialFromDate,
    e.initialToDate,
    e.toMonth
  ), r = {
    ...{
      selectedItem: null,
      from: void 0,
      to: void 0,
      temporaryTo: void 0,
      currentMonth: a,
      customTempFrom: void 0,
      customTempTo: void 0
    },
    ...mc(e)
  };
  function _(l, i) {
    switch (i.type) {
      case H.NEW_SELECTED_ITEM:
        return {
          selectedItem: i.payload.selectedItem,
          from: void 0,
          to: void 0,
          temporaryTo: void 0,
          currentMonth: a
        };
      case H.NEW_TEMPORARY_FROM_VALUE:
        return {
          ...l,
          temporaryFrom: i.payload.date
        };
      case H.NEW_TEMPORARY_TO_VALUE:
        return {
          ...l,
          temporaryTo: i.payload.date
        };
      case H.SELECT_FIRST_DAY:
        return {
          ...l,
          from: i.payload.date,
          to: void 0,
          temporaryFrom: void 0,
          temporaryTo: void 0,
          customTempFrom: void 0,
          customTempTo: void 0
        };
      case H.SELECT_SECOND_DAY_AS_FROM:
        return {
          ...l,
          from: i.payload.date,
          to: l.from,
          temporaryTo: l.from
        };
      case H.SELECT_SECOND_DAY_AS_TO:
        return {
          ...l,
          to: i.payload.date,
          temporaryTo: i.payload.date
        };
      case H.CURRENT_MONTH_CHANGE:
        return {
          ...l,
          currentMonth: i.payload.date
        };
      case H.SET_FROM:
        return {
          ...l,
          from: i.payload.date
        };
      case H.SET_TO:
        return {
          ...l,
          to: i.payload.date
        };
      case H.SET_CUSTOM_TEMP_RANGE:
        return {
          ...l,
          customTempFrom: i.payload.customTempFrom,
          customTempTo: i.payload.customTempTo
        };
      default:
        return l;
    }
  }
  return J_(_, r);
}, q_ = ({
  options: e,
  initialSelectedItemKey: a,
  initialFromDate: o,
  initialToDate: r,
  customTempFromDate: _,
  customTempToDate: l,
  toMonth: i,
  today: n,
  onChange: d,
  onRangeSelect: u,
  onSelect: s,
  onCustomTempDateRangeChange: m,
  children: h
}) => {
  const y = qt(
    a || null
  ), [p, k] = gc({
    initialFromDate: o,
    initialToDate: r,
    toMonth: i,
    options: e,
    initialSelectedItemKey: a
  });
  q(() => {
    k({
      type: H.SET_CUSTOM_TEMP_RANGE,
      payload: {
        customTempFrom: _,
        customTempTo: l
      }
    });
  }, [_, l]), q(() => {
    k({
      type: H.SET_FROM,
      payload: { date: o }
    });
  }, [o]), q(() => {
    k({
      type: H.SET_TO,
      payload: { date: r }
    });
  }, [r]), q(() => {
    const f = L_(
      o,
      r,
      i
    );
    k({
      type: H.CURRENT_MONTH_CHANGE,
      payload: { date: f }
    });
  }, [i, o, r]), q(() => {
    const { from: f, selectedItem: v, to: E } = p;
    if (!(f && E))
      return;
    const D = za(v, e);
    D && d?.({
      ...D,
      value: {
        from: f,
        to: E
      }
    });
  }, [p.from, p.to, p.selectedItem, e, d]), q(() => {
    const { from: f, to: v } = p;
    !(f && v) || !u || u?.({
      from: f,
      to: v
    });
  }, [p.from, p.to, u]), q(() => {
    const { selectedItem: f } = p;
    if (f === y.current || !e)
      return;
    if (!f) {
      d?.(null);
      return;
    }
    if (!za(f, e))
      return;
    const E = e.reduce(
      (D, B) => ({ ...D, [B.id]: B }),
      {}
    );
    d?.(E[f]);
  }, [d, p.selectedItem, e]), q(() => {
    m?.({
      from: p.temporaryFrom,
      to: p.temporaryTo
    });
  }, [p.temporaryFrom, p.temporaryTo]);
  const x = ht(() => {
    const { from: f, to: v } = p;
    f && v && s && s({
      from: f,
      to: v
    });
  }, [s]), C = ht(
    (f) => {
      const { from: v, to: E } = p, D = i ? v_(i, f) >= 0 : !0;
      v && !jr(v, E) && D && (ql(f, v) ? (k({
        type: H.NEW_TEMPORARY_FROM_VALUE,
        payload: { date: f }
      }), k({
        type: H.NEW_TEMPORARY_TO_VALUE,
        payload: { date: v }
      })) : (k({
        type: H.NEW_TEMPORARY_TO_VALUE,
        payload: { date: f }
      }), k({
        type: H.NEW_TEMPORARY_FROM_VALUE,
        payload: { date: v }
      })));
    },
    [i, p.from, p.to]
  ), S = ht(
    (f) => {
      const { from: v, to: E } = p;
      U_(f, { to: i }) && (jr(v, E) ? (k({
        type: H.SELECT_FIRST_DAY,
        payload: { date: f }
      }), k({
        type: H.NEW_TEMPORARY_FROM_VALUE,
        payload: { date: f }
      }), k({
        type: H.NEW_TEMPORARY_TO_VALUE,
        payload: { date: f }
      })) : v && vr(f, v) || v && yr(f, v) ? k({
        type: H.SELECT_SECOND_DAY_AS_TO,
        payload: { date: f }
      }) : k({
        type: H.SELECT_SECOND_DAY_AS_FROM,
        payload: { date: f }
      }));
    },
    [i, p.from, p.to]
  ), N = ht(
    (f) => {
      if (f === null) {
        k({
          type: H.NEW_SELECTED_ITEM,
          payload: { selectedItem: null }
        });
        return;
      }
      za(f, e) && k({
        type: H.NEW_SELECTED_ITEM,
        payload: { selectedItem: f }
      });
    },
    [e]
  ), $ = ht((f) => {
    k({
      type: H.CURRENT_MONTH_CHANGE,
      payload: { date: f }
    });
  }, []);
  return h((() => {
    const {
      currentMonth: f,
      from: v,
      selectedItem: E,
      temporaryFrom: D,
      temporaryTo: B,
      to: M,
      customTempFrom: I,
      customTempTo: P
    } = p, A = pa(() => za(E, e), [e, E]), F = pa(() => ({ from: D || v, to: B }), [v, D, B]), R = pa(() => {
      if (!(!I || !P))
        return { from: I, to: P };
    }, [I, P]), U = pa(() => i ? { after: i } : void 0, [i]);
    return {
      select: {
        onItemSelect: N,
        selected: E || ""
      },
      inputs: {
        fromDate: v,
        toDate: M
      },
      datepicker: {
        mode: "range",
        month: f,
        numberOfMonths: 2,
        onDayClick: S,
        selected: R || F,
        endMonth: i,
        disabled: U,
        today: n,
        onDayMouseEnter: C,
        onMonthChange: $,
        onSelect: x
      },
      selectedOption: A
    };
  })());
};
q_.defaultProps = {
  options: [
    {
      id: "default",
      label: "Default option",
      isManual: !0,
      value: {
        from: void 0,
        to: void 0
      }
    }
  ]
};
const bu = (e) => {
  const { className: a, children: o, ...r } = e, _ = c(
    a,
    Pe["date-picker--range__calendars-wrapper"]
  );
  return /* @__PURE__ */ t("div", { ...r, className: _, children: o });
}, Y = {
  "details-card": "lc-DetailsCard-module__details-card___v-Avc",
  "details-card__button--fading": "lc-DetailsCard-module__details-card__button--fading___LlMMo",
  "details-card--with-divider": "lc-DetailsCard-module__details-card--with-divider___AhDnH",
  "details-card__label-wrapper": "lc-DetailsCard-module__details-card__label-wrapper___r70F3",
  "details-card__label-wrapper--hide": "lc-DetailsCard-module__details-card__label-wrapper--hide___Nz6ap",
  "details-card__label-wrapper--fading": "lc-DetailsCard-module__details-card__label-wrapper--fading___gPYF3",
  "details-card__label": "lc-DetailsCard-module__details-card__label___4cvW8",
  "details-card__label--with-margin": "lc-DetailsCard-module__details-card__label--with-margin___3bSuV",
  "details-card__label__left-node": "lc-DetailsCard-module__details-card__label__left-node___Vpq-P",
  "details-card__label__right-node": "lc-DetailsCard-module__details-card__label__right-node___640HC",
  "details-card__label__content": "lc-DetailsCard-module__details-card__label__content___iMTpo",
  "details-card__button": "lc-DetailsCard-module__details-card__button___x6Yex",
  "details-card__button--closed": "lc-DetailsCard-module__details-card__button--closed___4sjdi",
  "details-card__button__icon": "lc-DetailsCard-module__details-card__button__icon___clN8y",
  "details-card__button__icon--open": "lc-DetailsCard-module__details-card__button__icon--open___IU-Rk",
  "details-card__content-wrapper": "lc-DetailsCard-module__details-card__content-wrapper___6U9cE",
  "details-card__content-wrapper--open": "lc-DetailsCard-module__details-card__content-wrapper--open___n-ZsY",
  "details-card__content": "lc-DetailsCard-module__details-card__content___aJux3",
  "details-card__content--spacing": "lc-DetailsCard-module__details-card__content--spacing___F17pU",
  "details-card__content--full-space": "lc-DetailsCard-module__details-card__content--full-space___8CLFw"
}, X = "details-card", hc = ["input", "button", "select", "textarea", "a"], vu = ({
  children: e,
  className: a,
  leftNode: o,
  rightNode: r,
  label: _,
  withDivider: l,
  fullSpaceContent: i,
  openOnInit: n = !1,
  hideLabelOnOpen: d,
  onClick: u
}) => {
  const [s, m] = b.useState(n), [h, y] = b.useState(0), p = b.useRef(null), k = c(
    Y[X],
    l && Y[`${X}--with-divider`],
    a
  ), x = d && s, C = typeof _ == "string", S = ($) => {
    m((w) => !w), $.currentTarget.blur(), u?.($);
  }, N = ($) => {
    const f = $.target.tagName.toLowerCase();
    hc.includes(f) || (m((v) => !v), u?.($));
  };
  return b.useEffect(() => {
    const $ = !!window.IntersectionObserver;
    if (p.current && $) {
      const w = new ResizeObserver(() => {
        p.current && h !== p.current.offsetHeight && y(p.current.offsetHeight);
      });
      return w.observe(p.current), () => w.disconnect();
    }
  }, [p]), /* @__PURE__ */ g("div", { className: k, children: [
    /* @__PURE__ */ t(
      "div",
      {
        className: c(
          Y[`${X}__label-wrapper`],
          d && Y[`${X}__label-wrapper--fading`],
          x && Y[`${X}__label-wrapper--hide`],
          s && Y[`${X}__label-wrapper--open`]
        ),
        "aria-expanded": s,
        "aria-hidden": x,
        "data-testid": "details-card-label",
        onClick: N,
        children: /* @__PURE__ */ g(
          "div",
          {
            className: c(
              Y[`${X}__label`],
              d && Y[`${X}__label--with-margin`]
            ),
            children: [
              o && /* @__PURE__ */ t("div", { className: Y[`${X}__label__left-node`], children: o }),
              C ? /* @__PURE__ */ t(
                ce,
                {
                  size: "xs",
                  className: Y[`${X}__label__content`],
                  children: _
                }
              ) : /* @__PURE__ */ t("div", { className: Y[`${X}__label__content`], children: _ }),
              r && /* @__PURE__ */ t("div", { className: Y[`${X}__label__right-node`], children: r })
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ t(
      L,
      {
        kind: s && d ? "float" : "text",
        icon: /* @__PURE__ */ t(
          O,
          {
            source: Do,
            className: c(
              Y[`${X}__button__icon`],
              s && Y[`${X}__button__icon--open`]
            )
          }
        ),
        className: c(
          Y[`${X}__button`],
          !s && Y[`${X}__button--closed`],
          s && Y[`${X}__button--open`],
          d && Y[`${X}__button--fading`]
        ),
        onClick: S,
        "aria-expanded": s
      }
    ),
    /* @__PURE__ */ t("div", { children: /* @__PURE__ */ t(
      "div",
      {
        className: c(
          Y[`${X}__content-wrapper`],
          s && Y[`${X}__content-wrapper--open`]
        ),
        style: {
          maxHeight: s ? h : 0
        },
        children: /* @__PURE__ */ t(
          "div",
          {
            ref: p,
            className: c(
              Y[`${X}__content`],
              i && Y[`${X}__content--full-space`],
              d && Y[`${X}__content--spacing`]
            ),
            children: e
          }
        )
      }
    ) })
  ] });
}, tr = {
  "details-card-info": "lc-DetailsCardInfo-module__details-card-info___22mOK",
  "details-card-info__label": "lc-DetailsCardInfo-module__details-card-info__label___LXTXh",
  "details-card-info__content": "lc-DetailsCardInfo-module__details-card-info__content___03cfr"
}, ar = "details-card-info", yu = ({ children: e, label: a }) => /* @__PURE__ */ g("div", { className: tr[ar], children: [
  /* @__PURE__ */ t("div", { className: tr[`${ar}__label`], children: a }),
  /* @__PURE__ */ t("div", { className: tr[`${ar}__content`], children: e })
] }), wt = {
  "empty-state": "lc-EmptyState-module__empty-state___vtzjl",
  "empty-state--centered": "lc-EmptyState-module__empty-state--centered___NW4Cb",
  "empty-state--inline": "lc-EmptyState-module__empty-state--inline___GJs59",
  "empty-state--full": "lc-EmptyState-module__empty-state--full___SrQt1",
  "empty-state__image": "lc-EmptyState-module__empty-state__image___-Sl-v",
  "empty-state__icon--full": "lc-EmptyState-module__empty-state__icon--full___vYFVG",
  "empty-state__description": "lc-EmptyState-module__empty-state__description___cMfKv",
  "empty-state__content-inline": "lc-EmptyState-module__empty-state__content-inline___gCYVX",
  "empty-state__title": "lc-EmptyState-module__empty-state__title___JSD4P",
  "empty-state__actions": "lc-EmptyState-module__empty-state__actions___gnEFS",
  "empty-state__actions--inline": "lc-EmptyState-module__empty-state__actions--inline___OuON7"
}, $t = "empty-state", ku = ({
  type: e = "full",
  image: a,
  icon: o,
  title: r,
  description: _,
  actions: l,
  centered: i = !1
}) => /* @__PURE__ */ g(
  "div",
  {
    className: c(
      wt[$t],
      wt[`${$t}--${e}`],
      i && wt[`${$t}--centered`]
    ),
    children: [
      a && /* @__PURE__ */ t(
        "img",
        {
          className: wt[`${$t}__image`],
          src: a,
          alt: r
        }
      ),
      e === "inline" ? /* @__PURE__ */ g("div", { className: wt[`${$t}__content-inline`], children: [
        o && /* @__PURE__ */ t(Lr, { "data-testid": "icon", children: o }),
        /* @__PURE__ */ t(T, { noMargin: !0, children: r })
      ] }) : /* @__PURE__ */ g(W, { children: [
        o && /* @__PURE__ */ t(
          Lr,
          {
            className: wt[`${$t}__icon--${e}`],
            "data-testid": "icon",
            children: o
          }
        ),
        /* @__PURE__ */ t(ce, { className: wt[`${$t}__title`], children: r })
      ] }),
      e === "full" && _ && /* @__PURE__ */ t(T, { noMargin: !0, className: wt[`${$t}__description`], children: _ }),
      l && /* @__PURE__ */ t(
        "div",
        {
          className: c(
            wt[`${$t}__actions`],
            wt[`${$t}__actions--${e}`]
          ),
          children: l
        }
      )
    ]
  }
), Jr = {
  "field-error": "lc-FieldError-module__field-error___-rtI3",
  "field-error__icon": "lc-FieldError-module__field-error__icon___4KpOc"
}, Qr = "field-error", Ir = ({
  children: e,
  className: a = "",
  ...o
}) => {
  const r = c(Jr[Qr], a);
  return /* @__PURE__ */ g(T, { as: "span", size: "sm", ...o, className: r, children: [
    /* @__PURE__ */ t(
      O,
      {
        source: h_,
        className: Jr[`${Qr}__icon`],
        size: "small"
      }
    ),
    e
  ] });
}, or = {
  "field-group": "lc-FieldGroup-module__field-group___--i2x",
  "field-group--inline": "lc-FieldGroup-module__field-group--inline___iSg4S",
  "field-group--stretched": "lc-FieldGroup-module__field-group--stretched___4Evlw"
}, rr = "field-group", Cu = ({
  className: e = "",
  children: a,
  description: o,
  error: r,
  inline: _,
  stretch: l,
  ...i
}) => {
  const n = c(or[rr], e, {
    [or[`${rr}--inline`]]: _,
    [or[`${rr}--stretched`]]: l
  });
  return /* @__PURE__ */ g("div", { ...i, className: n, children: [
    a,
    r && /* @__PURE__ */ t(Ir, { children: r }),
    o && /* @__PURE__ */ t(Fo, { children: o })
  ] });
}, fc = "lc-Form-module__form___ddwfw", bc = "lc-Form-module__form__header___mr4AX", vc = "lc-Form-module__form__footer___NJUBH", yc = "lc-Form-module__form__label___2hAXA", kc = "lc-Form-module__form__helper___r1lJG", Ea = {
  form: fc,
  form__header: bc,
  form__footer: vc,
  form__label: yc,
  form__helper: kc
}, Ta = "form", wu = ({
  className: e,
  children: a,
  labelText: o,
  helperText: r,
  formFooter: _,
  ...l
}) => /* @__PURE__ */ g("form", { className: c(Ea[Ta], e), ...l, children: [
  (o || r) && /* @__PURE__ */ g("div", { className: Ea[`${Ta}__header`], children: [
    o && /* @__PURE__ */ t(ce, { size: "sm", className: Ea[`${Ta}__label`], children: o }),
    r && /* @__PURE__ */ t(T, { as: "p", size: "sm", className: Ea[`${Ta}__helper`], children: r })
  ] }),
  a,
  _ && /* @__PURE__ */ t("div", { className: Ea[`${Ta}__footer`], children: _ })
] }), re = {
  "form-field": "lc-FormField-module__form-field___kx7Vx",
  "form-field--inline": "lc-FormField-module__form-field--inline___1xuhX",
  "form-field__wrapper--inline": "lc-FormField-module__form-field__wrapper--inline___MPvG-",
  "form-field__label": "lc-FormField-module__form-field__label___xZ4Qz",
  "form-field__label--inline": "lc-FormField-module__form-field__label--inline___x9AUt",
  "form-field__label--no-text": "lc-FormField-module__form-field__label--no-text___h2VqV",
  "form-field__label-wrapper": "lc-FormField-module__form-field__label-wrapper___O1XAl",
  "form-field__label-wrapper--inline": "lc-FormField-module__form-field__label-wrapper--inline___5hqdR",
  "form-field__label-adornment": "lc-FormField-module__form-field__label-adornment___4uieF",
  "form-field__label-adornment--inline": "lc-FormField-module__form-field__label-adornment--inline___Uj4Y6",
  "form-field__label-left-node": "lc-FormField-module__form-field__label-left-node___XWg6l",
  "form-field__label-left-node--read-only": "lc-FormField-module__form-field__label-left-node--read-only___WnnjA",
  "form-field__label-right-node": "lc-FormField-module__form-field__label-right-node___dzUl6",
  "form-field__label-right-node--inline": "lc-FormField-module__form-field__label-right-node--inline___zfQ8H",
  "form-field__row-break": "lc-FormField-module__form-field__row-break___ibOb7",
  "form-field__content": "lc-FormField-module__form-field__content___7Cnwe",
  "form-field__content__description": "lc-FormField-module__form-field__content__description___qdMlU"
}, _e = "form-field", Cc = ({
  inline: e,
  error: a,
  description: o,
  labelText: r,
  labelAdornment: _,
  className: l,
  labelFor: i,
  children: n,
  labelRightNode: d,
  boldLabel: u = !1,
  readOnly: s = !1
}) => {
  const m = b.useRef(null), [h, y] = b.useState("auto"), { isEmpty: p } = Tt(), k = c(
    re[_e],
    {
      [re[`${_e}--inline`]]: e
    },
    l
  );
  return b.useEffect(() => {
    const x = m;
    return e && x.current ? y(`${x.current.clientHeight}px`) : y("auto");
  }), /* @__PURE__ */ g("div", { className: k, children: [
    d && e && /* @__PURE__ */ g(b.Fragment, { children: [
      /* @__PURE__ */ t(
        T,
        {
          as: "div",
          size: "sm",
          className: c(
            re[`${_e}__label-right-node`],
            re[`${_e}__label-right-node--inline`]
          ),
          children: d
        }
      ),
      /* @__PURE__ */ t("div", { className: re[`${_e}__row-break`] })
    ] }),
    /* @__PURE__ */ g(
      "div",
      {
        className: c(
          re[`${_e}__wrapper`],
          e && re[`${_e}__wrapper--inline`]
        ),
        children: [
          (r || d) && /* @__PURE__ */ g(
            "div",
            {
              className: c(
                re[`${_e}__label`],
                e && re[`${_e}__label--inline`],
                !r && re[`${_e}__label--no-text`]
              ),
              children: [
                r && /* @__PURE__ */ g(
                  "div",
                  {
                    className: c(
                      re[`${_e}__label-wrapper`],
                      e && re[`${_e}__label-wrapper--inline`]
                    ),
                    style: {
                      height: h
                    },
                    children: [
                      /* @__PURE__ */ t(
                        "label",
                        {
                          className: c(
                            re[`${_e}__label-left-node`],
                            s && re[`${_e}__label-left-node--read-only`]
                          ),
                          htmlFor: i,
                          children: /* @__PURE__ */ t(
                            T,
                            {
                              as: "span",
                              size: "sm",
                              bold: !s && u,
                              customColor: p ? "var(--content-basic-secondary)" : void 0,
                              children: r
                            }
                          )
                        }
                      ),
                      _ && /* @__PURE__ */ t(
                        T,
                        {
                          as: "div",
                          size: "sm",
                          className: c(
                            re[`${_e}__label-adornment`],
                            e && re[`${_e}__label-adornment--inline`]
                          ),
                          children: _
                        }
                      )
                    ]
                  }
                ),
                d && !e && /* @__PURE__ */ t(
                  T,
                  {
                    as: "div",
                    size: "sm",
                    className: c(re[`${_e}__label-right-node`]),
                    children: d
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ g("div", { className: c(re[`${_e}__content`]), children: [
            /* @__PURE__ */ t("div", { ref: m, children: n }),
            a && /* @__PURE__ */ t(Ir, { children: a }),
            !a && o && /* @__PURE__ */ t(
              Fo,
              {
                className: c(re[`${_e}__content__description`]),
                children: o
              }
            )
          ] })
        ]
      }
    )
  ] });
}, $u = ({
  readOnly: e,
  ...a
}) => /* @__PURE__ */ t(gn, { readOnly: e, children: /* @__PURE__ */ t(Cc, { readOnly: e, ...a }) }), bo = {
  "form-group": "lc-FormGroup-module__form-group___uAHnp",
  "form-group__header": "lc-FormGroup-module__form-group__header___U4FrR",
  "form-group__label": "lc-FormGroup-module__form-group__label___9AcBX",
  "form-group__helper": "lc-FormGroup-module__form-group__helper___2XQcm"
}, vo = "form-group", Su = ({
  className: e = "",
  children: a,
  labelText: o,
  helperText: r,
  ..._
}) => {
  const l = c(bo[vo], e);
  return /* @__PURE__ */ g(
    "div",
    {
      ..._,
      role: "group",
      ...o && { "aria-label": o },
      className: l,
      children: [
        (o || r) && /* @__PURE__ */ g("div", { className: bo[`${vo}__header`], children: [
          o && /* @__PURE__ */ t(
            ce,
            {
              as: "div",
              size: "sm",
              className: bo[`${vo}__label`],
              children: o
            }
          ),
          r && /* @__PURE__ */ t(T, { as: "div", size: "sm", className: bo[`${vo}__helper`], children: r })
        ] }),
        a
      ]
    }
  );
}, wc = "lc-AnimatedButton-module__icon___x-2D0", $c = "lc-AnimatedButton-module__text___JEZ-a", Sc = "lc-AnimatedButton-module__expanded___oXA4t", yo = {
  "animated-button": "lc-AnimatedButton-module__animated-button___d1ume",
  icon: wc,
  text: $c,
  expanded: Sc
}, Nc = ({
  icon: e,
  text: a,
  onClick: o,
  className: r,
  isExpanded: _
}) => {
  const [l, i] = le(!1), n = _ !== void 0, d = n ? _ : l, u = () => {
    i(!0);
  }, s = () => {
    i(!1);
  };
  return q(() => {
    n && !_ && i(!1);
  }, [n, _]), /* @__PURE__ */ g(
    "button",
    {
      type: "button",
      className: c(
        yo["animated-button"],
        { [yo.expanded]: d },
        r
      ),
      onClick: o,
      onMouseEnter: u,
      onMouseLeave: s,
      children: [
        /* @__PURE__ */ t("span", { className: yo.icon, children: e }),
        /* @__PURE__ */ t("span", { className: yo.text, children: a })
      ]
    }
  );
}, e_ = {
  available: 1,
  unavailable: 2,
  unknown: 3
}, xc = (e) => [...e].sort((a, o) => e_[a.status] - e_[o.status]), He = {
  "invite-agents": "lc-InviteAgents-module__invite-agents___XHov-",
  "invite-agents--empty": "lc-InviteAgents-module__invite-agents--empty___-uyZv",
  "invite-agents--only-unavailable": "lc-InviteAgents-module__invite-agents--only-unavailable___rwGmo",
  "invite-agents__not-accepting": "lc-InviteAgents-module__invite-agents__not-accepting___GF-hX",
  "invite-agents__tooltip": "lc-InviteAgents-module__invite-agents__tooltip___8CJxu",
  "invite-agents__tooltip-trigger": "lc-InviteAgents-module__invite-agents__tooltip-trigger___I77qz",
  "invite-agents__not-accepting-status-dot": "lc-InviteAgents-module__invite-agents__not-accepting-status-dot___BnVII",
  "invite-agents__avatar-container": "lc-InviteAgents-module__invite-agents__avatar-container___r56c3",
  "invite-agents__avatar": "lc-InviteAgents-module__invite-agents__avatar___Qs6yT",
  "invite-agents__available-agents-number": "lc-InviteAgents-module__invite-agents__available-agents-number___WpNqr",
  "invite-agents__accepting-agents": "lc-InviteAgents-module__invite-agents__accepting-agents___KNMQw",
  "invite-agents__accepting-agents-row": "lc-InviteAgents-module__invite-agents__accepting-agents-row___bTb9i"
}, ze = "invite-agents", Ec = 50, Tc = ({
  agents: e,
  onSetUpChatbotClick: a,
  onAddTeammateClick: o,
  className: r,
  animatedInviteButton: _ = !1,
  tooltipArrowOffset: l = 13,
  onAvailableAgentsClick: i,
  showBotsInTooltip: n = !0,
  ...d
}) => {
  const [u, s] = le(!1), [m, h] = le(!1), {
    availableAgentsNumber: y,
    visibleAgents: p,
    hasOnlyUnavailableAgents: k,
    onlyAgentsNumber: x,
    onlyBotsNumber: C
  } = pa(() => {
    const f = e.filter(
      (P) => P.status === "available"
    ), v = xc(f), E = f.length, D = v.length > 4 ? v.slice(0, 3) : v, B = e.length > 0 && E === 0, M = f.filter(
      (P) => !P.isBot
    ).length, I = E - M;
    return {
      availableAgentsNumber: E,
      visibleAgents: D,
      hasOnlyUnavailableAgents: B,
      onlyAgentsNumber: M,
      onlyBotsNumber: I
    };
  }, [e]), S = () => {
    a(), s(!1), h(!1);
  }, N = () => {
    o(), s(!1), h(!1);
  }, $ = () => {
    i(), s(!1), h(!1);
  }, w = [
    {
      key: "chatbot",
      onClick: S,
      element: /* @__PURE__ */ t(Xa, { leftNode: /* @__PURE__ */ t(O, { source: cl }), children: "Set up ChatBot" })
    },
    {
      key: "teammate",
      element: /* @__PURE__ */ t(Xa, { leftNode: /* @__PURE__ */ t(O, { source: sl }), children: "Invite teammate" }),
      onClick: N
    }
  ];
  return /* @__PURE__ */ g(
    "div",
    {
      ...d,
      className: c(
        Kt.Dark,
        He[ze],
        {
          [He[`${ze}--empty`]]: e.length === 0,
          [He[`${ze}--only-unavailable`]]: k
        },
        r
      ),
      children: [
        e.length > 0 && /* @__PURE__ */ t(
          Yt,
          {
            isVisible: m && !u,
            offsetMainAxis: l,
            floatingStrategy: "fixed",
            hoverOnDelay: Ec,
            onOpen: () => h(!0),
            onClose: () => h(!1),
            className: c(Kt.Dark, He[`${ze}__tooltip`]),
            triggerRenderer: k ? /* @__PURE__ */ g(
              "div",
              {
                className: He[`${ze}__not-accepting`],
                onClick: $,
                children: [
                  /* @__PURE__ */ t(
                    "div",
                    {
                      className: c(
                        He[`${ze}__not-accepting-status-dot`]
                      )
                    }
                  ),
                  /* @__PURE__ */ t(T, { noMargin: !0, bold: !0, size: "sm", children: "No active agents" })
                ]
              }
            ) : /* @__PURE__ */ g(
              "div",
              {
                className: He[`${ze}__tooltip-trigger`],
                onClick: $,
                children: [
                  /* @__PURE__ */ t("div", { className: He[`${ze}__avatar-container`], children: p.map((f, v) => /* @__PURE__ */ t(
                    Br,
                    {
                      text: f.name,
                      className: He[`${ze}__avatar`],
                      type: f.avatar ? "image" : "text",
                      size: "xsmall",
                      status: f.status,
                      src: f.avatar,
                      style: { zIndex: e.length - v }
                    },
                    f.email
                  )) }),
                  y > 0 && /* @__PURE__ */ t(
                    T,
                    {
                      className: He[`${ze}__available-agents-number`],
                      children: y
                    }
                  )
                ]
              }
            ),
            children: k ? /* @__PURE__ */ t(
              Oi,
              {
                header: "No one's available to assist customers",
                text: "Offer 24/7 support with ChatBot.",
                primaryButton: {
                  handleClick: S,
                  label: "Set up ChatBot"
                }
              }
            ) : /* @__PURE__ */ g(
              T,
              {
                as: "div",
                noMargin: !0,
                size: "md",
                className: He[`${ze}__accepting-agents`],
                children: [
                  /* @__PURE__ */ t(T, { bold: !0, noMargin: !0, children: "Accepting chats:" }),
                  /* @__PURE__ */ g(
                    T,
                    {
                      noMargin: !0,
                      className: He[`${ze}__accepting-agents-row`],
                      children: [
                        /* @__PURE__ */ t(O, { source: ll }),
                        Io(
                          x,
                          "1 agent",
                          `${x} agents`
                        )
                      ]
                    }
                  ),
                  n && /* @__PURE__ */ g(
                    T,
                    {
                      noMargin: !0,
                      className: He[`${ze}__accepting-agents-row`],
                      children: [
                        /* @__PURE__ */ t(O, { source: il }),
                        Io(C, "1 bot", `${C} bots`)
                      ]
                    }
                  )
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          Er,
          {
            floatingStrategy: "fixed",
            visible: u,
            onOpen: () => s(!0),
            onClose: () => s(!1),
            options: w,
            triggerRenderer: /* @__PURE__ */ t(
              Nc,
              {
                icon: /* @__PURE__ */ t(O, { source: nl }),
                text: "Invite",
                onClick: () => s((f) => !f),
                isExpanded: _ ? u || void 0 : !0
              }
            )
          }
        )
      ]
    }
  );
}, Nu = Q_(Tc), Bc = "lc-Link-module__link___35Vo1", t_ = {
  link: Bc,
  "link--bold": "lc-Link-module__link--bold___9Uq3Z"
}, a_ = "link", xu = ({
  bold: e = !1,
  className: a = "",
  ...o
}) => /* @__PURE__ */ t(
  "a",
  {
    className: c(
      t_[a_],
      e && t_[`${a_}--bold`],
      a
    ),
    ...o
  }
), Ic = "lc-Modal-module__modal__body___K3X3J", Ac = "lc-Modal-module__modal__header___22qVU", Dc = "lc-Modal-module__modal__heading___TQl-G", Oc = "lc-Modal-module__modal__footer___-z-ze", xe = {
  "modal-base": "lc-Modal-module__modal-base___W3hsn",
  "fade-in": "lc-Modal-module__fade-in___uf1sy",
  "modal-base--full-space": "lc-Modal-module__modal-base--full-space___I5mqs",
  "modal-base__overlay": "lc-Modal-module__modal-base__overlay___BXG-c",
  "modal-base__overlay--visible": "lc-Modal-module__modal-base__overlay--visible___SkPQ3",
  "modal-base__overlay--labelled": "lc-Modal-module__modal-base__overlay--labelled___XJo16",
  "modal-base__close": "lc-Modal-module__modal-base__close___a2xPW",
  "modal-base__close--label-type": "lc-Modal-module__modal-base__close--label-type___IWIlG",
  modal__body: Ic,
  modal__header: Ac,
  "modal__header--without-heading": "lc-Modal-module__modal__header--without-heading___-zvH5",
  "modal__label-header": "lc-Modal-module__modal__label-header___LL-pz",
  modal__heading: Dc,
  "modal__label-heading": "lc-Modal-module__modal__label-heading___OZoP1",
  modal__footer: Oc
}, Ba = "modal-base", Pc = ({
  children: e,
  className: a = "",
  onClose: o,
  closeOnEscPress: r = !0,
  closeOnOverlayPress: _ = !0,
  fullSpaceContent: l,
  isLabelled: i,
  ...n
}) => {
  const d = c(
    xe[Ba],
    a,
    l && xe[`${Ba}--full-space`]
  );
  return b.useEffect(() => {
    if (!r)
      return;
    const s = (m) => {
      m.key === ie.esc && o();
    };
    return document.addEventListener("keyup", s, !0), () => document.removeEventListener("keyup", s, !0);
  }, [r]), /* @__PURE__ */ t(
    Ml,
    {
      "data-testid": "lc-modal-overlay",
      onMouseDown: (s) => {
        _ && s.target === s.currentTarget && o();
      },
      className: c(
        xe[`${Ba}__overlay`],
        xe[`${Ba}__overlay--visible`],
        i && xe[`${Ba}__overlay--labelled`]
      ),
      children: /* @__PURE__ */ t(
        "div",
        {
          role: "dialog",
          "aria-modal": !0,
          className: d,
          ...n,
          children: e
        }
      )
    }
  );
}, o_ = ({
  labelType: e,
  customColor: a,
  onClick: o
}) => /* @__PURE__ */ t(
  L,
  {
    type: "button",
    kind: "plain",
    "aria-label": "Close modal",
    title: "Close modal",
    className: c(
      xe["modal-base__close"],
      e && xe["modal-base__close--label-type"]
    ),
    onClick: o,
    icon: /* @__PURE__ */ t(O, { source: lt, size: "medium", customColor: a })
  }
), Vt = "modal", Eu = ({
  children: e,
  className: a = "",
  heading: o,
  labelHeading: r,
  fullSpaceContent: _,
  footer: l,
  onClose: i,
  contentClassName: n,
  ...d
}) => {
  const u = c(xe[Vt], a), s = typeof e == "string", m = (h) => {
    h.preventDefault(), h.stopPropagation(), i();
  };
  return /* @__PURE__ */ g(
    Pc,
    {
      className: u,
      fullSpaceContent: _,
      onClose: i,
      isLabelled: !!r,
      ...d,
      children: [
        r && /* @__PURE__ */ g("div", { className: xe[`${Vt}__label-header`], children: [
          /* @__PURE__ */ t(
            ce,
            {
              size: "sm",
              as: "div",
              className: xe[`${Vt}__label-heading`],
              children: r
            }
          ),
          /* @__PURE__ */ t(
            o_,
            {
              labelType: !!r,
              customColor: "var(--color-white)",
              onClick: m
            }
          )
        ] }),
        !r && /* @__PURE__ */ g(
          "div",
          {
            className: c(xe[`${Vt}__header`], {
              [xe[`${Vt}__header--without-heading`]]: !o
            }),
            children: [
              o && /* @__PURE__ */ t(
                ce,
                {
                  size: "sm",
                  as: "div",
                  className: xe[`${Vt}__heading`],
                  children: o
                }
              ),
              /* @__PURE__ */ t(o_, { onClick: m })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "div",
          {
            "data-testid": "modal-body",
            className: c(xe[`${Vt}__body`], n),
            children: s ? /* @__PURE__ */ t(T, { as: "div", children: e }) : e
          }
        ),
        l && /* @__PURE__ */ t("div", { className: xe[`${Vt}__footer`], children: l })
      ]
    }
  );
}, Tu = ({
  children: e,
  className: a = "",
  parentElementName: o = "body",
  zIndex: r
}) => {
  const _ = qt(document.createElement("div"));
  return q(() => {
    const l = _.current, i = document.querySelector(o);
    return i && i.appendChild(l), () => {
      i && i.removeChild(l);
    };
  }, [o]), q(() => {
    const l = _.current;
    a && (l.className = a), r && (l.style.zIndex = `${r}`);
  }, [a, r]), Gl(/* @__PURE__ */ t(W, { children: e }), _.current);
}, Ia = {
  "modal-header": "lc-ModalHeader-module__modal-header___YwkiN",
  "modal-header__heading-left-node": "lc-ModalHeader-module__modal-header__heading-left-node___SZBRX",
  "modal-header__heading-body": "lc-ModalHeader-module__modal-header__heading-body___aBgMz",
  "modal-header__heading-description": "lc-ModalHeader-module__modal-header__heading-description___dpbWK"
}, Aa = "modal-header", Bu = ({ title: e, iconProps: a, avatarProps: o, children: r, className: _ = "" }) => {
  const l = c(Ia[Aa], _);
  return /* @__PURE__ */ g("div", { className: l, children: [
    a && /* @__PURE__ */ t(
      O,
      {
        className: Ia[`${Aa}__heading-left-node`],
        ...a
      }
    ),
    o && /* @__PURE__ */ t(
      Br,
      {
        className: Ia[`${Aa}__heading-left-node`],
        ...o
      }
    ),
    /* @__PURE__ */ g("div", { className: Ia[`${Aa}__heading-body`], children: [
      /* @__PURE__ */ t(ce, { as: "div", size: "sm", children: e }),
      r && /* @__PURE__ */ t(
        T,
        {
          as: "div",
          className: Ia[`${Aa}__heading-description`],
          children: r
        }
      )
    ] })
  ] });
}, Da = {
  "action-modal-content": "lc-ActionModalContent-module__action-modal-content___LGNxr",
  "action-modal-content__icon": "lc-ActionModalContent-module__action-modal-content__icon___JYTP2",
  "action-modal-content__heading": "lc-ActionModalContent-module__action-modal-content__heading___gGgOD",
  "action-modal-content__content": "lc-ActionModalContent-module__action-modal-content__content___K4e5r",
  "action-modal-content__actions": "lc-ActionModalContent-module__action-modal-content__actions___bgnDV"
}, Oa = "action-modal-content", Iu = ({
  children: e,
  className: a,
  icon: o,
  heading: r,
  actions: _,
  headerClassName: l,
  contentClassName: i
}) => {
  const n = c(Da[Oa], a);
  return /* @__PURE__ */ g("div", { className: n, children: [
    o && /* @__PURE__ */ t("div", { className: Da[`${Oa}__icon`], children: o }),
    r && /* @__PURE__ */ t(
      ce,
      {
        className: c(Da[`${Oa}__heading`], l),
        children: r
      }
    ),
    /* @__PURE__ */ t(
      T,
      {
        as: "div",
        className: c(Da[`${Oa}__content`], i),
        children: e
      }
    ),
    _ && /* @__PURE__ */ t("div", { className: Da[`${Oa}__actions`], children: _ })
  ] });
}, sa = {
  "numeric-input": "lc-NumericInput-module__numeric-input___qYvYK",
  "numeric-input__increment": "lc-NumericInput-module__numeric-input__increment___7AdPN",
  "numeric-input__decrement": "lc-NumericInput-module__numeric-input__decrement___18Raa",
  "numeric-input--disabled": "lc-NumericInput-module__numeric-input--disabled___s2O8w",
  "numeric-input--no-controls": "lc-NumericInput-module__numeric-input--no-controls___nO8zN",
  "numeric-input--error": "lc-NumericInput-module__numeric-input--error___y9v6f"
}, da = "numeric-input", Au = ({
  className: e,
  error: a,
  value: o,
  max: r,
  min: _,
  disabled: l,
  noControls: i,
  style: n,
  onChange: d,
  noDataFallbackText: u = "No data",
  ...s
}) => {
  const m = b.useRef(null), { readOnly: h } = Tt(), y = h || s.readOnly, p = c(
    sa[da],
    {
      [sa[`${da}--error`]]: a,
      [sa[`${da}--no-controls`]]: i,
      [sa[`${da}--disabled`]]: l
    },
    e
  ), k = (v) => d(String(v)), x = (v) => r !== void 0 && v > r ? r : _ !== void 0 && v < _ ? _ : v, C = (v) => {
    const E = parseInt(o, 10) + v;
    return k(x(E));
  }, S = (v) => {
    v.key === ie.arrowDown && (v.preventDefault(), C(-1)), v.key === ie.arrowUp && (v.preventDefault(), C(1));
  }, N = (v, E) => E !== void 0 && parseInt(v, 10) === E, $ = (v) => {
    v.preventDefault(), v.stopPropagation();
    const E = v.currentTarget.value.replace(
      /((?!([-]|([-]?\d+))).)/,
      ""
    );
    if (E === "" || E === "-")
      return k(E);
    const D = parseInt(E, 10);
    return k(x(D));
  }, w = () => (m.current?.focus(), C(1)), f = () => (m.current?.focus(), C(-1));
  return y ? /* @__PURE__ */ t(
    va,
    {
      value: o?.toString(),
      noDataFallbackText: u
    }
  ) : /* @__PURE__ */ g("div", { className: p, style: n, children: [
    /* @__PURE__ */ t(
      "input",
      {
        type: "text",
        ref: m,
        ...s,
        value: o,
        disabled: l,
        onChange: $,
        onKeyDown: S,
        min: _,
        max: r
      }
    ),
    !i && /* @__PURE__ */ g(W, { children: [
      /* @__PURE__ */ t(
        "button",
        {
          tabIndex: -1,
          disabled: l || N(o, r),
          onClick: w,
          "aria-label": "Increment value",
          className: sa[`${da}__increment`],
          type: "button",
          children: /* @__PURE__ */ t(
            O,
            {
              source: ja,
              disabled: l || N(o, r),
              kind: "primary"
            }
          )
        }
      ),
      /* @__PURE__ */ t(
        "button",
        {
          tabIndex: -1,
          disabled: l || N(o, _),
          "aria-label": "Decrement value",
          className: sa[`${da}__decrement`],
          onClick: f,
          type: "button",
          children: /* @__PURE__ */ t(
            O,
            {
              source: Xt,
              kind: "primary",
              disabled: l || N(o, _)
            }
          )
        }
      )
    ] })
  ] });
}, we = {
  "checklist-item": "lc-CheckListItem-module__checklist-item___iuIlB",
  "checklist-item--active": "lc-CheckListItem-module__checklist-item--active___aoLek",
  "checklist-item__check-mark": "lc-CheckListItem-module__checklist-item__check-mark___stkGB",
  "checklist-item__check-mark--checked": "lc-CheckListItem-module__checklist-item__check-mark--checked___qcaKG",
  "checklist-item__content": "lc-CheckListItem-module__checklist-item__content___dUQrj",
  "checklist-item__content--open": "lc-CheckListItem-module__checklist-item__content--open___Gb8Bj",
  "checklist-item__content__label": "lc-CheckListItem-module__checklist-item__content__label___IECjY",
  "checklist-item__content__label--open": "lc-CheckListItem-module__checklist-item__content__label--open___bXXcm",
  "checklist-item__content__label--checked": "lc-CheckListItem-module__checklist-item__content__label--checked___v-CRg",
  "checklist-item__content__hint": "lc-CheckListItem-module__checklist-item__content__hint___zyxAI",
  "checklist-item__content__inner": "lc-CheckListItem-module__checklist-item__content__inner___T9e7f",
  "checklist-item__content__inner--open": "lc-CheckListItem-module__checklist-item__content__inner--open___hVtIm",
  "checklist-item__content__inner__description": "lc-CheckListItem-module__checklist-item__content__inner__description___oQx09",
  "checklist-item__content__inner__cta": "lc-CheckListItem-module__checklist-item__content__inner__cta___pPrxs",
  "checklist-item__chevron": "lc-CheckListItem-module__checklist-item__chevron___S9Cp1"
}, $e = "checklist-item", Mc = 7, Rc = ({
  id: e,
  isActive: a,
  isChecked: o,
  title: r,
  titleHint: _,
  description: l,
  customContent: i,
  onClick: n,
  cta: d
}) => {
  const u = b.useRef(null), s = b.useRef(null), [m, h] = b.useState(0), y = b.useRef(m);
  return b.useEffect(() => {
    a && u.current && u.current.focus();
  }, [a]), b.useEffect(() => {
    const p = !!window.ResizeObserver;
    if (s.current && p) {
      const k = new ResizeObserver((x) => {
        const C = x[0];
        if (!C) return;
        const S = C.contentRect.height + Mc;
        y.current !== S && (h(S), y.current = S);
      });
      return k.observe(s.current), () => k.disconnect();
    }
  }, [s]), /* @__PURE__ */ g(
    "div",
    {
      className: c(we[$e], {
        [we[`${$e}--active`]]: a
      }),
      children: [
        /* @__PURE__ */ t(
          "span",
          {
            className: c(we[`${$e}__check-mark`], {
              [we[`${$e}__check-mark--checked`]]: o
            }),
            children: o && /* @__PURE__ */ t(O, { size: "small", source: fa })
          }
        ),
        /* @__PURE__ */ g(
          "div",
          {
            ref: u,
            "data-testid": `checklist-item-${e}`,
            "aria-expanded": a,
            tabIndex: 0,
            onFocus: a ? void 0 : () => n(e),
            onClick: a ? void 0 : () => n(e),
            className: c(we[`${$e}__content`], {
              [we[`${$e}__content--open`]]: a
            }),
            children: [
              /* @__PURE__ */ g("div", { children: [
                /* @__PURE__ */ g(
                  ce,
                  {
                    size: "xs",
                    className: c(we[`${$e}__content__label`], {
                      [we[`${$e}__content__label--open`]]: a,
                      [we[`${$e}__content__label--checked`]]: o
                    }),
                    children: [
                      r,
                      " ",
                      _ && /* @__PURE__ */ g(
                        T,
                        {
                          noMargin: !0,
                          size: "lg",
                          className: we[`${$e}__content__hint`],
                          children: [
                            " ",
                            _
                          ]
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ t(
                  "div",
                  {
                    className: c(we[`${$e}__content__inner`], {
                      [we[`${$e}__content__inner--open`]]: a
                    }),
                    style: { maxHeight: a ? m : 0 },
                    children: /* @__PURE__ */ g("div", { ref: s, children: [
                      l && /* @__PURE__ */ t(
                        T,
                        {
                          size: "lg",
                          className: we[`${$e}__content__inner__description`],
                          children: l
                        }
                      ),
                      i && /* @__PURE__ */ t(
                        "div",
                        {
                          className: we[`${$e}__content__inner__description`],
                          children: i
                        }
                      ),
                      /* @__PURE__ */ t("div", { className: we[`${$e}__content__inner__cta`], children: d })
                    ] })
                  }
                )
              ] }),
              !a && /* @__PURE__ */ t("div", { className: we[`${$e}__chevron`], children: /* @__PURE__ */ t(O, { source: Do }) })
            ]
          }
        )
      ]
    }
  );
}, Z = {
  "onboarding-checklist": "lc-OnboardingChecklist-module__onboarding-checklist___98RSw",
  "onboarding-checklist__complete": "lc-OnboardingChecklist-module__onboarding-checklist__complete___ihqN7",
  "onboarding-checklist__complete__icon": "lc-OnboardingChecklist-module__onboarding-checklist__complete__icon___LDJ-I",
  "onboarding-checklist__complete__label": "lc-OnboardingChecklist-module__onboarding-checklist__complete__label___-wqtx",
  "onboarding-checklist__complete__title": "lc-OnboardingChecklist-module__onboarding-checklist__complete__title___MvGM7",
  "onboarding-checklist__complete__content--no-greeting": "lc-OnboardingChecklist-module__onboarding-checklist__complete__content--no-greeting___Q1glA",
  "onboarding-checklist__column": "lc-OnboardingChecklist-module__onboarding-checklist__column___juqpr",
  "onboarding-checklist__column--right": "lc-OnboardingChecklist-module__onboarding-checklist__column--right___9lOFL",
  "onboarding-checklist__column--right--completed": "lc-OnboardingChecklist-module__onboarding-checklist__column--right--completed___nHt44",
  "onboarding-checklist__header": "lc-OnboardingChecklist-module__onboarding-checklist__header___RB1O7",
  "onboarding-checklist__header__label": "lc-OnboardingChecklist-module__onboarding-checklist__header__label___O2yRJ",
  "onboarding-checklist__header__title": "lc-OnboardingChecklist-module__onboarding-checklist__header__title___H36qW",
  "onboarding-checklist__checklist": "lc-OnboardingChecklist-module__onboarding-checklist__checklist___0vKse",
  "onboarding-checklist__placeholder": "lc-OnboardingChecklist-module__onboarding-checklist__placeholder___JYc-z",
  "onboarding-checklist__button": "lc-OnboardingChecklist-module__onboarding-checklist__button___ZmZ2j",
  "onboarding-checklist__button--open": "lc-OnboardingChecklist-module__onboarding-checklist__button--open___QR74p",
  "onboarding-checklist__button--closed": "lc-OnboardingChecklist-module__onboarding-checklist__button--closed___0bDKk",
  "onboarding-checklist__button__icon": "lc-OnboardingChecklist-module__onboarding-checklist__button__icon___ta8M6",
  "onboarding-checklist__button__icon--open": "lc-OnboardingChecklist-module__onboarding-checklist__button__icon--open___Jnrn8"
}, j = "onboarding-checklist", Du = ({
  activeItemId: e,
  completedItemsIds: a,
  title: o,
  greetingText: r,
  items: _,
  onActiveChange: l,
  placeholderClassName: i,
  isCompleted: n = !1,
  completionMessageData: d,
  isInitiallyOpen: u,
  onOpenChange: s,
  className: m
}) => {
  const [h, y] = b.useState(n), [p, k] = b.useState(
    n ? u ?? !1 : !0
  ), [x, C] = b.useState(void 0), S = b.useRef(null), N = d.height || 108, $ = 108, w = () => {
    k(!p), s?.(!p);
  };
  return b.useEffect(() => {
    const f = d.delay || 1500, v = S.current;
    if (n && v && !h) {
      const E = v.offsetHeight;
      C(E);
      const D = setTimeout(() => {
        y(!0), k(!1), s?.(!1);
      }, f);
      return () => {
        clearTimeout(D);
      };
    }
  }, [n, h]), b.useEffect(() => {
    if (S.current) {
      const f = p ? S.current.scrollHeight + $ : N;
      C(f);
    }
  }, [p, h]), /* @__PURE__ */ g(
    "div",
    {
      ref: S,
      className: c(
        Z[j],
        {
          [Z[`${j}--complete`]]: h && !p
        },
        m
      ),
      style: {
        height: x
      },
      children: [
        p && /* @__PURE__ */ g(W, { children: [
          /* @__PURE__ */ g("div", { className: Z[`${j}__column`], children: [
            /* @__PURE__ */ g("div", { className: Z[`${j}__header`], children: [
              r && /* @__PURE__ */ t(
                T,
                {
                  size: "lg",
                  semiBold: !0,
                  className: Z[`${j}__header__label`],
                  children: r
                }
              ),
              /* @__PURE__ */ t(
                ce,
                {
                  size: "lg",
                  className: Z[`${j}__header__title`],
                  children: o
                }
              )
            ] }),
            /* @__PURE__ */ t("div", { className: Z[`${j}__checklist`], children: _.map((f, v) => /* @__PURE__ */ t(
              Rc,
              {
                id: f.id,
                description: f.description,
                customContent: f.customContent,
                title: f.title,
                titleHint: f.titleHint,
                isActive: f.id === e,
                isChecked: a.includes(f.id),
                onClick: l,
                cta: f.cta
              },
              v
            )) })
          ] }),
          /* @__PURE__ */ g(
            "div",
            {
              className: c(
                Z[`${j}__column`],
                Z[`${j}__column--right`],
                {
                  [Z[`${j}__column--right--completed`]]: n
                },
                i
              ),
              children: [
                !n && /* @__PURE__ */ t("div", { className: Z[`${j}__placeholder`], children: _.find((f) => f.id === e)?.placeholder }),
                n && /* @__PURE__ */ t("div", { className: Z[`${j}__placeholder`], children: d.placeholder })
              ]
            }
          )
        ] }),
        !p && /* @__PURE__ */ t(W, { children: /* @__PURE__ */ g("div", { className: Z[`${j}__complete`], children: [
          /* @__PURE__ */ t("div", { children: /* @__PURE__ */ t(
            O,
            {
              size: "large",
              className: Z[`${j}__complete__icon`],
              source: $r
            }
          ) }),
          /* @__PURE__ */ g(
            "div",
            {
              className: c({
                [Z[`${j}__complete__content--no-greeting`]]: !d?.greetingText
              }),
              children: [
                d?.greetingText && /* @__PURE__ */ t(
                  T,
                  {
                    size: "lg",
                    className: Z[`${j}__complete__label`],
                    children: d.greetingText
                  }
                ),
                /* @__PURE__ */ t(
                  ce,
                  {
                    size: "sm",
                    className: Z[`${j}__complete__title`],
                    children: d.title
                  }
                )
              ]
            }
          )
        ] }) }),
        h && /* @__PURE__ */ t(
          L,
          {
            kind: p ? "float" : "text",
            icon: /* @__PURE__ */ t(
              O,
              {
                source: Xt,
                className: c(
                  Z[`${j}__button__icon`],
                  p && Z[`${j}__button__icon--open`]
                )
              }
            ),
            className: c(Z[`${j}__button`], {
              [Z[`${j}__button--open`]]: p,
              [Z[`${j}__button--closed`]]: !p
            }),
            onClick: w,
            "aria-expanded": p
          }
        )
      ]
    }
  );
}, Fc = "lc-OverflowTooltipText-module__tooltipContent___M9T9h", Gc = "lc-OverflowTooltipText-module__text___JcdMZ", r_ = {
  tooltipContent: Fc,
  text: Gc
}, Ou = ({ text: e }) => {
  const a = qt(null), o = ei(a), { isHovered: r, handleMouseOut: _, handleMouseOver: l } = Ql(o), i = /* @__PURE__ */ t(
    "div",
    {
      onMouseEnter: l,
      onMouseLeave: _,
      ref: a,
      className: r_.text,
      children: e
    }
  );
  return /* @__PURE__ */ t(
    Yt,
    {
      kind: "invert",
      isVisible: o && r,
      triggerRenderer: i,
      children: /* @__PURE__ */ t("div", { className: r_.tooltipContent, children: e })
    }
  );
}, Uc = "lc-Popover-module__popover___rvS3X", Lc = {
  popover: Uc
}, qc = ({
  triggerRenderer: e,
  onClose: a,
  onOpen: o,
  children: r,
  className: _,
  triggerClassName: l,
  placement: i,
  flipOptions: n,
  offsetSize: d = 4,
  isVisible: u,
  openedOnInit: s,
  closeOnEsc: m = !0,
  useDismissHookProps: h,
  useClickHookProps: y,
  floatingStrategy: p,
  transitionOptions: k
}) => {
  const [x, C] = b.useState(s), S = Oo(), N = Ja(), $ = u !== void 0, w = $ ? u : x, f = typeof r == "string", v = typeof e == "function", E = (K, he) => {
    K ? o?.(he) : a?.(he), !$ && C(K);
  }, { refs: D, context: B, floatingStyles: M } = Qa({
    nodeId: N,
    open: w,
    onOpenChange: E,
    middleware: [to(d), Po(n), Sr()],
    placement: i,
    strategy: p,
    whileElementsMounted: eo
  }), I = ao(B, y), P = oo(B, {
    escapeKey: m,
    ...h
  }), A = ro(B), { getReferenceProps: F, getFloatingProps: R } = _o([
    I,
    P,
    A
  ]), U = {
    initial: ({ side: K }) => ({
      opacity: 0,
      ...K === "bottom" && {
        marginTop: -10
      } || K === "top" && {
        marginTop: 10
      } || K === "left" && {
        marginLeft: 10
      } || K === "right" && {
        marginLeft: -10
      }
    })
  }, { isMounted: ge, styles: oe } = Mo(
    B,
    k || U
  ), se = c(Lc.popover, _), Q = /* @__PURE__ */ g(W, { children: [
    /* @__PURE__ */ t(
      "div",
      {
        "data-testid": "popover-trigger-button",
        ref: D.setReference,
        ...F(),
        className: l,
        children: v ? e() : e
      }
    ),
    /* @__PURE__ */ t(ba, { id: N, children: ge && /* @__PURE__ */ t(br, { context: B, modal: !1, children: /* @__PURE__ */ t(
      "div",
      {
        className: se,
        ref: D.setFloating,
        style: {
          ...M,
          ...oe
        },
        ...R(),
        children: f ? /* @__PURE__ */ t(T, { as: "div", children: r }) : r
      }
    ) }) })
  ] });
  return S === null ? /* @__PURE__ */ t(Ro, { children: Q }) : Q;
}, Je = {
  "outer-border": "lc-ProductTile-module__outer-border___tsyqh",
  "product-tile-wrapper": "lc-ProductTile-module__product-tile-wrapper___iKDxM",
  "product-tile-wrapper__animated": "lc-ProductTile-module__product-tile-wrapper__animated___xwIAa",
  "product-tile": "lc-ProductTile-module__product-tile___SAnnV",
  "product-tile__second-layer": "lc-ProductTile-module__product-tile__second-layer___YFtzE",
  "product-tile__third-layer": "lc-ProductTile-module__product-tile__third-layer___W0nsL",
  "product-tile__main-product": "lc-ProductTile-module__product-tile__main-product___Imdix",
  "product-tile__badge": "lc-ProductTile-module__product-tile__badge___EwFjs",
  "product-tile__badge--bordered": "lc-ProductTile-module__product-tile__badge--bordered___H08Ep",
  "product-tile__icon": "lc-ProductTile-module__product-tile__icon___IQqzd",
  "product-tile__icon--large": "lc-ProductTile-module__product-tile__icon--large___Ta9v0",
  "product-tile__icon--expired": "lc-ProductTile-module__product-tile__icon--expired___5PbNr"
}, Mt = "product-tile", H_ = ({
  icon: e,
  iconColor: a,
  expired: o,
  backgroundColors: r,
  borderColor: _,
  notificationCount: l,
  withBorder: i = !1,
  isMainProduct: n = !1
}) => /* @__PURE__ */ t("div", { className: c({ [Je["outer-border"]]: i }), children: /* @__PURE__ */ g(
  "div",
  {
    tabIndex: n ? 0 : -1,
    className: c(Je["product-tile-wrapper"], {
      [Je["product-tile-wrapper__animated"]]: n
    }),
    children: [
      n && /* @__PURE__ */ g(W, { children: [
        /* @__PURE__ */ t(
          "div",
          {
            className: Je[`${Mt}__third-layer`],
            style: { background: r.third }
          }
        ),
        /* @__PURE__ */ t(
          "div",
          {
            className: Je[`${Mt}__second-layer`],
            style: { background: r.second }
          }
        )
      ] }),
      /* @__PURE__ */ g(
        "div",
        {
          className: c(Je[Mt], {
            [Je[`${Mt}__main-product`]]: n
          }),
          style: {
            background: o ? "var(--surface-moderate-default)" : r.main,
            border: _ ? `1px solid ${_}` : ""
          },
          children: [
            l && !o ? /* @__PURE__ */ t(
              To,
              {
                size: "compact",
                count: l,
                className: c(Je[`${Mt}__badge`], {
                  [Je[`${Mt}__badge--bordered`]]: n
                })
              }
            ) : null,
            /* @__PURE__ */ t(
              O,
              {
                source: e,
                className: c(Je[`${Mt}__icon`], {
                  [Je[`${Mt}__icon--large`]]: n,
                  [Je[`${Mt}__icon--expired`]]: o
                }),
                customColor: a
              }
            )
          ]
        }
      )
    ]
  }
) }), st = {
  "product-row": "lc-ProductRow-module__product-row___eDpb-",
  "product-row--expired": "lc-ProductRow-module__product-row--expired___-ttqU",
  "product-row__divider": "lc-ProductRow-module__product-row__divider___Fe--b",
  "product-row__heading": "lc-ProductRow-module__product-row__heading___xjZuH",
  "product-row__shortcut": "lc-ProductRow-module__product-row__shortcut___g3-0w",
  "product-row__name": "lc-ProductRow-module__product-row__name___qAIq-",
  "product-row__tooltip-icon": "lc-ProductRow-module__product-row__tooltip-icon___XO-IY",
  "product-row__trial-tooltip": "lc-ProductRow-module__product-row__trial-tooltip___naThN",
  "product-row__tooltip-dark-shadow": "lc-ProductRow-module__product-row__tooltip-dark-shadow___U8Tqp"
}, dt = "product-row", Hc = ({
  product: {
    id: e,
    icon: a,
    iconColor: o,
    backgroundColors: r,
    borderColor: _,
    notificationCount: l,
    name: i,
    url: n,
    withDivider: d,
    shortcutKey: u,
    expired: s,
    trialDaysLeft: m,
    nameAdornment: h
  },
  onClick: y,
  isActive: p = !1,
  isDarkMode: k
}) => /* @__PURE__ */ g(W, { children: [
  d && /* @__PURE__ */ t("div", { className: st[`${dt}__divider`] }),
  /* @__PURE__ */ g(
    "a",
    {
      href: n,
      "aria-label": `Go to ${i} product`,
      onClick: (x) => y(x, e),
      className: c(st[dt], {
        [st[`${dt}--expired`]]: s
      }),
      children: [
        /* @__PURE__ */ g("div", { className: st[`${dt}__heading`], children: [
          /* @__PURE__ */ t(
            H_,
            {
              icon: a,
              iconColor: o,
              expired: s,
              backgroundColors: r,
              borderColor: _,
              notificationCount: l,
              withBorder: p
            }
          ),
          /* @__PURE__ */ g(T, { as: "div", bold: !0, className: st[`${dt}__name`], children: [
            i,
            s && /* @__PURE__ */ t(
              Yt,
              {
                className: c({
                  [st[`${dt}__tooltip-dark-shadow`]]: k
                }),
                triggerRenderer: /* @__PURE__ */ t(
                  O,
                  {
                    source: Eo,
                    className: st[`${dt}__tooltip-icon`]
                  }
                ),
                placement: "right",
                children: "Your licence is expired."
              }
            ),
            typeof m < "u" && /* @__PURE__ */ g(
              Yt,
              {
                className: c(st[`${dt}__trial-tooltip`], {
                  [st[`${dt}__tooltip-dark-shadow`]]: k
                }),
                triggerRenderer: /* @__PURE__ */ t(
                  O,
                  {
                    source: Eo,
                    className: st[`${dt}__tooltip-icon`]
                  }
                ),
                placement: "right",
                children: [
                  m,
                  " ",
                  Io(m, "day", "days"),
                  " left in your trial. Time to upgrade."
                ]
              }
            ),
            h
          ] })
        ] }),
        u && /* @__PURE__ */ g(T, { size: "sm", className: st[`${dt}__shortcut`], children: [
          "⌘",
          u
        ] })
      ]
    }
  )
] }), Pa = {
  "product-switcher": "lc-ProductSwitcher-module__product-switcher___Dqwcp",
  "product-switcher__content": "lc-ProductSwitcher-module__product-switcher__content___-P5yw",
  "product-switcher__footer": "lc-ProductSwitcher-module__product-switcher__footer___YRPN9",
  "product-switcher__footer-link": "lc-ProductSwitcher-module__product-switcher__footer-link___X0VOn",
  "product-switcher__tooltip": "lc-ProductSwitcher-module__product-switcher__tooltip___kcVyp"
}, Ma = "product-switcher", Pu = ({
  productOptions: e,
  mainProductId: a,
  openedOnInit: o = !1,
  isVisible: r,
  isDarkMode: _ = !0,
  onOpen: l,
  onClose: i,
  onSelect: n,
  textURL: d = "https://www.text.com"
}) => {
  const [u, s] = b.useState(o), [m, h] = le(
    !1
  ), y = Oo(), p = Ja(), k = r !== void 0, x = k ? r : u, C = (R, U) => {
    R ? l?.(U) : i?.(U), !k && s(R);
  }, { refs: S, context: N, floatingStyles: $ } = Qa({
    nodeId: p,
    strategy: "fixed",
    placement: "right-start",
    open: x,
    onOpenChange: (R, U) => {
      h(!1), C(R, U);
    },
    middleware: [to({ mainAxis: 5 })],
    whileElementsMounted: eo
  }), w = ao(N), f = ro(N), v = oo(N), { isMounted: E, styles: D } = Mo(N, {
    duration: 200,
    common: {
      transformOrigin: "left top"
    },
    initial: {
      opacity: 0,
      transform: "scale(0.84) translateX(-22px)"
    }
  }), { getReferenceProps: B, getFloatingProps: M } = _o([
    w,
    v,
    f
  ]), I = e.find(
    (R) => R.id === a
  );
  if (!I)
    return null;
  const P = (R, U) => {
    U === a && R.preventDefault(), s(!1), n?.(U);
  }, A = e.reduce(
    (R, U) => R + (U.notificationCount || 0),
    0
  ), F = /* @__PURE__ */ g(W, { children: [
    /* @__PURE__ */ t("div", { ref: S.setReference, ...B(), children: /* @__PURE__ */ t(
      Yt,
      {
        isVisible: m,
        onOpen: () => h(!0),
        onClose: () => h(!1),
        offsetCrossAxis: 2,
        arrowOffsetY: 2,
        offsetMainAxis: 10,
        hoverOnDelay: 400,
        className: c(Pa[`${Ma}__tooltip`]),
        placement: "right",
        floatingStrategy: "fixed",
        kind: "invert",
        triggerRenderer: /* @__PURE__ */ t(
          H_,
          {
            isMainProduct: !0,
            icon: I.icon,
            iconColor: I.iconColor,
            backgroundColors: I.backgroundColors,
            notificationCount: A
          }
        ),
        closeOnTriggerBlur: !0,
        children: "Switch product"
      }
    ) }),
    /* @__PURE__ */ t(ba, { id: p, children: /* @__PURE__ */ t(
      "div",
      {
        ref: S.setFloating,
        style: $,
        ...M(),
        children: E && /* @__PURE__ */ g(
          "div",
          {
            className: c(
              _ ? "lc-dark-theme" : "lc-light-theme",
              Pa[Ma]
            ),
            style: D,
            children: [
              /* @__PURE__ */ t("div", { className: Pa[`${Ma}__content`], children: e.map((R) => /* @__PURE__ */ t(
                Hc,
                {
                  isDarkMode: _,
                  isActive: R.id === a,
                  product: R,
                  onClick: P
                },
                R.id
              )) }),
              /* @__PURE__ */ t("div", { className: Pa[`${Ma}__footer`], children: /* @__PURE__ */ g(
                "a",
                {
                  href: d,
                  target: "_blank",
                  className: Pa[`${Ma}__footer-link`],
                  onClick: () => C(!1),
                  children: [
                    /* @__PURE__ */ t(T, { noMargin: !0, children: "powered by" }),
                    /* @__PURE__ */ t(
                      O,
                      {
                        size: "xlarge",
                        source: dl,
                        customColor: "var(--content-basic-primary)"
                      }
                    )
                  ]
                }
              ) })
            ]
          }
        )
      }
    ) })
  ] });
  return y === null ? /* @__PURE__ */ t(Ro, { children: F }) : F;
}, zc = 'data:image/svg+xml,%3Csvg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"%3E%3Cg clip-path="url(%23clip0_24854_8994)"%3E%3Crect width="40" height="40" fill="%230066FF"/%3E%3Cg filter="url(%23filter0_f_24854_8994)"%3E%3Cpath d="M32.6382 31.0816C41.9891 31.0816 49.5694 23.5012 49.5694 14.1504C49.5694 4.79953 41.9891 -2.78082 32.6382 -2.78082C23.2874 -2.78082 15.707 4.79953 15.707 14.1504C15.707 23.5012 23.2874 31.0816 32.6382 31.0816Z" fill="%23FF4205"/%3E%3C/g%3E%3Cg filter="url(%23filter1_f_24854_8994)"%3E%3Cpath d="M10.417 50.1292C19.7679 50.1292 27.3482 42.5488 27.3482 33.198C27.3482 23.8471 19.7679 16.2668 10.417 16.2668C1.0662 16.2668 -6.51416 23.8471 -6.51416 33.198C-6.51416 42.5488 1.0662 50.1292 10.417 50.1292Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter2_f_24854_8994)"%3E%3Cpath d="M9.35788 16.2667C15.2022 16.2667 19.9399 11.529 19.9399 5.68472C19.9399 -0.159555 15.2022 -4.89728 9.35788 -4.89728C3.5136 -4.89728 -1.22412 -0.159555 -1.22412 5.68472C-1.22412 11.529 3.5136 16.2667 9.35788 16.2667Z" fill="%233750FF"/%3E%3C/g%3E%3Cg filter="url(%23filter3_f_24854_8994)"%3E%3Cpath d="M7.24274 18.3831C13.6714 18.3831 18.8829 13.1716 18.8829 6.74292C18.8829 0.314217 13.6714 -4.89728 7.24274 -4.89728C0.814034 -4.89728 -4.39746 0.314217 -4.39746 6.74292C-4.39746 13.1716 0.814034 18.3831 7.24274 18.3831Z" fill="%233750FF"/%3E%3C/g%3E%3Cg filter="url(%23filter4_f_24854_8994)"%3E%3Cpath d="M8.29938 21.5577C14.7281 21.5577 19.9396 16.3462 19.9396 9.91748C19.9396 3.48878 14.7281 -1.72272 8.29938 -1.72272C1.87068 -1.72272 -3.34082 3.48878 -3.34082 9.91748C-3.34082 16.3462 1.87068 21.5577 8.29938 21.5577Z" fill="%233750FF"/%3E%3C/g%3E%3Cg filter="url(%23filter5_f_24854_8994)"%3E%3Cpath d="M33.6973 45.8964C40.126 45.8964 45.3375 40.6849 45.3375 34.2562C45.3375 27.8275 40.126 22.616 33.6973 22.616C27.2686 22.616 22.0571 27.8275 22.0571 34.2562C22.0571 40.6849 27.2686 45.8964 33.6973 45.8964Z" fill="%23FFD001"/%3E%3C/g%3E%3Cg filter="url(%23filter6_f_24854_8994)"%3E%3Cpath d="M29.4639 48.0128C35.8926 48.0128 41.1041 42.8013 41.1041 36.3726C41.1041 29.9439 35.8926 24.7324 29.4639 24.7324C23.0352 24.7324 17.8237 29.9439 17.8237 36.3726C17.8237 42.8013 23.0352 48.0128 29.4639 48.0128Z" fill="%23FFD001"/%3E%3C/g%3E%3Cg filter="url(%23filter7_f_24854_8994)"%3E%3Cpath d="M29.4639 48.0128C35.8926 48.0128 41.1041 42.8013 41.1041 36.3726C41.1041 29.9439 35.8926 24.7324 29.4639 24.7324C23.0352 24.7324 17.8237 29.9439 17.8237 36.3726C17.8237 42.8013 23.0352 48.0128 29.4639 48.0128Z" fill="%23FFD001"/%3E%3C/g%3E%3Cg filter="url(%23filter8_f_24854_8994)"%3E%3Cpath d="M6.18299 39.5472C11.4428 39.5472 15.7068 35.2832 15.7068 30.0234C15.7068 24.7635 11.4428 20.4996 6.18299 20.4996C0.923135 20.4996 -3.34082 24.7635 -3.34082 30.0234C-3.34082 35.2832 0.923135 39.5472 6.18299 39.5472Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter9_f_24854_8994)"%3E%3Cpath d="M6.18299 39.5472C11.4428 39.5472 15.7068 35.2832 15.7068 30.0234C15.7068 24.7635 11.4428 20.4996 6.18299 20.4996C0.923135 20.4996 -3.34082 24.7635 -3.34082 30.0234C-3.34082 35.2832 0.923135 39.5472 6.18299 39.5472Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter10_f_24854_8994)"%3E%3Cpath d="M6.18299 39.5472C11.4428 39.5472 15.7068 35.2832 15.7068 30.0234C15.7068 24.7635 11.4428 20.4996 6.18299 20.4996C0.923135 20.4996 -3.34082 24.7635 -3.34082 30.0234C-3.34082 35.2832 0.923135 39.5472 6.18299 39.5472Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter11_f_24854_8994)"%3E%3Cpath d="M6.18299 39.5472C11.4428 39.5472 15.7068 35.2832 15.7068 30.0234C15.7068 24.7635 11.4428 20.4996 6.18299 20.4996C0.923135 20.4996 -3.34082 24.7635 -3.34082 30.0234C-3.34082 35.2832 0.923135 39.5472 6.18299 39.5472Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter12_f_24854_8994)"%3E%3Cpath d="M6.18299 39.5472C11.4428 39.5472 15.7068 35.2832 15.7068 30.0234C15.7068 24.7635 11.4428 20.4996 6.18299 20.4996C0.923135 20.4996 -3.34082 24.7635 -3.34082 30.0234C-3.34082 35.2832 0.923135 39.5472 6.18299 39.5472Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter13_f_24854_8994)"%3E%3Cpath d="M9.35898 38.489C12.8655 38.489 15.7082 35.6463 15.7082 32.1398C15.7082 28.6332 12.8655 25.7906 9.35898 25.7906C5.8524 25.7906 3.00977 28.6332 3.00977 32.1398C3.00977 35.6463 5.8524 38.489 9.35898 38.489Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter14_f_24854_8994)"%3E%3Cpath d="M38.9871 31.0816C46.5846 31.0816 52.7437 24.9225 52.7437 17.325C52.7437 9.7274 46.5846 3.56836 38.9871 3.56836C31.3895 3.56836 25.2305 9.7274 25.2305 17.325C25.2305 24.9225 31.3895 31.0816 38.9871 31.0816Z" fill="%23FF4205"/%3E%3C/g%3E%3Cg filter="url(%23filter15_f_24854_8994)"%3E%3Cpath d="M38.9879 25.7905C45.4166 25.7905 50.6281 20.579 50.6281 14.1503C50.6281 7.72157 45.4166 2.51007 38.9879 2.51007C32.5592 2.51007 27.3477 7.72157 27.3477 14.1503C27.3477 20.579 32.5592 25.7905 38.9879 25.7905Z" fill="%23FF4205"/%3E%3C/g%3E%3Cg filter="url(%23filter16_f_24854_8994)"%3E%3Cpath d="M9.35868 21.5578C14.0341 21.5578 17.8243 17.7676 17.8243 13.0922C17.8243 8.41674 14.0341 4.62656 9.35868 4.62656C4.68325 4.62656 0.893066 8.41674 0.893066 13.0922C0.893066 17.7676 4.68325 21.5578 9.35868 21.5578Z" fill="%233750FF"/%3E%3C/g%3E%3Cg filter="url(%23filter17_f_24854_8994)"%3E%3Cpath d="M31.5797 18.3831C35.0862 18.3831 37.9289 15.5404 37.9289 12.0339C37.9289 8.5273 35.0862 5.68466 31.5797 5.68466C28.0731 5.68466 25.2305 8.5273 25.2305 12.0339C25.2305 15.5404 28.0731 18.3831 31.5797 18.3831Z" fill="%23FF2E00"/%3E%3C/g%3E%3Cg filter="url(%23filter18_f_24854_8994)"%3E%3Cpath d="M12.5312 14.1503C18.3755 14.1503 23.1132 9.41257 23.1132 3.5683C23.1132 -2.27598 18.3755 -7.0137 12.5312 -7.0137C6.68694 -7.0137 1.94922 -2.27598 1.94922 3.5683C1.94922 9.41257 6.68694 14.1503 12.5312 14.1503Z" fill="%233851FF"/%3E%3C/g%3E%3Cg filter="url(%23filter19_f_24854_8994)"%3E%3Cpath d="M28.4057 13.0921C34.25 13.0921 38.9877 8.35441 38.9877 2.51013C38.9877 -3.33415 34.25 -8.07187 28.4057 -8.07187C22.5615 -8.07187 17.8237 -3.33415 17.8237 2.51013C17.8237 8.35441 22.5615 13.0921 28.4057 13.0921Z" fill="%23F3354D"/%3E%3C/g%3E%3Cg filter="url(%23filter20_f_24854_8994)"%3E%3Cpath d="M33.6958 48.0128C39.54 48.0128 44.2778 43.275 44.2778 37.4308C44.2778 31.5865 39.54 26.8488 33.6958 26.8488C27.8515 26.8488 23.1138 31.5865 23.1138 37.4308C23.1138 43.275 27.8515 48.0128 33.6958 48.0128Z" fill="%23FFD101"/%3E%3C/g%3E%3Cg filter="url(%23filter21_f_24854_8994)"%3E%3Cpath d="M8.30173 43.78C14.146 43.78 18.8837 39.0422 18.8837 33.198C18.8837 27.3537 14.146 22.616 8.30173 22.616C2.45745 22.616 -2.28027 27.3537 -2.28027 33.198C-2.28027 39.0422 2.45745 43.78 8.30173 43.78Z" fill="%237FCF35"/%3E%3C/g%3E%3Cg filter="url(%23filter22_f_24854_8994)"%3E%3Cpath d="M6.18454 34.2562C12.0288 34.2562 16.7665 29.5184 16.7665 23.6742C16.7665 17.8299 12.0288 13.0922 6.18454 13.0922C0.340261 13.0922 -4.39746 17.8299 -4.39746 23.6742C-4.39746 29.5184 0.340261 34.2562 6.18454 34.2562Z" fill="%231D7DD0"/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3Cfilter id="filter0_f_24854_8994" x="-8.29297" y="-26.7808" width="81.8623" height="81.8624" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter1_f_24854_8994" x="-30.5142" y="-7.73322" width="81.8623" height="81.8624" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter2_f_24854_8994" x="-25.2241" y="-28.8973" width="69.1641" height="69.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter3_f_24854_8994" x="-28.3975" y="-28.8973" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter4_f_24854_8994" x="-27.3408" y="-25.7227" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter5_f_24854_8994" x="-1.94287" y="-1.38403" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter6_f_24854_8994" x="-6.17627" y="0.732361" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter7_f_24854_8994" x="-6.17627" y="0.732361" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter8_f_24854_8994" x="-27.3408" y="-3.50043" width="67.0479" height="67.0476" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter9_f_24854_8994" x="-27.3408" y="-3.50043" width="67.0479" height="67.0476" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter10_f_24854_8994" x="-27.3408" y="-3.50043" width="67.0479" height="67.0476" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter11_f_24854_8994" x="-27.3408" y="-3.50043" width="67.0479" height="67.0476" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter12_f_24854_8994" x="-27.3408" y="-3.50043" width="67.0479" height="67.0476" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter13_f_24854_8994" x="-20.9902" y="1.79056" width="60.6982" height="60.6984" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter14_f_24854_8994" x="1.23047" y="-20.4316" width="75.5132" height="75.5132" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter15_f_24854_8994" x="3.34766" y="-21.4899" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter16_f_24854_8994" x="-23.1069" y="-19.3734" width="64.9312" height="64.9312" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter17_f_24854_8994" x="1.23047" y="-18.3153" width="60.6982" height="60.6984" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter18_f_24854_8994" x="-9.05078" y="-18.0137" width="43.1641" height="43.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="5.5" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter19_f_24854_8994" x="6.82373" y="-19.0719" width="43.1641" height="43.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="5.5" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter20_f_24854_8994" x="12.1138" y="15.8488" width="43.1641" height="43.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="5.5" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter21_f_24854_8994" x="-13.2803" y="11.616" width="43.1641" height="43.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="5.5" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter22_f_24854_8994" x="-15.3975" y="2.09216" width="43.1641" height="43.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="5.5" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3CclipPath id="clip0_24854_8994"%3E%3Crect width="40" height="40" fill="white"/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A', Vc = [
  {
    id: "livechat",
    name: "LiveChat",
    icon: ul,
    backgroundColors: {
      main: "var(--products-livechat)",
      second: "var(--products-helpdesk)",
      third: "var(--products-chatbot)"
    },
    url: ""
  },
  {
    id: "chatbot",
    name: "ChatBot",
    icon: ml,
    backgroundColors: {
      main: "var(--products-chatbot)",
      second: "var(--products-livechat)",
      third: "var(--products-helpdesk)"
    },
    url: ""
  },
  {
    id: "helpdesk",
    name: "HelpDesk",
    icon: pl,
    backgroundColors: {
      main: "var(--products-helpdesk)",
      second: "var(--products-livechat)",
      third: "var(--products-chatbot)"
    },
    url: "",
    expired: !0
  },
  {
    id: "knowledgebase",
    name: "KnowledgeBase",
    icon: gl,
    backgroundColors: {
      main: "var(--products-knowledgebase)",
      second: "var(--products-helpdesk)",
      third: "var(--products-chatbot)"
    },
    url: "",
    trialDaysLeft: 2
  },
  {
    id: "openwidget",
    name: "OpenWidget",
    icon: hl,
    backgroundColors: {
      main: `url('${zc}')`,
      second: "var(--products-livechat)",
      third: "var(--products-chatbot)"
    },
    url: ""
  },
  {
    id: "teamchat",
    name: "TeamChat",
    icon: fl,
    backgroundColors: {
      main: "var(--products-hello)",
      second: "var(--products-livechat)",
      third: "var(--products-chatbot)"
    },
    url: ""
  },
  {
    id: "accounts",
    name: "Text Accounts",
    icon: bl,
    backgroundColors: {
      main: "var(--surface-locked-white)",
      second: "var(--products-livechat)",
      third: "var(--products-chatbot)"
    },
    iconColor: "var(--content-locked-black)",
    withDivider: !0,
    url: "",
    borderColor: "var(--border-basic-secondary)"
  }
], Wc = [
  {
    clientId: "58737b5829e65621a45d598aa6f2ed8e",
    redirectUri: "https://my.labs.livechatinc.com",
    product: "LiveChat"
  },
  {
    clientId: "ee078090-b721-4e2b-9cf2-65e95904634c",
    redirectUri: "https://app.labs.helpdesk.com",
    product: "HelpDesk"
  },
  {
    clientId: "9638698004690917c9b787a2e16fc007",
    redirectUri: "https://app.staging.chatbot.com/auth",
    product: "ChatBot"
  },
  {
    clientId: "40f0baca4e364c84c2d89bf3403caa31",
    redirectUri: "https://app.labs.openwidget.com",
    product: "OpenWidget"
  },
  {
    clientId: "de5fce27f8c77fa41e9fa621beeed111",
    redirectUri: "https://app.staging.knowledgebase.ai",
    product: "KnowledgeBase"
  },
  {
    clientId: "6193fd6d9771645e2dc6a4614c677314",
    redirectUri: "https://teamchat.labs.text.com/app",
    product: "TeamChat"
  },
  {
    clientId: "0ab5cf9b99447db22109ff70003d4507",
    redirectUri: "https://accounts.labs.livechat.com/panel",
    product: "Accounts"
  }
], Kc = [
  {
    clientId: "bb9e5b2f1ab480e4a715977b7b1b4279",
    redirectUri: "https://my.staging.livechatinc.com",
    product: "LiveChat"
  },
  {
    clientId: "82837eac-ff5e-45ca-bce1-00011acf925c",
    redirectUri: "https://app.staging.helpdesk.com",
    product: "HelpDesk"
  },
  {
    clientId: "92418ea187dd3c572383cbf56f015b6c",
    redirectUri: "https://app.chatbot.com/auth",
    product: "ChatBot"
  },
  {
    clientId: "8c7275c9fa6f4853e8442df1387f7fe6",
    redirectUri: "https://app.openwidget.com",
    product: "OpenWidget"
  },
  {
    clientId: "0671f59cf1c3015a511619de69373e47",
    redirectUri: "https://app.knowledgebase.ai",
    product: "KnowledgeBase"
  },
  {
    clientId: "6c493637185258c1a937e68886906831",
    redirectUri: "https//teamchat.text.com/app",
    product: "TeamChat"
  },
  {
    clientId: "2fd9f1923f2233763b8637f7d10a6fe6",
    redirectUri: "https://accounts.staging.livechat.com/panel",
    product: "Accounts"
  }
], z_ = [
  {
    clientId: "bb9e5b2f1ab480e4a715977b7b1b4279",
    redirectUri: "https://my.livechatinc.com",
    product: "LiveChat"
  },
  {
    clientId: "82837eac-ff5e-45ca-bce1-00011acf925c",
    redirectUri: "https://app.helpdesk.com",
    product: "HelpDesk"
  },
  {
    clientId: "92418ea187dd3c572383cbf56f015b6c",
    redirectUri: "https://app.chatbot.com/auth",
    product: "ChatBot"
  },
  {
    clientId: "8c7275c9fa6f4853e8442df1387f7fe6",
    redirectUri: "https://app.openwidget.com",
    product: "OpenWidget"
  },
  {
    clientId: "0671f59cf1c3015a511619de69373e47",
    redirectUri: "https://app.knowledgebase.ai",
    product: "KnowledgeBase"
  },
  {
    clientId: "1ebfa721f575b1346b9c76bb8f86583c",
    redirectUri: "https://teamchat.text.com/app",
    product: "TeamChat"
  },
  {
    clientId: "2fd9f1923f2233763b8637f7d10a6fe6",
    redirectUri: "https://accounts.livechat.com/panel",
    product: "Accounts"
  }
], Yc = [
  "livechat",
  "chatbot",
  "helpdesk",
  "accounts"
], Ar = {
  livechat: "LiveChat",
  helpdesk: "HelpDesk",
  accounts: "Accounts",
  knowledgebase: "KnowledgeBase",
  chatbot: "ChatBot",
  openwidget: "OpenWidget",
  teamchat: "TeamChat"
}, Xc = (e, a, o, r, _) => {
  let l = "";
  _ && _ !== "prod" ? l += `https://accounts.${_}.livechat.com` : l += "https://accounts.livechat.com";
  const i = Qc(_, r), n = `${l}?client_id=${e}&redirect_uri=${encodeURIComponent(
    a
  )}&response_type=token&organization_id=${o}`;
  return i ? `${n}&utm_source=${i}&utm_medium=referral&utm_campaign=productswitcher` : n;
}, Zc = (e) => {
  const a = new Date(e), o = /* @__PURE__ */ new Date();
  return Hl(a) ? 0 : v_(a, o);
}, jc = (e, a) => Yc.includes(e) || a.some(
  (o) => o.product === Ar[e]
), Jc = (e, a, o, r, _, l) => {
  const i = a.find(
    (n) => n.product === Ar[e.id]
  );
  if (!i)
    throw new Error(`Product data for ${e.id} not found`);
  return {
    ...e,
    trialDaysLeft: o[e.id] && o[e.id]?.status === "trial" && o[e.id]?.next_charge_at ? Zc(o[e.id]?.next_charge_at ?? "") : void 0,
    expired: o[e.id]?.status === "expired",
    url: Xc(
      i.clientId,
      i.redirectUri,
      r,
      _,
      l
    )
  };
}, V_ = (e) => {
  switch (e) {
    case "prod":
      return z_;
    case "staging":
      return Kc;
    case "labs":
      return Wc;
    default:
      return [];
  }
}, Qc = (e, a) => V_(e).find(
  (_) => _.product === Ar[a]
)?.redirectUri.replace("https://", ""), Mu = ({
  env: e = "prod",
  installedProducts: a,
  subscriptions: o,
  organizationId: r,
  mainProductId: _
}) => {
  if (!a || !o || !r)
    throw new Error("Missing required parameters");
  const l = e ? V_(e) : z_;
  return {
    products: Vc.reduce(
      (i, n) => (jc(n.id, a) && i.push(
        Jc(
          n,
          l,
          o,
          r,
          _,
          e
        )
      ), i),
      []
    )
  };
}, es = (e) => Math.min(Math.max(e, 0), 100);
function W_(e, a = 0) {
  return e === "error" ? 0 : es(parseInt(a.toString(), 10));
}
const Ra = {
  "progress-circle": "lc-ProgressCircle-module__progress-circle___H4Abd",
  "progress-circle--small": "lc-ProgressCircle-module__progress-circle--small___BH3y7",
  "progress-circle--medium": "lc-ProgressCircle-module__progress-circle--medium___0GWFs",
  "progress-circle--large": "lc-ProgressCircle-module__progress-circle--large___AxNYV",
  "progress-circle__bg-line--normal": "lc-ProgressCircle-module__progress-circle__bg-line--normal___LYe5F",
  "progress-circle__bg-line--success": "lc-ProgressCircle-module__progress-circle__bg-line--success___51Jk6",
  "progress-circle__bg-line--error": "lc-ProgressCircle-module__progress-circle__bg-line--error___uIy7L",
  "progress-circle__indicator--normal": "lc-ProgressCircle-module__progress-circle__indicator--normal___LVjBb",
  "progress-circle__indicator--success": "lc-ProgressCircle-module__progress-circle__indicator--success___JnXe0",
  "progress-circle__indicator--error": "lc-ProgressCircle-module__progress-circle__indicator--error___HejoU"
}, ts = {
  small: 2,
  medium: 3,
  large: 4
}, as = {
  small: 15,
  medium: 36,
  large: 56
}, Fa = "progress-circle", os = b.forwardRef(
  ({
    status: e = "normal",
    progressValue: a,
    className: o,
    size: r = "medium",
    ..._
  }, l) => {
    const i = W_(e, a), n = ts[r], d = as[r], u = c(
      Ra[Fa],
      {
        [Ra[`${Fa}--${r}`]]: r,
        [Ra[`${Fa}--${e}`]]: e
      },
      o
    ), s = 2 * Math.PI * ((d - n) / 2), m = {
      strokeDasharray: s.toFixed(3),
      strokeDashoffset: `${((100 - i) / 100 * s).toFixed(3)}px`
    }, h = `${d / 2} ${d / 2} ${d} ${d}`;
    return /* @__PURE__ */ t(
      "div",
      {
        className: u,
        ref: l,
        role: "progressbar",
        ..._,
        children: /* @__PURE__ */ g("svg", { viewBox: h, children: [
          /* @__PURE__ */ t(
            "circle",
            {
              className: Ra[`${Fa}__bg-line--${e}`],
              cx: d,
              cy: d,
              r: (d - n) / 2,
              fill: "none",
              strokeWidth: n
            }
          ),
          /* @__PURE__ */ t(
            "circle",
            {
              className: Ra[`${Fa}__indicator--${e}`],
              style: m,
              cx: d,
              cy: d,
              r: (d - n) / 2,
              fill: "none",
              strokeWidth: n
            }
          )
        ] })
      }
    );
  }
), ko = {
  "progress-bar": "lc-ProgressBar-module__progress-bar___ERC2D",
  "progress-bar--small": "lc-ProgressBar-module__progress-bar--small___PPhCr",
  "progress-bar--medium": "lc-ProgressBar-module__progress-bar--medium___GgSEb",
  "progress-bar--large": "lc-ProgressBar-module__progress-bar--large___Seq-t",
  "progress-bar--error": "lc-ProgressBar-module__progress-bar--error___2AR1I",
  "progress-bar--success": "lc-ProgressBar-module__progress-bar--success___-fKPU",
  "progress-bar--normal": "lc-ProgressBar-module__progress-bar--normal___WboRI",
  "progress-bar__indicator--success": "lc-ProgressBar-module__progress-bar__indicator--success___MHAlN",
  "progress-bar__indicator--normal": "lc-ProgressBar-module__progress-bar__indicator--normal___sjEAI"
}, Co = "progress-bar", rs = b.forwardRef(
  ({
    status: e = "normal",
    percent: a,
    size: o = "medium",
    className: r = "",
    ..._
  }, l) => {
    const i = W_(e, a), n = c(
      ko[Co],
      {
        [ko[`${Co}--${o}`]]: o,
        [ko[`${Co}--${e}`]]: e
      },
      r
    );
    return /* @__PURE__ */ t(
      "div",
      {
        ..._,
        className: n,
        ref: l,
        role: "progressbar",
        children: /* @__PURE__ */ t(
          "div",
          {
            "data-testid": "progress-bar-indicator",
            className: ko[`${Co}__indicator--${e}`],
            style: { width: `${i}%` }
          }
        )
      }
    );
  }
), St = {
  "main-wrapper": "lc-PromoBannerV2-module__main-wrapper___6Ka0j",
  "promo-banner-v2": "lc-PromoBannerV2-module__promo-banner-v2___vkVos",
  "promo-banner-v2__content": "lc-PromoBannerV2-module__promo-banner-v2__content___16-yG",
  "promo-banner-v2__content__cta": "lc-PromoBannerV2-module__promo-banner-v2__content__cta___59Ml7",
  "promo-banner-v2__content__cta__secondary": "lc-PromoBannerV2-module__promo-banner-v2__content__cta__secondary___ka6nD",
  "promo-banner-v2__additional-content": "lc-PromoBannerV2-module__promo-banner-v2__additional-content___QsE3z",
  "promo-banner-v2__close": "lc-PromoBannerV2-module__promo-banner-v2__close___HA3Hr",
  "promo-banner-v2__close__btn": "lc-PromoBannerV2-module__promo-banner-v2__close__btn___23Qui",
  "promo-banner-v2--dark": "lc-PromoBannerV2-module__promo-banner-v2--dark___pmXpS",
  "promo-banner-v2--vertical": "lc-PromoBannerV2-module__promo-banner-v2--vertical___hXlPD"
}, Rt = "promo-banner-v2", Ru = ({
  children: e,
  className: a,
  additionalContent: o,
  primaryButton: r,
  secondaryButton: _,
  vertical: l,
  contentClassName: i,
  additionalContentClassName: n,
  onClose: d,
  kind: u = "default"
}) => {
  const s = c(
    St["main-wrapper"],
    St[`${Rt}--${u}`],
    u === "dark" && Kt.Dark,
    a
  );
  return /* @__PURE__ */ t("div", { role: "banner", className: s, children: /* @__PURE__ */ g(
    "div",
    {
      className: c(
        St[Rt],
        l && St[`${Rt}--vertical`]
      ),
      children: [
        /* @__PURE__ */ g(
          "div",
          {
            "data-testId": "content",
            className: c(St[`${Rt}__content`], i),
            children: [
              e,
              (r || _) && /* @__PURE__ */ g("div", { className: St[`${Rt}__content__cta`], children: [
                r && /* @__PURE__ */ t(
                  L,
                  {
                    ...r,
                    kind: r?.kind || "high-contrast",
                    onClick: r.handleClick,
                    children: r.label
                  }
                ),
                _ && /* @__PURE__ */ t(
                  L,
                  {
                    ..._,
                    kind: _?.kind || "text",
                    onClick: _.handleClick,
                    className: c(
                      St[`${Rt}__content__cta__secondary`],
                      _.className
                    ),
                    children: _.label
                  }
                )
              ] })
            ]
          }
        ),
        o && /* @__PURE__ */ t(
          "div",
          {
            "data-testId": "additional-content",
            className: c(
              St[`${Rt}__additional-content`],
              n
            ),
            children: o
          }
        ),
        d && /* @__PURE__ */ t("div", { className: St[`${Rt}__close`], children: /* @__PURE__ */ t(
          L,
          {
            className: St[`${Rt}__close__btn`],
            onClick: d,
            icon: /* @__PURE__ */ t(O, { source: lt, kind: "primary" }),
            kind: "plain",
            size: "compact",
            "aria-label": "Close banner"
          }
        ) })
      ]
    }
  ) });
}, Nt = {
  "radio-button": "lc-RadioButton-module__radio-button___PtGXj",
  "radio-button__circle": "lc-RadioButton-module__radio-button__circle___-RXEf",
  "radio-button__label": "lc-RadioButton-module__radio-button__label___WGhio",
  "radio-button__inner-circle": "lc-RadioButton-module__radio-button__inner-circle___T5nYz",
  "radio-button__text": "lc-RadioButton-module__radio-button__text___8q8cs",
  "radio-button__input": "lc-RadioButton-module__radio-button__input___nd4MZ",
  "radio-button__helper": "lc-RadioButton-module__radio-button__helper___X4Ihv",
  "radio-button--read-only": "lc-RadioButton-module__radio-button--read-only___pSy5f",
  "radio-button--selected": "lc-RadioButton-module__radio-button--selected___00LlN",
  "radio-button--disabled": "lc-RadioButton-module__radio-button--disabled___StpOi"
}, xt = "radio-button", _s = b.forwardRef(
  ({ children: e, className: a = "", description: o, checked: r, disabled: _, ...l }, i) => {
    const { readOnly: n } = Tt(), d = n || l.readOnly, u = c(Nt[xt], a, {
      [Nt[`${xt}--selected`]]: r,
      [Nt[`${xt}--disabled`]]: _,
      [Nt[`${xt}--read-only`]]: d
    });
    return /* @__PURE__ */ g("div", { className: u, children: [
      /* @__PURE__ */ g("label", { className: Nt[`${xt}__label`], children: [
        /* @__PURE__ */ g("div", { className: Nt[`${xt}__circle`], children: [
          /* @__PURE__ */ t("span", { className: Nt[`${xt}__inner-circle`] }),
          /* @__PURE__ */ t(
            "input",
            {
              ...l,
              className: Nt[`${xt}__input`],
              ref: i,
              type: "radio",
              checked: r,
              disabled: _
            }
          )
        ] }),
        e && /* @__PURE__ */ t(T, { as: "div", size: "md", className: Nt[`${xt}__text`], children: e })
      ] }),
      o && /* @__PURE__ */ t(Fo, { className: Nt[`${xt}__helper`], children: o })
    ] });
  }
), __ = {
  "range-date-picker-v2-label": "lc-RangeDatePickerV2Label-module__range-date-picker-v2-label___jHKH2",
  "range-date-picker-v2-label--selected": "lc-RangeDatePickerV2Label-module__range-date-picker-v2-label--selected___I-O8x"
}, l_ = "range-date-picker-v2-label", ls = ({
  tempDate: e,
  date: a,
  selectedOptionName: o
}) => {
  const r = () => e?.from ? `${io(e.from, "dd-MM-yy")}` : a?.from ? `${io(a.from, "dd-MM-yy")}` : "Start date", _ = () => e?.to ? `${io(e.to, "dd-MM-yy")}` : a?.to ? `${io(a.to, "dd-MM-yy")}` : "End date";
  return /* @__PURE__ */ g(
    T,
    {
      className: c(__[`${l_}`], {
        [__[`${l_}--selected`]]: a?.from && a?.to
      }),
      children: [
        r(),
        " - ",
        _(),
        " ",
        o && `(${o})`
      ]
    }
  );
}, Qe = y_(), wo = [
  {
    id: "today",
    label: "Today",
    value: { from: Qe, to: Qe }
  },
  {
    id: "yesterday",
    label: "Yesterday",
    value: { from: no(Qe, 1), to: no(Qe, 1) }
  },
  {
    id: "last7days",
    label: "Last 7 days",
    value: { from: no(Qe, 6), to: Qe }
  },
  {
    id: "last30days",
    label: "Last 30 days",
    value: { from: no(Qe, 29), to: Qe }
  },
  {
    id: "lastMonth",
    label: "Last month",
    value: {
      from: Mr(ta(Qe, 1)),
      to: zl(ta(Qe, 1))
    }
  },
  {
    id: "currentMonth",
    label: "Current month",
    value: { from: Mr(Qe), to: Qe }
  }
], is = (e, a) => a?.from && a?.to && e?.from && e?.to ? a.from.getTime() === e.from.getTime() && a.to.getTime() === e.to.getTime() : !1, Ae = {
  "range-date-picker__popover": "lc-RangeDatePickerV2-module__range-date-picker__popover___0Q1sv",
  "range-date-picker__trigger": "lc-RangeDatePickerV2-module__range-date-picker__trigger___QX-yx",
  "range-date-picker__trigger__right-node--active": "lc-RangeDatePickerV2-module__range-date-picker__trigger__right-node--active___HYCcu",
  "range-date-picker__trigger__right-node__icon": "lc-RangeDatePickerV2-module__range-date-picker__trigger__right-node__icon___fHaPd",
  "range-date-picker__trigger__right-node__button": "lc-RangeDatePickerV2-module__range-date-picker__trigger__right-node__button___XqDl3",
  "range-date-picker__trigger__right-node": "lc-RangeDatePickerV2-module__range-date-picker__trigger__right-node___amiev",
  "range-date-picker__trigger--active": "lc-RangeDatePickerV2-module__range-date-picker__trigger--active___JX1bA",
  "range-date-picker__date-picker": "lc-RangeDatePickerV2-module__range-date-picker__date-picker___dzDlt",
  "range-date-picker__date-picker__list": "lc-RangeDatePickerV2-module__range-date-picker__date-picker__list___tlSQ8",
  "range-date-picker__date-picker__list__item": "lc-RangeDatePickerV2-module__range-date-picker__date-picker__list__item___uH4Y9",
  "range-date-picker__date-picker__list__item--selected": "lc-RangeDatePickerV2-module__range-date-picker__date-picker__list__item--selected___-0-d6",
  "range-date-picker__date-picker__list__item__icon": "lc-RangeDatePickerV2-module__range-date-picker__date-picker__list__item__icon___5A--A",
  "range-date-picker__date-picker__callendar": "lc-RangeDatePickerV2-module__range-date-picker__date-picker__callendar___3dPDs"
}, De = "range-date-picker", ns = y_(), cs = 680, Fu = ({
  initiallyOpen: e = !1,
  initialSelectedOptionId: a,
  onRangeSelect: o,
  triggerClassName: r,
  rangeDatePickerClassName: _,
  ...l
}) => {
  const { initialFromDate: i, initialToDate: n } = l, d = i || n ? {
    from: i,
    to: n
  } : void 0, [u, s] = le(d), [m, h] = le(!1), [y, p] = le(), [k, x] = le(e), [C, S] = le(), N = qt(-1), $ = qt(null);
  window.onresize = () => window.innerWidth <= cs ? h(!0) : h(!1);
  const w = (I) => N.current + I, f = (I) => {
    N.current = w(I);
    const P = $.current?.children;
    return (P && P[N.current]?.children[0])?.focus();
  }, v = (I) => {
    I.key === ie.arrowUp && N.current > 0 && (I.preventDefault(), f(-1)), I.key === ie.arrowDown && N.current + 1 < wo.length && (I.preventDefault(), f(1));
  }, E = (I, P) => {
    s(I || void 0), o(I, P), p(void 0), S(void 0);
  }, D = () => {
    p(void 0), x(!1);
  }, B = ht(
    ({ from: I, to: P }, A) => {
      E({ from: I, to: P }, A), D(), S(A);
    },
    [E, D]
  ), M = ht(
    (I) => {
      !I || is(I, u) || (E(I), D());
    },
    [u]
  );
  return q(() => {
    if (k)
      return document.addEventListener("keydown", v), () => document.removeEventListener("keydown", v);
    N.current = -1;
  }, [k, v]), q(() => {
    if (a && !u) {
      const I = wo.find(({ id: P }) => P === a);
      I && B(I.value, I.id);
    }
  }, [a, u, B]), /* @__PURE__ */ t("div", { className: Ae[De], children: /* @__PURE__ */ t(
    qc,
    {
      isVisible: k,
      onOpen: () => x(!0),
      onClose: D,
      className: Ae[`${De}__popover`],
      placement: "bottom-start",
      triggerRenderer: () => /* @__PURE__ */ g(
        "div",
        {
          tabIndex: 0,
          role: "button",
          "data-testid": "range-date-picker-trigger",
          "aria-label": "Select date range",
          className: c(
            Ae[`${De}__trigger`],
            {
              [Ae[`${De}__trigger--active`]]: k
            },
            r
          ),
          onKeyDown: (I) => {
            (I.key === ie.enter || I.key === ie.spacebar) && f(1);
          },
          children: [
            /* @__PURE__ */ t(
              ls,
              {
                tempDate: y,
                date: u,
                selectedOptionName: wo.find(({ id: I }) => I === C)?.label
              }
            ),
            /* @__PURE__ */ g(
              "div",
              {
                className: c(
                  Ae[`${De}__trigger__right-node`],
                  u && Ae[`${De}__trigger__right-node--active`]
                ),
                children: [
                  /* @__PURE__ */ t(
                    O,
                    {
                      source: vl,
                      className: Ae[`${De}__trigger__right-node__icon`]
                    }
                  ),
                  u && /* @__PURE__ */ t(
                    L,
                    {
                      size: "xcompact",
                      kind: "plain",
                      icon: /* @__PURE__ */ t(O, { size: "xsmall", source: lt }),
                      className: Ae[`${De}__trigger__right-node__button`],
                      onClick: () => E(null)
                    }
                  )
                ]
              }
            )
          ]
        }
      ),
      children: /* @__PURE__ */ g(
        "div",
        {
          "data-testid": "range-date-picker",
          id: "date-range-popup",
          className: c(
            Ae[`${De}__date-picker`],
            _
          ),
          children: [
            /* @__PURE__ */ t(
              "ul",
              {
                role: "menu",
                ref: $,
                className: Ae[`${De}__date-picker__list`],
                children: wo.map((I) => /* @__PURE__ */ t("li", { role: "none", children: /* @__PURE__ */ g(
                  "button",
                  {
                    "aria-selected": C === I.id,
                    role: "menuitem",
                    className: c(
                      Ae[`${De}__date-picker__list__item`],
                      {
                        [Ae[`${De}__date-picker__list__item--selected`]]: C === I.id
                      }
                    ),
                    onClick: () => B(I.value, I.id),
                    onMouseEnter: () => p(I.value),
                    onMouseLeave: () => p(void 0),
                    children: [
                      /* @__PURE__ */ t(T, { as: "span", children: I.label }),
                      C === I.id && /* @__PURE__ */ t(
                        "div",
                        {
                          className: Ae[`${De}__date-picker__list__item__icon`],
                          children: /* @__PURE__ */ t(O, { source: fa, kind: "action-primary" })
                        }
                      )
                    ]
                  }
                ) }, I.id))
              }
            ),
            /* @__PURE__ */ t("div", { className: Ae[`${De}__date-picker__callendar`], children: /* @__PURE__ */ t(
              q_,
              {
                onRangeSelect: M,
                customTempFromDate: y?.from || u?.from,
                customTempToDate: y?.to || u?.to,
                onCustomTempDateRangeChange: p,
                initialToDate: u?.to || ns,
                ...l,
                children: ({ datepicker: I }) => /* @__PURE__ */ t(pc, { ...I, numberOfMonths: m ? 1 : 2 })
              }
            ) })
          ]
        }
      )
    }
  ) });
}, Oe = {
  "search-input": "lc-SearchInput-module__search-input___3J4w9",
  "search-input--compact": "lc-SearchInput-module__search-input--compact___4hBLm",
  "search-input--medium": "lc-SearchInput-module__search-input--medium___c3OEc",
  "search-input--large": "lc-SearchInput-module__search-input--large___RcwfK",
  "search-input--focused": "lc-SearchInput-module__search-input--focused___XvA05",
  "search-input--disabled": "lc-SearchInput-module__search-input--disabled___m1suy",
  "search-input--collapsable": "lc-SearchInput-module__search-input--collapsable___LgOIB",
  "search-input--collapsable--compact": "lc-SearchInput-module__search-input--collapsable--compact___QgiH-",
  "search-input--collapsable--medium": "lc-SearchInput-module__search-input--collapsable--medium___KVwWI",
  "search-input--collapsable--large": "lc-SearchInput-module__search-input--collapsable--large___ks2s-",
  "search-input__search-icon": "lc-SearchInput-module__search-input__search-icon___KYne6",
  "search-input--collapsable--open": "lc-SearchInput-module__search-input--collapsable--open___a3kOq",
  "search-input__search-icon--compact": "lc-SearchInput-module__search-input__search-icon--compact___3imck",
  "search-input__search-icon--medium": "lc-SearchInput-module__search-input__search-icon--medium___exSsN",
  "search-input__search-icon--large": "lc-SearchInput-module__search-input__search-icon--large___qFfxH",
  "search-input__clear-icon": "lc-SearchInput-module__search-input__clear-icon___PgKgA",
  "search-input__loader": "lc-SearchInput-module__search-input__loader___9veIC",
  "search-input__input-wrapper": "lc-SearchInput-module__search-input__input-wrapper___9NT39",
  "search-input__input-wrapper--compact": "lc-SearchInput-module__search-input__input-wrapper--compact___d-GJ7",
  "search-input__input-wrapper--medium": "lc-SearchInput-module__search-input__input-wrapper--medium___VN8Dh",
  "search-input__input-wrapper--large": "lc-SearchInput-module__search-input__input-wrapper--large___ZwZ0o",
  "search-input__input-wrapper--crop": "lc-SearchInput-module__search-input__input-wrapper--crop___JA7J1"
}, at = "search-input", _r = `${at}__input-wrapper`, ss = b.forwardRef(
  ({
    isCollapsable: e,
    isDisabled: a,
    isLoading: o,
    placeholder: r = "Search ...",
    size: _ = "medium",
    value: l,
    className: i,
    cropOnBlur: n = !0,
    onChange: d,
    ...u
  }, s) => {
    const m = b.useRef(null);
    b.useImperativeHandle(s, () => m.current, [s]);
    const [h, y] = b.useState(!0), [p, k] = b.useState(!1), x = !!l && !a && !o, C = e && !h && "true", S = c(
      i,
      Oe[at],
      Oe[`${at}--${_}`],
      p && Oe[`${at}--focused`],
      a && Oe[`${at}--disabled`],
      e && Oe[`${at}--collapsable`],
      e && Oe[`${at}--collapsable--${_}`],
      !h && Oe[`${at}--collapsable--open`]
    );
    b.useEffect(() => {
      e && l && y(!1);
    }, [e, l]);
    const N = (D) => {
      const B = D.currentTarget.value;
      d(B);
    }, $ = () => {
      d("");
    }, w = () => {
      m.current && m.current.focus();
    }, f = () => {
      e && y(!1), k(!0);
    }, v = () => {
      e && !l && y(!0), k(!1);
    }, E = (D) => {
      D.key === ie.enter && (D.preventDefault(), d(l));
    };
    return /* @__PURE__ */ g(
      "div",
      {
        "aria-expanded": C,
        role: "search",
        className: S,
        onClick: w,
        children: [
          /* @__PURE__ */ t(
            O,
            {
              className: c(
                Oe[`${at}__search-icon`],
                Oe[`${at}__search-icon--${_}`]
              ),
              source: yl,
              disabled: a,
              kind: "primary"
            }
          ),
          /* @__PURE__ */ t(
            T,
            {
              as: "div",
              className: c(
                Oe[_r],
                Oe[`${_r}--${_}`],
                n && Oe[`${_r}--crop`]
              ),
              children: /* @__PURE__ */ t(
                "input",
                {
                  role: "searchbox",
                  ref: m,
                  type: "text",
                  value: l,
                  placeholder: r,
                  onChange: N,
                  onBlur: v,
                  onFocus: f,
                  onKeyDown: E,
                  disabled: a,
                  ...u
                }
              )
            }
          ),
          x && /* @__PURE__ */ t(
            L,
            {
              "aria-label": "Clear search",
              title: "Clear search",
              className: Oe[`${at}__clear-icon`],
              onClick: $,
              icon: /* @__PURE__ */ t(O, { source: lt, kind: "primary" }),
              kind: "text",
              size: "compact"
            }
          ),
          o && /* @__PURE__ */ t("div", { className: Oe[`${at}__loader`], children: /* @__PURE__ */ t(Tr, { size: "small" }) })
        ]
      }
    );
  }
);
ss.displayName = "SearchInput";
const Ga = {
  "selectable-card": "lc-SelectableCard-module__selectable-card___b2hXr",
  "selectable-card--thumbnail": "lc-SelectableCard-module__selectable-card--thumbnail___lS1aG",
  "selectable-card__select-indicator": "lc-SelectableCard-module__selectable-card__select-indicator___JalkO",
  "selectable-card--gallery": "lc-SelectableCard-module__selectable-card--gallery___0sJB1",
  "selectable-card--interactive": "lc-SelectableCard-module__selectable-card--interactive___r8N-q",
  "selectable-card--selected": "lc-SelectableCard-module__selectable-card--selected___StMaB",
  "selectable-card__select-indicator__checkbox": "lc-SelectableCard-module__selectable-card__select-indicator__checkbox___qoZSh"
}, Ua = "selectable-card", Dr = ({
  children: e,
  className: a,
  kind: o = "interactive",
  selectionType: r,
  isSelected: _ = !1,
  onClick: l,
  style: i,
  ...n
}) => {
  const d = c(
    Ga[Ua],
    Ga[`${Ua}--${o}`],
    {
      [Ga[`${Ua}--selected`]]: _
    },
    a
  ), { handleInteractiveClick: u } = Jl({ onClick: l });
  return /* @__PURE__ */ g(
    "div",
    {
      "aria-selected": _,
      "aria-label": typeof e == "string" ? e : void 0,
      role: "button",
      tabIndex: 0,
      className: d,
      onClick: u,
      onKeyDown: (m) => {
        m.currentTarget === document.activeElement && (m.key === "Enter" || m.key === " " || m.key === "Spacebar" || m.key === "Space") && (m.preventDefault(), l?.());
      },
      style: i,
      ...n,
      children: [
        /* @__PURE__ */ t("div", { className: Ga[`${Ua}__select-indicator`], children: r === "radio" ? /* @__PURE__ */ t(_s, { tabIndex: -1, onClick: l, checked: _ }) : /* @__PURE__ */ t(
          Go,
          {
            tabIndex: -1,
            onClick: l,
            className: Ga[`${Ua}__select-indicator__checkbox`],
            checked: _
          }
        ) }),
        e
      ]
    }
  );
}, La = {
  "thumbnail-selectable-card": "lc-ThumbnailSelectableCard-module__thumbnail-selectable-card___G2B0C",
  "thumbnail-selectable-card__icon": "lc-ThumbnailSelectableCard-module__thumbnail-selectable-card__icon___GRN1c",
  "thumbnail-selectable-card__content": "lc-ThumbnailSelectableCard-module__thumbnail-selectable-card__content___-O6lf",
  "thumbnail-selectable-card__content__description": "lc-ThumbnailSelectableCard-module__thumbnail-selectable-card__content__description___b7-vQ"
}, qa = "thumbnail-selectable-card", Gu = ({
  label: e,
  description: a,
  icon: o,
  customElement: r,
  contentClassName: _,
  ...l
}) => /* @__PURE__ */ t(Dr, { ...l, kind: "thumbnail", children: /* @__PURE__ */ g(
  "div",
  {
    role: "presentation",
    className: c(La[qa], _),
    children: [
      !r && /* @__PURE__ */ g(W, { children: [
        o && /* @__PURE__ */ t("div", { className: La[`${qa}__icon`], children: o }),
        /* @__PURE__ */ g("div", { className: La[`${qa}__content`], children: [
          /* @__PURE__ */ t(T, { as: "span", className: La[`${qa}__content__label`], children: e }),
          /* @__PURE__ */ t(
            T,
            {
              size: "sm",
              as: "span",
              className: La[`${qa}__content__description`],
              children: a
            }
          )
        ] })
      ] }),
      r
    ]
  }
) }), lr = {
  "gallery-selectable-card": "lc-GallerySelectableCard-module__gallery-selectable-card___z-d6f",
  "gallery-selectable-card--with-label": "lc-GallerySelectableCard-module__gallery-selectable-card--with-label___cXRfx",
  "gallery-selectable-card__label": "lc-GallerySelectableCard-module__gallery-selectable-card__label___XTehc"
}, ir = "gallery-selectable-card", Uu = ({
  label: e,
  icon: a,
  customElement: o,
  contentClassName: r,
  className: _,
  ...l
}) => /* @__PURE__ */ t(
  Dr,
  {
    ...l,
    className: c(_, {
      [lr[`${ir}--with-label`]]: e
    }),
    kind: "gallery",
    children: /* @__PURE__ */ g(
      "div",
      {
        role: "presentation",
        className: c(lr[ir], r),
        children: [
          a && !o && a,
          o,
          e && /* @__PURE__ */ t(T, { as: "span", className: lr[`${ir}__label`], children: e })
        ]
      }
    )
  }
), ds = {
  "gallery-selectable-card": "lc-InteractiveSelectableCard-module__gallery-selectable-card___FkMyM",
  "gallery-selectable-card__label": "lc-InteractiveSelectableCard-module__gallery-selectable-card__label___2fKRM"
}, us = "interactive-selectable-card", Lu = ({
  children: e,
  contentClassName: a,
  ...o
}) => /* @__PURE__ */ t(Dr, { ...o, kind: "interactive", children: /* @__PURE__ */ t(
  "div",
  {
    role: "presentation",
    className: c(ds[us], a),
    children: e
  }
) }), K_ = {
  "grid-wrapper": "lc-InteractiveGrid-module__grid-wrapper___FnLIP",
  "grid-row": "lc-InteractiveGrid-module__grid-row___YsMbS",
  "grid-col": "lc-InteractiveGrid-module__grid-col___jDoA6"
}, ms = "grid-wrapper", qu = ({
  children: e,
  className: a
}) => /* @__PURE__ */ t("div", { className: `${K_[ms]} ${a || ""}`, children: e }), Y_ = ({ children: e, className: a, baseClass: o, role: r = "presentation" }) => /* @__PURE__ */ t("div", { role: r, className: `${K_[o]} ${a || ""}`, children: e }), Hu = (e) => /* @__PURE__ */ t(Y_, { ...e, baseClass: "grid-row" }), zu = (e) => /* @__PURE__ */ t(Y_, { ...e, baseClass: "grid-col" }), ps = "lc-Skeleton-module__loading___fc1WK", aa = {
  "skeleton-wrapper": "lc-Skeleton-module__skeleton-wrapper___5N-1n",
  "skeleton-wrapper--vertical": "lc-Skeleton-module__skeleton-wrapper--vertical___0sU7e",
  "skeleton-avatar": "lc-Skeleton-module__skeleton-avatar___7-CDQ",
  "skeleton-avatar--square": "lc-Skeleton-module__skeleton-avatar--square___NlK0K",
  "skeleton-avatar--animated": "lc-Skeleton-module__skeleton-avatar--animated___iFXkb",
  loading: ps,
  "skeleton-text": "lc-Skeleton-module__skeleton-text___WnwUw",
  "skeleton-text--animated": "lc-Skeleton-module__skeleton-text--animated___Bnr3Z"
}, i_ = "skeleton-wrapper", Vu = ({ children: e, vertical: a, animated: o, ...r }) => {
  const _ = b.Children.map(e, (l) => b.isValidElement(l) ? b.cloneElement(l, {
    animated: o
  }) : l);
  return /* @__PURE__ */ t(
    "div",
    {
      className: c(aa[`${i_}`], {
        [aa[`${i_}--vertical`]]: a
      }),
      ...r,
      children: _
    }
  );
}, nr = "skeleton-avatar", Wu = ({
  square: e = !1,
  size: a = 16,
  animated: o
}) => /* @__PURE__ */ t(
  "div",
  {
    className: c(aa[`${nr}`], {
      [aa[`${nr}--square`]]: e,
      [aa[`${nr}--animated`]]: o
    }),
    style: {
      width: a,
      height: a
    }
  }
), n_ = "skeleton-text", Ku = ({
  height: e = 13,
  width: a,
  animated: o
}) => /* @__PURE__ */ t(
  "div",
  {
    className: c(aa[`${n_}`], {
      [aa[`${n_}--animated`]]: o
    }),
    style: {
      height: e,
      width: a
    }
  }
), cr = {
  "status-badge": "lc-StatusBadge-module__status-badge___lygXF",
  "status-badge--3XS": "lc-StatusBadge-module__status-badge--3XS___A-lDu",
  "status-badge--2XS": "lc-StatusBadge-module__status-badge--2XS___7u4kB",
  "status-badge--XS": "lc-StatusBadge-module__status-badge--XS___M5fdN",
  "status-badge--SM": "lc-StatusBadge-module__status-badge--SM___How9K",
  "status-badge--MD": "lc-StatusBadge-module__status-badge--MD___tlaxX",
  "status-badge--LG": "lc-StatusBadge-module__status-badge--LG___2-7IC",
  "status-badge--XL": "lc-StatusBadge-module__status-badge--XL___m-MzF",
  "status-badge--2XL": "lc-StatusBadge-module__status-badge--2XL___lSyzS",
  "status-badge--3XL": "lc-StatusBadge-module__status-badge--3XL___LpjBZ",
  "status-badge--offline": "lc-StatusBadge-module__status-badge--offline___90IJN",
  "status-badge--accept": "lc-StatusBadge-module__status-badge--accept___UvRWg",
  "status-badge--not-accept": "lc-StatusBadge-module__status-badge--not-accept___bhNkL"
}, sr = "status-badge", Yu = ({
  className: e,
  kind: a = "offline",
  size: o = "MD",
  ...r
}) => {
  const _ = c(
    cr[sr],
    cr[`${sr}--${a}`],
    cr[`${sr}--${o}`],
    e
  );
  return /* @__PURE__ */ t("span", { className: _, ...r });
}, gs = "lc-Switch-module__switch__input___-bYMW", hs = "lc-Switch-module__switch__container___dYb8a", fs = "lc-Switch-module__switch__track___3lNXx", bs = "lc-Switch-module__switch__slider___NmDHK", vs = "lc-Switch-module__switch__loader___Pbo1Q", ys = "lc-Switch-module__switch__icon___tCZTq", de = {
  switch: "lc-Switch-module__switch___PKzsW",
  "switch__track--enabled": "lc-Switch-module__switch__track--enabled___Dwbmx",
  "switch__track--on": "lc-Switch-module__switch__track--on___7vdEj",
  "switch__track--off": "lc-Switch-module__switch__track--off___IAZA0",
  "switch--large": "lc-Switch-module__switch--large___dMF98",
  "switch--compact": "lc-Switch-module__switch--compact___T4bhh",
  "switch--medium": "lc-Switch-module__switch--medium___uruMu",
  "switch--focused": "lc-Switch-module__switch--focused___XADLL",
  switch__input: gs,
  "switch__input--disabled": "lc-Switch-module__switch__input--disabled___c1vVD",
  switch__container: hs,
  switch__track: fs,
  "switch__container--focused": "lc-Switch-module__switch__container--focused___120ao",
  "switch__track--disabled": "lc-Switch-module__switch__track--disabled___pz3md",
  switch__slider: bs,
  "switch__slider--large": "lc-Switch-module__switch__slider--large___0-Vky",
  "switch__slider--large--on": "lc-Switch-module__switch__slider--large--on___HXudz",
  "switch__slider--large--off": "lc-Switch-module__switch__slider--large--off___zPuP6",
  "switch__slider--compact": "lc-Switch-module__switch__slider--compact___GD-ov",
  "switch__slider--compact--on": "lc-Switch-module__switch__slider--compact--on___VhXTF",
  "switch__slider--compact--off": "lc-Switch-module__switch__slider--compact--off___a0WyG",
  "switch__slider--medium": "lc-Switch-module__switch__slider--medium___j3xMd",
  "switch__slider--medium--on": "lc-Switch-module__switch__slider--medium--on___WNNGh",
  "switch__slider--medium--off": "lc-Switch-module__switch__slider--medium--off___pkbCl",
  "switch__slider--disabled": "lc-Switch-module__switch__slider--disabled___6rrSU",
  switch__loader: vs,
  "switch__loader--compact": "lc-Switch-module__switch__loader--compact___jKLak",
  "switch__loader--medium": "lc-Switch-module__switch__loader--medium___XpfaO",
  "switch__loader--large": "lc-Switch-module__switch__loader--large___NDgeg",
  switch__icon: ys
}, ne = "switch", Xu = ({
  className: e = "",
  defaultOn: a = !1,
  disabled: o = !1,
  name: r = ne,
  on: _,
  onChange: l,
  size: i = "large",
  state: n = "regular",
  innerRef: d,
  ariaLabel: u,
  ...s
}) => {
  const m = _ !== void 0, [h, y] = b.useState(
    () => m ? _ : a
  ), [p, k] = b.useState(!1), x = m ? _ : h, C = n === "loading", S = n === "locked", N = i === "large" ? "small" : "xsmall", $ = x ? "on" : "off", w = o || C || S, f = w ? "disabled" : "enabled", v = c(
    de[ne],
    de[`${ne}--${i}`],
    {
      [de[`${ne}--focused`]]: p
    },
    e
  ), E = (D) => {
    l?.(D, !x), m || (D.stopPropagation(), y((B) => !B));
  };
  return /* @__PURE__ */ g("span", { className: v, children: [
    /* @__PURE__ */ t(
      "input",
      {
        type: "checkbox",
        className: c(
          de[`${ne}__input`],
          de[`${ne}__input--${f}`]
        ),
        onChange: E,
        checked: x,
        name: r,
        ref: d,
        disabled: w,
        "aria-label": u,
        ...s,
        onFocus: () => k(!0),
        onBlur: () => k(!1)
      }
    ),
    /* @__PURE__ */ g(
      "span",
      {
        className: c(de[`${ne}__container`], {
          [de[`${ne}__container--focused`]]: p
        }),
        children: [
          /* @__PURE__ */ t(
            "span",
            {
              className: c(
                de[`${ne}__track`],
                de[`${ne}__track--${$}`],
                de[`${ne}__track--${f}`]
              )
            }
          ),
          /* @__PURE__ */ g(
            "span",
            {
              className: c(
                de[`${ne}__slider`],
                de[`${ne}__slider--${f}`],
                de[`${ne}__slider--${i}`],
                de[`${ne}__slider--${i}--${$}`]
              ),
              children: [
                C && /* @__PURE__ */ t(
                  Tr,
                  {
                    "data-testid": "switch-loader",
                    className: c(
                      de[`${ne}__loader`],
                      de[`${ne}__loader--${i}`]
                    )
                  }
                ),
                S && /* @__PURE__ */ t(
                  O,
                  {
                    className: de[`${ne}__icon`],
                    "data-testid": "lock-icon",
                    size: N,
                    source: kl,
                    kind: "primary"
                  }
                )
              ]
            }
          )
        ]
      }
    )
  ] });
}, ks = "lc-Tab-module__tab___ShyYn", Cs = "lc-Tab-module__tab__count___7QKoz", ws = "lc-Tab-module__tab__icon___eCD-d", $s = "lc-Tab-module__tab__badge___nwfVJ", jt = {
  tab: ks,
  tab__count: Cs,
  "tab--compact": "lc-Tab-module__tab--compact___yetP5",
  "tab--medium": "lc-Tab-module__tab--medium___KhPsI",
  "tab--large": "lc-Tab-module__tab--large___3GE8k",
  tab__icon: ws,
  tab__badge: $s,
  "tab--selected": "lc-Tab-module__tab--selected___vsPhT",
  "tab--disabled": "lc-Tab-module__tab--disabled___JPMHC"
}, Jt = "tab", Zu = ({
  children: e,
  className: a,
  count: o,
  isSelected: r,
  asBadge: _,
  size: l = "medium",
  icon: i,
  ...n
}) => {
  const { disabled: d } = n, u = o !== void 0 && !_, s = o !== void 0 && _;
  return /* @__PURE__ */ g(
    T,
    {
      ...n,
      as: n.href ? "a" : "button",
      "aria-selected": r,
      size: "md",
      bold: r,
      className: c(
        a,
        jt[Jt],
        jt[`${Jt}--${l}`],
        r && jt[`${Jt}--selected`],
        d && jt[`${Jt}--disabled`]
      ),
      children: [
        i && /* @__PURE__ */ t("div", { "data-testId": "icon", className: jt[`${Jt}__icon`], children: i }),
        e,
        u && /* @__PURE__ */ g(T, { as: "span", size: "md", className: jt[`${Jt}__count`], children: [
          "(",
          o,
          ")"
        ] }),
        s && /* @__PURE__ */ t(
          To,
          {
            "data-testid": "tab-badge",
            count: o,
            size: "compact",
            className: jt[`${Jt}__badge`]
          }
        )
      ]
    }
  );
}, Ss = "lc-TabsWrapper-module__tabs___rJby-", Ns = "lc-TabsWrapper-module__tabs__list___ylJuP", X_ = {
  tabs: Ss,
  tabs__list: Ns
}, Z_ = "tabs", ju = ({ className: e, children: a }) => /* @__PURE__ */ t("div", { className: c(X_[Z_], e), children: a }), Ju = ({ className: e, children: a }) => /* @__PURE__ */ t("div", { role: "tablist", className: c(X_[`${Z_}__list`], e), children: a }), xs = ({
  data: e,
  getRowId: a,
  selectedRows: o,
  onSelectionChange: r
}) => {
  const _ = ht(
    (n) => !!o?.has(n),
    [o]
  ), l = ht(
    (n) => {
      const d = new Set(o || []);
      d.has(n) ? d.delete(n) : d.add(n), r?.(d);
    },
    [o, r]
  ), i = ht(() => {
    const n = new Set(e.map(a)), u = o?.size === e.length ? /* @__PURE__ */ new Set() : n;
    r?.(u);
  }, [e, a, o, r]);
  return {
    isSelected: _,
    toggleRowSelection: l,
    toggleSelectAll: i,
    selectedCount: o?.size
  };
}, Es = "lc-TableRow-module__row___NrIRP", Ts = "lc-TableRow-module__table__header___eVCSg", Bs = "lc-TableRow-module__row__selected___8IvPR", dr = {
  row: Es,
  table__header: Ts,
  "row__select-cell": "lc-TableRow-module__row__select-cell___SecNT",
  row__selected: Bs
}, ur = "row", Is = ({
  row: e,
  columns: a,
  columnWidths: o,
  selectable: r,
  isSelected: _,
  toggleRowSelection: l,
  rowId: i
}) => /* @__PURE__ */ g(
  "tr",
  {
    className: c(
      dr[ur],
      _(i) ? dr[`${ur}__selected`] : void 0
    ),
    children: [
      r && /* @__PURE__ */ t(
        "td",
        {
          role: "cell",
          "aria-selected": _(i),
          className: dr[`${ur}__select-cell`],
          children: /* @__PURE__ */ t(
            Go,
            {
              checked: _(i),
              onChange: () => l(i)
            }
          )
        }
      ),
      a.map((n, d) => /* @__PURE__ */ t(
        "td",
        {
          style: {
            width: o[d] ? `${o[d]}px` : "auto"
          },
          role: "cell",
          "data-column": String(n.key),
          children: /* @__PURE__ */ t(T, { size: "md", noMargin: !0, children: e[n.key] })
        },
        String(n.key)
      ))
    ]
  }
), As = ({
  data: e,
  columns: a,
  getRowId: o,
  columnWidths: r,
  selectable: _,
  isSelected: l,
  toggleRowSelection: i
}) => /* @__PURE__ */ t("tbody", { role: "rowgroup", children: e.map((n) => {
  const d = o(n);
  return /* @__PURE__ */ t(
    Is,
    {
      row: n,
      columns: a,
      columnWidths: r,
      selectable: _,
      isSelected: l,
      toggleRowSelection: i,
      rowId: o(n)
    },
    d
  );
}) });
var Re = /* @__PURE__ */ ((e) => (e.Ascending = "asc", e.Descending = "desc", e.None = "none", e))(Re || {});
const Ds = "lc-TableHeader-module__header___JDLIB", Os = "lc-TableHeader-module__header__cell___aYvzx", Ps = "lc-TableHeader-module__header__hiddenIcon___NNtMw", Ms = "lc-TableHeader-module__header__resizer___h-Al0", Rs = "lc-TableHeader-module__header__content___LRMNn", Qt = {
  header: Ds,
  header__cell: Os,
  "header__cell--hoverDisabled": "lc-TableHeader-module__header__cell--hoverDisabled___PaQRH",
  header__hiddenIcon: Ps,
  header__resizer: Ms,
  header__content: Rs,
  "header__select-cell": "lc-TableHeader-module__header__select-cell___H9qHi",
  "header--selectable": "lc-TableHeader-module__header--selectable___yPgDs"
}, oa = "header", Fs = `${oa}__cell`, Gs = `${oa}__resizer`, Us = `${oa}__content`, Ls = `${oa}__hiddenIcon`;
function qs(e, a, o, r) {
  return e.key === a && e.direction !== Re.None && o ? /* @__PURE__ */ t(
    O,
    {
      source: e.direction === Re.Ascending ? Cl : wl,
      kind: "primary"
    }
  ) : r && o ? /* @__PURE__ */ t(O, { source: $l, kind: "subtle" }) : /* @__PURE__ */ t(O, { source: Sl, className: Qt[Ls] });
}
const Hs = ({
  columns: e,
  sortConfig: a,
  handleSort: o,
  resizable: r,
  handleMouseDown: _,
  columnRefs: l,
  selectable: i,
  hoveredColumnIndex: n,
  setHoveredColumnIndex: d,
  selectedCount: u,
  dataLength: s,
  toggleSelectAll: m
}) => /* @__PURE__ */ t("thead", { children: /* @__PURE__ */ g(
  "tr",
  {
    className: c(Qt[oa], {
      [Qt[`${oa}--selectable`]]: i && !!u
    }),
    children: [
      i && /* @__PURE__ */ t(
        "th",
        {
          className: Qt[`${oa}__select-cell`],
          onClick: m,
          children: /* @__PURE__ */ t(
            Go,
            {
              checked: u === s,
              indeterminate: u !== void 0 && u > 0 && u < (s || 0)
            }
          )
        }
      ),
      e.map((h, y) => /* @__PURE__ */ t(
        "th",
        {
          ref: (p) => {
            l.current && (l.current[y] = p);
          },
          className: c({
            [Qt[`${Fs}--hoverDisabled`]]: !h.sortable
          }),
          onMouseEnter: () => d(y),
          onMouseLeave: () => d(null),
          role: "columnheader",
          children: /* @__PURE__ */ g(
            "span",
            {
              onClick: () => {
                h.sortable && o(h.key);
              },
              className: Qt[Us],
              children: [
                /* @__PURE__ */ t(T, { size: "sm", bold: !0, noMargin: !0, children: h.header }),
                qs(
                  a,
                  h.key,
                  h.sortable ?? !1,
                  n === y
                ),
                r && /* @__PURE__ */ t(
                  "span",
                  {
                    className: Qt[Gs],
                    onMouseDown: (p) => _(y, p),
                    role: "button",
                    "aria-label": "resize"
                  }
                )
              ]
            }
          )
        },
        String(h.key)
      ))
    ]
  }
) }), zs = "lc-Table-module__table___-ZPCW", Vs = "lc-Table-module__table__cell___8rtqj", Ws = "lc-Table-module__table__selected___f9beX", Ks = "lc-Table-module__table__selected__divider___VlK4B", Ys = "lc-Table-module__table__selected__checkbox___4yJlB", Xs = "lc-Table-module__table__selected__content___9LKcS", Et = {
  table: zs,
  "table--small": "lc-Table-module__table--small___DuQa-",
  "table--medium": "lc-Table-module__table--medium___pe9rZ",
  "table--large": "lc-Table-module__table--large___8PMkf",
  "table--pinned_header": "lc-Table-module__table--pinned_header___5SrTn",
  "table--pinned_header--selectable": "lc-Table-module__table--pinned_header--selectable___R5ZXX",
  "table--has-selected": "lc-Table-module__table--has-selected___U7gSR",
  "table--pinned_leftColumn": "lc-Table-module__table--pinned_leftColumn___GWfss",
  table__cell: Vs,
  table__selected: Ws,
  "table__selected--visible": "lc-Table-module__table__selected--visible___RTjMS",
  "table__selected--hidden": "lc-Table-module__table__selected--hidden___Wu9PE",
  table__selected__divider: Ks,
  table__selected__checkbox: Ys,
  table__selected__content: Xs,
  "table--stripped_rows": "lc-Table-module__table--stripped_rows___ALUEi",
  "table--stripped_columns": "lc-Table-module__table--stripped_columns___JQlQW"
}, ea = "table", $o = `${ea}__selected`, Qu = ({
  data: e,
  columns: a,
  stripped: o,
  size: r = "medium",
  pin: _,
  selectable: l,
  getRowId: i,
  resizable: n,
  selectedRows: d,
  onSelectionChange: u,
  rowSelectionMessage: s,
  rowActions: m,
  testId: h,
  customBackgroundColor: y
}) => {
  const p = b.useRef([]), [k, x] = b.useState(null), { isSelected: C, toggleRowSelection: S, toggleSelectAll: N, selectedCount: $ } = xs({
    data: e,
    getRowId: i,
    selectedRows: d,
    onSelectionChange: u
  }), [w, f] = b.useState({
    key: null,
    direction: Re.None
  }), [v, E] = b.useState(Array(a.length).fill(void 0)), D = (P, A) => {
    A.preventDefault();
    const F = A.clientX, R = v[P] || A.currentTarget.offsetWidth, U = v[P + 1] || 0, ge = 1.05, oe = (Q) => {
      const K = (Q.clientX - F) * ge;
      E((he) => {
        const Ve = [...he], We = Math.max(50, R + K), it = Math.max(50, U - K);
        return Ve[P] = We, P + 1 < Ve.length && (Ve[P + 1] = it), Ve;
      });
    }, se = () => {
      document.removeEventListener("mousemove", oe), document.removeEventListener("mouseup", se);
    };
    document.addEventListener("mousemove", oe), document.addEventListener("mouseup", se);
  }, B = (P) => {
    const A = a.find((F) => F.key === P);
    !A || A.sortable === !1 || f((F) => {
      if (F.key === P) {
        let R;
        switch (F.direction) {
          case Re.None:
            R = Re.Ascending;
            break;
          case Re.Ascending:
            R = Re.Descending;
            break;
          default:
            R = Re.None;
        }
        return {
          key: R === Re.None ? null : P,
          direction: R
        };
      } else
        return { key: P, direction: Re.Ascending };
    });
  }, M = b.useMemo(() => {
    if (!w.key || w.direction === Re.None)
      return e;
    const P = a.find((A) => A.key === w.key);
    return P ? [...e].sort((A, F) => {
      const R = P.sortable ? P.sortValue(A) : A[w.key], U = P.sortable ? P.sortValue(F) : F[w.key];
      return R < U ? w.direction === Re.Ascending ? -1 : 1 : R > U ? w.direction === Re.Ascending ? 1 : -1 : 0;
    }) : e;
  }, [e, w, a]);
  b.useEffect(() => {
    const P = p.current.map(
      (A) => A?.offsetWidth || 0
    );
    E(P);
  }, []);
  const I = y ? {
    "--custom-table-bg": y
  } : {};
  return /* @__PURE__ */ g(W, { children: [
    /* @__PURE__ */ g(
      "div",
      {
        className: c(Et[`${$o}`], {
          [Et[`${$o}--visible`]]: l && !!$,
          [Et[`${$o}--hidden`]]: !l
        }),
        children: [
          /* @__PURE__ */ t("div", { className: Et[`${$o}__content`], children: s || /* @__PURE__ */ g(T, { noMargin: !0, bold: !0, size: "sm", children: [
            $,
            " selected"
          ] }) }),
          /* @__PURE__ */ t("div", { children: m })
        ]
      }
    ),
    /* @__PURE__ */ g(
      "table",
      {
        className: c(
          Et[`${ea}`],
          Et[`${ea}--${r}`],
          Et[`${ea}--pinned_${_}`],
          l && Et[`${ea}--pinned_header--selectable`],
          l && !!$ && Et[`${ea}--has-selected`],
          Et[`${ea}--stripped_${o}`]
        ),
        "data-testid": h,
        style: I,
        children: [
          /* @__PURE__ */ t(
            Hs,
            {
              columns: a,
              sortConfig: w,
              handleSort: B,
              resizable: n,
              handleMouseDown: D,
              columnRefs: p,
              selectable: l,
              hoveredColumnIndex: k,
              setHoveredColumnIndex: x,
              selectedCount: $,
              dataLength: e.length,
              toggleSelectAll: N
            }
          ),
          /* @__PURE__ */ t(
            As,
            {
              data: M,
              columns: a,
              getRowId: i,
              columnWidths: v,
              selectable: l,
              isSelected: C,
              toggleRowSelection: S
            }
          )
        ]
      }
    )
  ] });
}, Va = {
  "tag-input": "lc-TagInput-module__tag-input___zQKuG",
  "tag-input--error": "lc-TagInput-module__tag-input--error___0iuR-",
  "tag-input__input": "lc-TagInput-module__tag-input__input___skuNT",
  "tag-input__input--medium": "lc-TagInput-module__tag-input__input--medium___9ifYO",
  "tag-input__input--large": "lc-TagInput-module__tag-input__input--large___0xBUb",
  "tag-input__tag__content": "lc-TagInput-module__tag-input__tag__content___glcu0"
}, Zs = ({
  className: e = "",
  innerEditableRef: a,
  inputRef: o,
  change: r,
  remove: _,
  value: l
}) => {
  const [i, n] = b.useState(!1), d = () => a.current, u = () => {
    const p = d();
    return p ? p.innerText : "";
  }, s = () => {
    o && o.current && o.current.focus();
  };
  return /* @__PURE__ */ t(
    "div",
    {
      ref: a,
      className: e,
      contentEditable: !0,
      onPaste: (p) => {
        p.preventDefault();
        const k = p.clipboardData.getData("text/plain");
        document.execCommand("insertHTML", !1, Rr(k));
      },
      onBlur: () => {
        const p = d();
        if (!(i || !p)) {
          if (p.innerText === "") {
            _();
            return;
          }
          r(p.innerText);
        }
      },
      onKeyDown: (p) => {
        if (p.key === ie.enter) {
          p.preventDefault(), s();
          return;
        }
        p.key === ie.backspace && u() === "" && (n(!0), _(), s());
      },
      dangerouslySetInnerHTML: { __html: Rr(l) }
    }
  );
}, js = "tag-input__tag", c_ = ({
  children: e,
  index: a,
  remove: o,
  validator: r,
  inputRef: _,
  update: l,
  size: i,
  tagProps: n
}) => {
  const d = b.useMemo(() => r !== void 0 ? r(e) : !0, [e, r]), u = b.useRef(null), s = () => o(a);
  return /* @__PURE__ */ t(R_, { size: i, ...n, kind: d ? n ? n.kind : "default" : "error", onRemove: s, children: /* @__PURE__ */ t(
    Zs,
    {
      value: e,
      inputRef: _,
      innerEditableRef: u,
      className: Va[`${js}__content`],
      change: (h) => l(a, h),
      remove: s,
      validator: r
    }
  ) });
}, So = "tag-input", Js = [
  ie.enter,
  ie.spacebar,
  ie.tab,
  ie.semicolon,
  ie.comma
], Qs = [ie.backspace, ie.delete], ed = ({
  id: e,
  tags: a,
  onChange: o,
  validator: r,
  error: _,
  placeholder: l,
  size: i = "medium",
  className: n,
  inputClassName: d,
  onBlur: u,
  addOnBlur: s = !0,
  readOnly: m,
  noDataFallbackText: h = "No data",
  ...y
}) => {
  const p = c(
    Va[So],
    {
      [Va[`${So}--error`]]: _
    },
    n
  ), k = c(
    d,
    Va[`${So}__input`],
    Va[`${So}__input--${i}`]
  ), [x, C] = b.useState(""), S = b.useRef(null), { readOnly: N } = Tt(), $ = N || m, w = (A) => {
    A.trim() !== "" && (o([...a || [], A]), C(""));
  }, f = (A) => {
    const F = [...a || []];
    F.splice(A, 1), o(F);
  }, v = (A) => C(A.target.value), E = (A) => {
    if (Js.includes(A.key)) {
      if (A.preventDefault(), x === "")
        return;
      w(x);
    } else if (Qs.includes(A.key)) {
      if (x !== "" || !a?.length)
        return;
      f(a.length - 1);
    }
  }, D = (A) => {
    s && w(x), u?.(A);
  }, B = (A, F) => {
    const R = [...a || []];
    R.reduce(
      (ge, oe, se) => ge + (oe === F && se !== A ? 1 : 0),
      0
    ) > 0 ? R.splice(A, 1) : R[A] = F, o(R);
  }, M = (A) => {
    A.preventDefault();
    const R = A.clipboardData.getData("text/plain").split(/[\s,;\n]+/);
    o([...a || [], ...R]);
  }, I = (A) => typeof A == "string" ? A : A.value || (typeof A.children == "string" ? A.children : "");
  if ($)
    return /* @__PURE__ */ t(
      va,
      {
        value: a?.filter(Boolean).map(I).join(", "),
        noDataFallbackText: h
      }
    );
  const P = (A, F) => typeof A == "string" ? /* @__PURE__ */ t(
    c_,
    {
      index: F,
      update: B,
      remove: f,
      inputRef: S,
      validator: r,
      size: i,
      children: A
    },
    `${F}${A}`
  ) : /* @__PURE__ */ t(
    c_,
    {
      index: F,
      update: B,
      remove: f,
      inputRef: S,
      validator: r,
      size: i,
      tagProps: A,
      children: A.value || A.children
    },
    `${F}${A.children}`
  );
  return /* @__PURE__ */ g(W, { children: [
    /* @__PURE__ */ g(T, { as: "div", className: p, children: [
      a?.map(P),
      /* @__PURE__ */ t(
        "input",
        {
          ...y,
          id: e,
          ref: S,
          className: k,
          placeholder: l,
          value: x,
          onChange: v,
          onKeyDown: E,
          onPaste: M,
          onBlur: D
        }
      )
    ] }),
    _ && /* @__PURE__ */ t(Ir, { children: _ })
  ] });
}, td = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)])$/i, ad = "name@company.com", od = (e) => td.test(e), em = ({
  placeholder: e = ad,
  ...a
}) => /* @__PURE__ */ t(ed, { ...a, placeholder: e, validator: od }), rd = "lc-Toast-module__toast___ngbBR", _d = "lc-Toast-module__toast__content___XGt2m", ld = "lc-Toast-module__toast__actions___iFshW", id = "lc-Toast-module__toast__actions__button___sQIbQ", pe = {
  toast: rd,
  toast__content: _d,
  toast__actions: ld,
  toast__actions__button: id,
  "toast__actions__button--success": "lc-Toast-module__toast__actions__button--success___p53MR",
  "toast__actions__button--warning": "lc-Toast-module__toast__actions__button--warning___fCMO5",
  "toast__actions__button--error": "lc-Toast-module__toast__actions__button--error___hct1w",
  "toast__actions__button--info": "lc-Toast-module__toast__actions__button--info___KLzoG",
  "toast__actions--custom": "lc-Toast-module__toast__actions--custom___Lao00",
  "toast--success": "lc-Toast-module__toast--success___AcCed",
  "toast--warning": "lc-Toast-module__toast--warning___RsGqU",
  "toast--error": "lc-Toast-module__toast--error___a7RTS",
  "toast--info": "lc-Toast-module__toast--info___9t8Za",
  "toast-wrapper": "lc-Toast-module__toast-wrapper___jVb0j",
  "toast-wrapper--fixed": "lc-Toast-module__toast-wrapper--fixed___Wo3QO",
  "toast-wrapper--block": "lc-Toast-module__toast-wrapper--block___LNWD0",
  "toast-wrapper--horizontal-center": "lc-Toast-module__toast-wrapper--horizontal-center___yR1at",
  "toast-wrapper--horizontal-left": "lc-Toast-module__toast-wrapper--horizontal-left___CY-Z-",
  "toast-wrapper--horizontal-right": "lc-Toast-module__toast-wrapper--horizontal-right___f7ts5",
  "toast-wrapper--vertical-top": "lc-Toast-module__toast-wrapper--vertical-top___-8YHw",
  "toast-appear--slide": "lc-Toast-module__toast-appear--slide___vNvCV",
  "toast-appear-active--slide": "lc-Toast-module__toast-appear-active--slide___ROIEb",
  "toast-exit--slide": "lc-Toast-module__toast-exit--slide___DVOQp",
  "toast-exit-active--slide": "lc-Toast-module__toast-exit-active--slide___rBWPS",
  "toast-wrapper--vertical-bottom": "lc-Toast-module__toast-wrapper--vertical-bottom___rihzw",
  "toast-appear--fade": "lc-Toast-module__toast-appear--fade___AcODR",
  "toast-appear-active--fade": "lc-Toast-module__toast-appear-active--fade___Z39eu",
  "toast-exit--fade": "lc-Toast-module__toast-exit--fade___1t0Qp",
  "toast-exit-active--fade": "lc-Toast-module__toast-exit-active--fade___UK5Kw"
}, nd = {
  success: {
    source: $r
  },
  warning: {
    source: g_
  },
  error: {
    source: p_
  },
  info: {
    source: Eo
  }
}, Wt = "toast", cd = ({
  action: e,
  className: a,
  children: o,
  removable: r,
  kind: _ = "info",
  onClose: l,
  ...i
}) => {
  const n = c(
    pe[Wt],
    pe[`${Wt}--${_}`],
    a
  ), d = typeof o == "string", u = (s) => s && s.closesOnClick && l ? (s.onClick(), l()) : s.onClick();
  return /* @__PURE__ */ g("div", { className: n, ...i, children: [
    /* @__PURE__ */ t("div", { className: pe[`${Wt}__icon`], children: /* @__PURE__ */ t(O, { ...nd[_], size: "medium" }) }),
    /* @__PURE__ */ t("div", { className: pe[`${Wt}__content`], children: d ? /* @__PURE__ */ t(T, { as: "div", children: o }) : o }),
    (e || r) && /* @__PURE__ */ g("div", { className: pe[`${Wt}__actions`], children: [
      e && /* @__PURE__ */ t(
        L,
        {
          className: pe[`${Wt}__actions--custom`],
          kind: "text",
          size: "compact",
          onClick: () => u(e),
          children: e.label
        }
      ),
      r && /* @__PURE__ */ t(
        "button",
        {
          className: c(
            pe[`${Wt}__actions__button`],
            pe[`${Wt}__actions__button--${_}`]
          ),
          "aria-label": "Close toast",
          onClick: l,
          children: /* @__PURE__ */ t(O, { source: lt, size: "medium" })
        }
      )
    ] })
  ] });
}, sd = 200, Ha = "toast-wrapper", tm = ({
  className: e,
  toasts: a = [],
  fixed: o = !0,
  block: r = !1,
  animationType: _ = "slide",
  verticalPosition: l = "top",
  horizontalPosition: i = "center"
}) => {
  const n = c(
    pe[Ha],
    {
      [pe[`${Ha}--fixed`]]: o,
      [pe[`${Ha}--block`]]: !o && r,
      [pe[`${Ha}--horizontal-${i}`]]: i,
      [pe[`${Ha}--vertical-${l}`]]: l
    },
    e
  );
  return /* @__PURE__ */ t("div", { className: n, children: /* @__PURE__ */ t(k_, { component: null, children: a.map(({ id: d, kind: u, content: s, removable: m, action: h, onClose: y }) => /* @__PURE__ */ t(
    C_,
    {
      classNames: {
        enter: pe[`toast-appear--${_}`],
        enterActive: pe[`toast-appear-active--${_}`],
        exit: pe[`toast-exit--${_}`],
        exitActive: pe[`toast-exit-active--${_}`]
      },
      timeout: sd,
      children: /* @__PURE__ */ t(
        cd,
        {
          kind: u,
          onClose: y,
          removable: m,
          action: h,
          children: s
        }
      )
    },
    d
  )) }) });
}, dd = "lc-Textarea-module__textarea___yE6jp", No = {
  textarea: dd,
  "textarea--focused": "lc-Textarea-module__textarea--focused___YnB5S",
  "textarea--disabled": "lc-Textarea-module__textarea--disabled___zZJAq",
  "textarea--error": "lc-Textarea-module__textarea--error___n-fD5"
}, xo = "textarea", am = b.forwardRef(
  ({ className: e, noDataFallbackText: a = "No data", error: o, ...r }, _) => {
    const { disabled: l, onBlur: i, onFocus: n } = r, { readOnly: d } = Tt(), u = d || r.readOnly, [s, m] = b.useState(!1), h = c(e, No[xo], {
      [No[`${xo}--disabled`]]: l,
      [No[`${xo}--focused`]]: s,
      [No[`${xo}--error`]]: o
    }), y = (k) => {
      m(!1), i?.(k);
    }, p = (k) => {
      m(!0), n?.(k);
    };
    return u ? /* @__PURE__ */ t(
      va,
      {
        value: r?.value?.toString(),
        noDataFallbackText: a
      }
    ) : /* @__PURE__ */ t(T, { as: "div", className: h, children: /* @__PURE__ */ t(
      "textarea",
      {
        ...r,
        ref: _,
        onFocus: p,
        onBlur: y
      }
    ) });
  }
), ud = {
  "update-badge": "lc-UpdateBadge-module__update-badge___heZyU"
}, md = "update-badge", om = () => /* @__PURE__ */ t("span", { className: ud[md] }), pd = "data:image/svg+xml,%3csvg%20width='40'%20height='43'%20viewBox='0%200%2040%2043'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20filter='url(%23filter0_d_2511_27812)'%3e%3cpath%20d='M12.1399%2028.6143L20.0002%2010.6475L27.8604%2028.6143L20.0002%2025.3255L12.1399%2028.6143Z'%20fill='%23050505'/%3e%3cpath%20d='M20.9164%2010.2467C20.7572%209.88266%2020.3976%209.64746%2020.0002%209.64746C19.6029%209.64746%2019.2433%209.88266%2019.0841%2010.2466L11.2237%2028.2134C11.0599%2028.5879%2011.1404%2029.0243%2011.4271%2029.3156C11.7138%2029.607%2012.1488%2029.6945%2012.5259%2029.5368L20.0002%2026.4095L27.4744%2029.5368C27.8514%2029.6945%2028.2865%2029.607%2028.5731%2029.3156C28.8598%2029.0243%2028.9403%2028.5879%2028.7765%2028.2135L20.9164%2010.2467Z'%20stroke='url(%23paint0_linear_2511_27812)'%20stroke-width='2'%20stroke-linejoin='round'/%3e%3c/g%3e%3cdefs%3e%3cfilter%20id='filter0_d_2511_27812'%20x='0.139893'%20y='0.647461'%20width='39.7205'%20height='41.9668'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='2'/%3e%3cfeGaussianBlur%20stdDeviation='5'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='out'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200.25%200'/%3e%3cfeBlend%20mode='normal'%20in2='BackgroundImageFix'%20result='effect1_dropShadow_2511_27812'/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='effect1_dropShadow_2511_27812'%20result='shape'/%3e%3c/filter%3e%3clinearGradient%20id='paint0_linear_2511_27812'%20x1='19'%20y1='37'%20x2='19.9864'%20y2='9.0268'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.318907'%20stop-color='%23CE97FE'/%3e%3cstop%20offset='0.456699'%20stop-color='%237000FF'/%3e%3cstop%20offset='0.690444'%20stop-color='%2300B3FF'/%3e%3cstop%20offset='0.955729'%20stop-color='white'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e";
class gd {
  element;
  padding;
  constructor(a, o) {
    this.element = a, this.padding = o;
  }
  addPadding(a) {
    const o = Math.ceil(a.left) - this.padding, r = Math.ceil(a.top) - this.padding, _ = Math.ceil(a.width) + 2 * this.padding, l = Math.ceil(a.height) + 2 * this.padding, i = r, n = o, d = i + l, u = n + _;
    return {
      x: o,
      y: r,
      width: _,
      height: l,
      top: i,
      left: n,
      bottom: d,
      right: u
    };
  }
  getBoundingClientRect() {
    return this.addPadding(this.element.getBoundingClientRect());
  }
  get clientWidth() {
    return this.getBoundingClientRect().width;
  }
  get clientHeight() {
    return this.getBoundingClientRect().height;
  }
}
const ut = {
  "user-guide__overlay": "lc-UserGuide-module__user-guide__overlay___xc8t9",
  "fade-in": "lc-UserGuide-module__fade-in___KEPPX",
  "user-guide__overlay__content": "lc-UserGuide-module__user-guide__overlay__content___Yu-6p",
  "user-guide__floating": "lc-UserGuide-module__user-guide__floating___RgxA2",
  "user-guide__floating--fast1": "lc-UserGuide-module__user-guide__floating--fast1___atd8C",
  "user-guide__floating--fast2": "lc-UserGuide-module__user-guide__floating--fast2___9zmT1",
  "user-guide__floating--moderate1": "lc-UserGuide-module__user-guide__floating--moderate1___4ZyOo",
  "user-guide__floating--moderate2": "lc-UserGuide-module__user-guide__floating--moderate2___-21Qx",
  "user-guide__guide": "lc-UserGuide-module__user-guide__guide___jCOMd",
  "user-guide__guide--right-start": "lc-UserGuide-module__user-guide__guide--right-start___dL15C",
  "user-guide__guide--left-start": "lc-UserGuide-module__user-guide__guide--left-start___d0zgg",
  "user-guide__guide--right": "lc-UserGuide-module__user-guide__guide--right___l-xa1",
  "user-guide__guide--left": "lc-UserGuide-module__user-guide__guide--left___b37DE",
  "user-guide__guide--right-end": "lc-UserGuide-module__user-guide__guide--right-end___ZrcKz",
  "user-guide__guide--left-end": "lc-UserGuide-module__user-guide__guide--left-end___P2R4X",
  "user-guide__guide--bottom-start": "lc-UserGuide-module__user-guide__guide--bottom-start___2nDLB",
  "user-guide__guide--top-start": "lc-UserGuide-module__user-guide__guide--top-start___dVZk-",
  "user-guide__guide--bottom": "lc-UserGuide-module__user-guide__guide--bottom___xKUf7",
  "user-guide__guide--top": "lc-UserGuide-module__user-guide__guide--top___VyXt3",
  "user-guide__guide--bottom-end": "lc-UserGuide-module__user-guide__guide--bottom-end___Sb3iU",
  "user-guide__guide--top-end": "lc-UserGuide-module__user-guide__guide--top-end___8BFCP",
  "user-guide__guide__arrow": "lc-UserGuide-module__user-guide__guide__arrow___Q5eJf",
  "user-guide__guide__arrow--fast1": "lc-UserGuide-module__user-guide__guide__arrow--fast1___p2D2X",
  "user-guide__guide__arrow--fast2": "lc-UserGuide-module__user-guide__guide__arrow--fast2___0uHUD",
  "user-guide__guide__arrow--moderate1": "lc-UserGuide-module__user-guide__guide__arrow--moderate1___5HE6Z",
  "user-guide__guide__arrow--moderate2": "lc-UserGuide-module__user-guide__guide__arrow--moderate2___jc9X8",
  "user-guide__guide__arrow--right-start": "lc-UserGuide-module__user-guide__guide__arrow--right-start___-uKZa",
  "user-guide__guide__arrow--right": "lc-UserGuide-module__user-guide__guide__arrow--right___gk-Jy",
  "user-guide__guide__arrow--right-end": "lc-UserGuide-module__user-guide__guide__arrow--right-end___FivLG",
  "user-guide__guide__arrow--bottom-start": "lc-UserGuide-module__user-guide__guide__arrow--bottom-start___RgKv9",
  "user-guide__guide__arrow--bottom": "lc-UserGuide-module__user-guide__guide__arrow--bottom___biAvs",
  "user-guide__guide__arrow--bottom-end": "lc-UserGuide-module__user-guide__guide__arrow--bottom-end___-UTZt",
  "user-guide__guide__arrow--top-start": "lc-UserGuide-module__user-guide__guide__arrow--top-start___suNzB",
  "user-guide__guide__arrow--top": "lc-UserGuide-module__user-guide__guide__arrow--top___2Jhvm",
  "user-guide__guide__arrow--top-end": "lc-UserGuide-module__user-guide__guide__arrow--top-end___flgo3",
  "user-guide__guide__arrow--left-start": "lc-UserGuide-module__user-guide__guide__arrow--left-start___wsidk",
  "user-guide__guide__arrow--left": "lc-UserGuide-module__user-guide__guide__arrow--left___44rSO",
  "user-guide__guide__arrow--left-end": "lc-UserGuide-module__user-guide__guide__arrow--left-end___SkNP2",
  "user-guide__guide__content": "lc-UserGuide-module__user-guide__guide__content___zlQji",
  "user-guide__guide__content--right-start": "lc-UserGuide-module__user-guide__guide__content--right-start___O1mf7",
  "fade-in-right-start": "lc-UserGuide-module__fade-in-right-start___n3frf",
  "user-guide__guide__content--right": "lc-UserGuide-module__user-guide__guide__content--right___G8NhS",
  "fade-in-right": "lc-UserGuide-module__fade-in-right___BBHBW",
  "user-guide__guide__content--right-end": "lc-UserGuide-module__user-guide__guide__content--right-end___1SSSy",
  "fade-in-right-end": "lc-UserGuide-module__fade-in-right-end___ETdwQ",
  "user-guide__guide__content--left-start": "lc-UserGuide-module__user-guide__guide__content--left-start___oCXn1",
  "fade-in-left-start": "lc-UserGuide-module__fade-in-left-start___8ggIA",
  "user-guide__guide__content--left": "lc-UserGuide-module__user-guide__guide__content--left___fgI-F",
  "fade-in-left": "lc-UserGuide-module__fade-in-left___hg0J0",
  "user-guide__guide__content--left-end": "lc-UserGuide-module__user-guide__guide__content--left-end___bR-YA",
  "fade-in-left-end": "lc-UserGuide-module__fade-in-left-end___Ui4wF",
  "user-guide__guide__content--top-start": "lc-UserGuide-module__user-guide__guide__content--top-start___zEKyj",
  "fade-in-top-start": "lc-UserGuide-module__fade-in-top-start___Ha6DR",
  "user-guide__guide__content--top": "lc-UserGuide-module__user-guide__guide__content--top___IsroR",
  "fade-in-top": "lc-UserGuide-module__fade-in-top___rYKUp",
  "user-guide__guide__content--top-end": "lc-UserGuide-module__user-guide__guide__content--top-end___dsuZm",
  "fade-in-top-end": "lc-UserGuide-module__fade-in-top-end___n2H6-",
  "user-guide__guide__content--bottom-start": "lc-UserGuide-module__user-guide__guide__content--bottom-start___o7-Uf",
  "fade-in-bottom-start": "lc-UserGuide-module__fade-in-bottom-start___tPQd1",
  "user-guide__guide__content--bottom": "lc-UserGuide-module__user-guide__guide__content--bottom___2gxXf",
  "fade-in-bottom": "lc-UserGuide-module__fade-in-bottom___2nyvW",
  "user-guide__guide__content--bottom-end": "lc-UserGuide-module__user-guide__guide__content--bottom-end___nT-g2",
  "fade-in-bottom-end": "lc-UserGuide-module__fade-in-bottom-end___89qmL",
  "user-guide__cursor": "lc-UserGuide-module__user-guide__cursor___9IuMJ",
  "user-guide__cursor--bottom": "lc-UserGuide-module__user-guide__cursor--bottom___jYXJ1",
  "user-guide__cursor--left": "lc-UserGuide-module__user-guide__cursor--left___h0ToJ",
  "user-guide__cursor--right": "lc-UserGuide-module__user-guide__cursor--right___Wc-yj"
}, mt = "user-guide", s_ = (e, a = 0) => new gd(e, a), rm = ({
  className: e,
  children: a,
  cursorPosition: o = "bottom-start",
  cursorTiming: r = "fast2",
  parentElementName: _,
  isVisible: l = !1,
  hideOverlay: i = !1,
  elementClassName: n,
  zIndex: d,
  isFirstStep: u,
  isLastStep: s
}) => {
  const [m, h] = le(null), [y, p] = le(null), k = qt(null), x = qt(null), C = u || s ? "bottom-start" : o, { refs: S, x: N, y: $, strategy: w, placement: f, update: v } = Vl({
    middleware: [Kl(), Yl()],
    placement: C,
    open: !0,
    whileElementsMounted: Wl
  }), E = () => {
    m && p(
      s_(m).getBoundingClientRect()
    );
  };
  q(() => {
    if (m !== null)
      return window.addEventListener("resize", E), window.addEventListener("scroll", E), () => {
        window.removeEventListener("resize", E), window.removeEventListener("scroll", E);
      };
  }, [m]), q(() => (window.addEventListener("resize", v), () => window.removeEventListener("resize", v)), [v]), q(() => {
    if (_) {
      const B = document.querySelector(_);
      h(B), S.setReference(B);
    }
  }, [_]), q(() => {
    m && p(
      s_(m).getBoundingClientRect()
    );
  }, [m]), q(() => {
    if (m && k.current) {
      k.current.innerHTML = "";
      const B = m.cloneNode(!0);
      n && (B.className += ` ${n}`), k.current.appendChild(B);
    }
    return () => {
      k.current && (k.current.innerHTML = "");
    };
  }, [m, k.current, n]), q(() => (l ? document.body.classList.add("user-guide-visible") : document.body.classList.remove("user-guide-visible"), () => {
    document.body.classList.remove("user-guide-visible");
  }), [l]);
  const D = () => y ? /* @__PURE__ */ t(
    "div",
    {
      ref: k,
      style: {
        position: "absolute",
        top: y.top,
        left: y.left,
        width: y.width,
        height: y.height,
        pointerEvents: "none"
      }
    }
  ) : null;
  return /* @__PURE__ */ g(W, { children: [
    /* @__PURE__ */ t(
      "div",
      {
        className: c(ut[`${mt}__overlay`]),
        style: {
          display: l && !i ? "flex" : "none",
          zIndex: d
        },
        children: m && D()
      }
    ),
    l && /* @__PURE__ */ t(ha, { children: /* @__PURE__ */ t(
      "div",
      {
        ref: S.setFloating,
        style: {
          position: w,
          top: u || s ? "40%" : $,
          left: u || s ? "calc(50% - 211px)" : N
        },
        className: c(
          ut[`${mt}__floating`],
          ut[`${mt}__floating--${r}`],
          e
        ),
        children: /* @__PURE__ */ g(
          "div",
          {
            ref: x,
            className: c(
              ut[`${mt}__guide`],
              ut[`${mt}__guide--${f}`]
            ),
            children: [
              /* @__PURE__ */ t(
                "div",
                {
                  className: c(
                    ut[`${mt}__guide__arrow`],
                    ut[`${mt}__guide__arrow--${f}`],
                    ut[`${mt}__guide__arrow--${r}`]
                  ),
                  children: /* @__PURE__ */ t("img", { src: pd, alt: "cursor" })
                }
              ),
              a && /* @__PURE__ */ t(
                "div",
                {
                  className: c(
                    ut[`${mt}__guide__content`],
                    ut[`${mt}__guide__content--${f}`],
                    ut[`${mt}__guide__content--${r}`]
                  ),
                  children: a
                },
                _
              )
            ]
          }
        )
      }
    ) })
  ] });
}, Se = {
  "user-guide-bubble-step": "lc-UserGuideBubbleStep-module__user-guide-bubble-step___85b6K",
  "user-guide-bubble-step__bubble-wrapper": "lc-UserGuideBubbleStep-module__user-guide-bubble-step__bubble-wrapper___CsEDk",
  "user-guide-bubble-step__bubble-wrapper--completed": "lc-UserGuideBubbleStep-module__user-guide-bubble-step__bubble-wrapper--completed___Ed8ua",
  "shadow-glow": "lc-UserGuideBubbleStep-module__shadow-glow___uMRE-",
  "user-guide-bubble-step__bubble": "lc-UserGuideBubbleStep-module__user-guide-bubble-step__bubble___CoHl4",
  "fade-in": "lc-UserGuideBubbleStep-module__fade-in___Pjz6d",
  "user-guide-bubble-step__bubble--next-msg": "lc-UserGuideBubbleStep-module__user-guide-bubble-step__bubble--next-msg___bzw2-",
  "user-guide-bubble-step__bubble--header": "lc-UserGuideBubbleStep-module__user-guide-bubble-step__bubble--header___frxyc",
  "user-guide-bubble-step__bubble--message": "lc-UserGuideBubbleStep-module__user-guide-bubble-step__bubble--message___dCGqv",
  "user-guide-bubble-step__bubble--cta": "lc-UserGuideBubbleStep-module__user-guide-bubble-step__bubble--cta___NcXxo"
}, Ne = "user-guide-bubble-step", _m = ({
  headerMessage: e,
  message: a,
  cta: o,
  isCompleted: r,
  handleAnimationComplete: _,
  disableTypingAnimations: l,
  typingDelay: i,
  typingSpeed: n,
  className: d
}) => {
  const [u, s] = le(["header"]), m = u.includes("header"), h = u.includes("message"), y = o && u.includes("cta");
  return q(() => {
    u.length === 3 && _ && _();
  }, [u]), /* @__PURE__ */ g("div", { className: c("lc-light-theme", Se[`${Ne}`], d), children: [
    m && /* @__PURE__ */ t(
      "div",
      {
        className: c(Se[`${Ne}__bubble-wrapper`], {
          [Se[`${Ne}__bubble-wrapper--completed`]]: r
        }),
        children: /* @__PURE__ */ g(
          "div",
          {
            className: c(
              Se[`${Ne}__bubble`],
              Se[`${Ne}__bubble--header`],
              {
                [Se[`${Ne}__bubble--next-msg`]]: h
              }
            ),
            children: [
              /* @__PURE__ */ t("div", { className: Se[`${Ne}__bubble__icon`], children: /* @__PURE__ */ t(O, { size: "large", source: f_ }) }),
              /* @__PURE__ */ t(T, { as: "span", children: /* @__PURE__ */ t(
                kr,
                {
                  text: e,
                  typingAnimation: !l,
                  typingDelay: i,
                  typingSpeed: n,
                  onTypingEnd: () => s([...u, "message"])
                }
              ) })
            ]
          }
        )
      }
    ),
    h && /* @__PURE__ */ t(
      "div",
      {
        className: c(Se[`${Ne}__bubble-wrapper`], {
          [Se[`${Ne}__bubble-wrapper--completed`]]: r
        }),
        children: /* @__PURE__ */ t(
          "div",
          {
            className: c(
              Se[`${Ne}__bubble`],
              Se[`${Ne}__bubble--message`],
              {
                [Se[`${Ne}__bubble--next-msg`]]: y
              }
            ),
            children: /* @__PURE__ */ t(T, { as: "span", children: /* @__PURE__ */ t(
              kr,
              {
                text: a,
                typingAnimation: !l,
                typingSpeed: n,
                typingDelay: 0,
                onTypingEnd: () => s([...u, "cta"])
              }
            ) })
          }
        )
      }
    ),
    y && /* @__PURE__ */ t(
      "div",
      {
        className: c(Se[`${Ne}__bubble-wrapper`], {
          [Se[`${Ne}__bubble-wrapper--completed`]]: r
        }),
        children: /* @__PURE__ */ t(
          "div",
          {
            className: c(
              Se[`${Ne}__bubble`],
              Se[`${Ne}__bubble--cta`]
            ),
            children: o
          }
        )
      }
    )
  ] });
}, et = {
  "user-guide-step": "lc-UserGuideStep-module__user-guide-step___WxRx-",
  "user-guide-step__heading": "lc-UserGuideStep-module__user-guide-step__heading___TmHOq",
  "user-guide-step__content": "lc-UserGuideStep-module__user-guide-step__content___1hIeo",
  "user-guide-step__media-wrapper": "lc-UserGuideStep-module__user-guide-step__media-wrapper___RF2FB",
  "user-guide-step__media": "lc-UserGuideStep-module__user-guide-step__media___GyJrq",
  "user-guide-step__footer": "lc-UserGuideStep-module__user-guide-step__footer___jhJ3K",
  "fade-in": "lc-UserGuideStep-module__fade-in___3sI4D",
  "user-guide-step__footer__step-counter": "lc-UserGuideStep-module__user-guide-step__footer__step-counter___GWY-W",
  "user-guide-step__footer__step-counter__current-step": "lc-UserGuideStep-module__user-guide-step__footer__step-counter__current-step___EfyHm",
  "user-guide-step__footer__button-primary": "lc-UserGuideStep-module__user-guide-step__footer__button-primary___1PHEv",
  "user-guide-step__footer__button-close": "lc-UserGuideStep-module__user-guide-step__footer__button-close___ShrtZ"
}, tt = "user-guide-step", lm = ({
  header: e,
  text: a,
  customCta: o,
  image: r,
  video: _,
  currentStep: l,
  stepMax: i,
  typingAnimation: n = !1,
  typingDelay: d,
  typingSpeed: u,
  handleCloseAction: s,
  handleClickPrimary: m,
  className: h
}) => {
  const [y, p] = le(!1);
  return q(() => {
    if (s)
      return document.addEventListener("keydown", s), () => {
        document.removeEventListener("keydown", s);
      };
  }, [s]), /* @__PURE__ */ g("div", { className: c("lc-light-theme", et[`${tt}`], h), children: [
    /* @__PURE__ */ g("span", { className: et[`${tt}__heading`], children: [
      /* @__PURE__ */ t(O, { size: "large", source: f_ }),
      /* @__PURE__ */ t(T, { size: "lg", bold: !0, as: "span", children: e })
    ] }),
    r && /* @__PURE__ */ t("div", { className: et[`${tt}__media-wrapper`], children: /* @__PURE__ */ t(
      "img",
      {
        className: et[`${tt}__media`],
        src: r.src,
        alt: r.alt
      }
    ) }),
    _ && !r && /* @__PURE__ */ t("div", { className: et[`${tt}__media-wrapper`], children: /* @__PURE__ */ t(
      "video",
      {
        className: et[`${tt}__media`],
        "data-testid": "user-guide-step-video",
        src: _.src,
        playsInline: _.playsInline,
        autoPlay: _.autoPlay,
        muted: _.muted,
        loop: _.loop,
        controls: _.controls
      }
    ) }),
    /* @__PURE__ */ t(
      T,
      {
        id: "user-guide-step-typed-text",
        as: "span",
        className: et[`${tt}__content`],
        children: /* @__PURE__ */ t(
          kr,
          {
            text: a,
            typingAnimation: n,
            typingDelay: d,
            typingSpeed: u,
            onTypingEnd: () => p(!0)
          }
        )
      }
    ),
    y && /* @__PURE__ */ g("div", { className: et[`${tt}__footer`], children: [
      /* @__PURE__ */ t(
        L,
        {
          kind: "high-contrast",
          size: "large",
          onClick: m,
          className: et[`${tt}__footer__button-primary`],
          children: o || (l === i ? "Finish" : "Next")
        }
      ),
      /* @__PURE__ */ g("span", { children: [
        s && /* @__PURE__ */ t(
          L,
          {
            kind: "plain",
            size: "large",
            onClick: s,
            className: et[`${tt}__footer__button-close`],
            children: "Skip all"
          }
        ),
        /* @__PURE__ */ g(
          T,
          {
            as: "span",
            className: et[`${tt}__footer__step-counter`],
            children: [
              /* @__PURE__ */ t(
                "span",
                {
                  className: et[`${tt}__footer__step-counter__current-step`],
                  children: l
                }
              ),
              " ",
              "/ ",
              i,
              " steps"
            ]
          }
        )
      ] })
    ] })
  ] });
}, mr = {
  "file-upload-progress-actions": "lc-FileUploadProgressActions-module__file-upload-progress-actions___XINkF",
  "file-upload-progress-actions__close-button": "lc-FileUploadProgressActions-module__file-upload-progress-actions__close-button___BHRcO",
  "file-upload-progress-actions__retry-button": "lc-FileUploadProgressActions-module__file-upload-progress-actions__retry-button___2Xd72"
}, pr = "file-upload-progress-actions", wr = ({ status: e, onCloseButtonClick: a, onRetryButtonClick: o }) => /* @__PURE__ */ g("div", { className: mr[`${pr}`], children: [
  o && e === "error" && /* @__PURE__ */ t(
    "button",
    {
      type: "button",
      className: mr[`${pr}__retry-button`],
      "aria-label": "Retry",
      onClick: o,
      children: /* @__PURE__ */ t(O, { size: "small", source: Nl })
    }
  ),
  a && e !== "success" && /* @__PURE__ */ t(
    "button",
    {
      type: "button",
      className: mr[`${pr}__close-button`],
      "aria-label": "Close",
      onClick: a,
      children: /* @__PURE__ */ t(O, { size: "small", source: lt })
    }
  )
] }), pt = {
  "file-upload-progress": "lc-FileUploadProgress-module__file-upload-progress___cAUbT",
  "file-upload-progress__icon": "lc-FileUploadProgress-module__file-upload-progress__icon___ZCOg9",
  "file-upload-progress__icon--success": "lc-FileUploadProgress-module__file-upload-progress__icon--success___mQkAS",
  "file-upload-progress__wrapper": "lc-FileUploadProgress-module__file-upload-progress__wrapper___Hrlp6",
  "file-upload-progress__wrapper--with-icon": "lc-FileUploadProgress-module__file-upload-progress__wrapper--with-icon___t56aA",
  "file-upload-progress__wrapper__header": "lc-FileUploadProgress-module__file-upload-progress__wrapper__header___DKuHl",
  "file-upload-progress__wrapper__header__actions": "lc-FileUploadProgress-module__file-upload-progress__wrapper__header__actions___AM74G",
  "file-upload-progress__wrapper__header__title": "lc-FileUploadProgress-module__file-upload-progress__wrapper__header__title___EYxE3",
  "file-upload-progress__wrapper__header__title--success": "lc-FileUploadProgress-module__file-upload-progress__wrapper__header__title--success___P0XSe",
  "file-upload-progress__wrapper__header__title--error": "lc-FileUploadProgress-module__file-upload-progress__wrapper__header__title--error___la8oa"
}, Ft = "file-upload-progress", gr = `${Ft}__wrapper__header__title`, hd = b.forwardRef(
  ({
    actionsVisibility: e = "hidden",
    className: a,
    icon: o,
    title: r,
    progressValue: _,
    size: l,
    status: i = "normal",
    onCloseButtonClick: n,
    onRetryButtonClick: d
  }, u) => /* @__PURE__ */ g("div", { className: pt[Ft], ref: u, children: [
    o && i !== "success" && /* @__PURE__ */ t("div", { className: pt[`${Ft}__icon`], children: o }),
    i === "success" && /* @__PURE__ */ t(
      "div",
      {
        className: c(
          pt[`${Ft}__icon`],
          pt[`${Ft}__icon--success`]
        ),
        children: /* @__PURE__ */ t(O, { source: fa })
      }
    ),
    /* @__PURE__ */ g(
      "div",
      {
        className: c(pt[`${Ft}__wrapper`], {
          [pt[`${Ft}__wrapper--with-icon`]]: o
        }),
        children: [
          /* @__PURE__ */ g("div", { className: pt[`${Ft}__wrapper__header`], children: [
            r && /* @__PURE__ */ t(
              "div",
              {
                className: c(pt[gr], {
                  [pt[`${gr}--success`]]: i === "success",
                  [pt[`${gr}--error`]]: i === "error"
                }),
                children: /* @__PURE__ */ t(T, { size: "sm", as: "div", children: r })
              }
            ),
            e !== "hidden" && /* @__PURE__ */ t(
              "div",
              {
                className: c({
                  [pt[`${Ft}__wrapper__header__actions`]]: e === "hover"
                }),
                children: /* @__PURE__ */ t(
                  wr,
                  {
                    status: i,
                    onCloseButtonClick: n,
                    onRetryButtonClick: d
                  }
                )
              }
            )
          ] }),
          i !== "success" && /* @__PURE__ */ t(
            rs,
            {
              className: a,
              percent: _,
              status: i,
              size: l
            }
          )
        ]
      }
    )
  ] })
), J = {
  "upload-bar": "lc-UploadBar-module__upload-bar___0ZOP3",
  "upload-bar__loader-test": "lc-UploadBar-module__upload-bar__loader-test___4QKID",
  "upload-bar--error": "lc-UploadBar-module__upload-bar--error___83It3",
  "upload-bar__wrapper": "lc-UploadBar-module__upload-bar__wrapper___vk3pI",
  "upload-bar__wrapper__header": "lc-UploadBar-module__upload-bar__wrapper__header___3z6fH",
  "upload-bar__wrapper__header__icon": "lc-UploadBar-module__upload-bar__wrapper__header__icon___97HQo",
  "upload-bar__wrapper__header__title": "lc-UploadBar-module__upload-bar__wrapper__header__title___CqykW",
  "upload-bar__wrapper__header__collapse-button": "lc-UploadBar-module__upload-bar__wrapper__header__collapse-button___9n0O7",
  "upload-bar__wrapper__header__actions-container": "lc-UploadBar-module__upload-bar__wrapper__header__actions-container___80EgZ",
  "upload-bar__wrapper__header__success-icon": "lc-UploadBar-module__upload-bar__wrapper__header__success-icon___eau3A",
  "upload-bar__wrapper__header__error-icon": "lc-UploadBar-module__upload-bar__wrapper__header__error-icon___VZLl2",
  "upload-bar__wrapper__header__loader": "lc-UploadBar-module__upload-bar__wrapper__header__loader___h0F6t",
  "upload-bar__files": "lc-UploadBar-module__upload-bar__files___jMFT-",
  "upload-bar__files--enter": "lc-UploadBar-module__upload-bar__files--enter___BNcoJ",
  "upload-bar__files--enter-active": "lc-UploadBar-module__upload-bar__files--enter-active___yj9Mq",
  "upload-bar__files--exit": "lc-UploadBar-module__upload-bar__files--exit___iEuiQ",
  "upload-bar__files--exit-active": "lc-UploadBar-module__upload-bar__files--exit-active___mz8u3",
  "upload-bar__files--exit-done": "lc-UploadBar-module__upload-bar__files--exit-done___-N5nJ",
  "upload-bar__files-wrapper": "lc-UploadBar-module__upload-bar__files-wrapper___C3au9",
  "upload-bar__files__list": "lc-UploadBar-module__upload-bar__files__list___95G7b"
}, Me = "upload-bar", Lt = `${Me}__wrapper__header`, fd = 300, bd = (e, a) => e === "success" ? /* @__PURE__ */ t(
  "div",
  {
    "data-testid": "success-icon",
    className: J[`${Lt}__success-icon`],
    children: /* @__PURE__ */ t(O, { source: fa })
  }
) : e === "error" ? /* @__PURE__ */ t(
  "div",
  {
    "data-testid": "error-icon",
    className: J[`${Lt}__error-icon`],
    children: /* @__PURE__ */ t(O, { source: h_ })
  }
) : /* @__PURE__ */ t(
  os,
  {
    className: J[`${Lt}__loader`],
    status: e,
    progressValue: a
  }
), im = ({
  children: e,
  className: a,
  progressValue: o,
  title: r,
  isExpanded: _,
  errorMessage: l,
  status: i = "normal",
  icon: n,
  size: d,
  mode: u = "multiple",
  onCloseButtonClick: s,
  onRetryButtonClick: m
}) => {
  const [h, y] = b.useState(_ || !1), p = i === "error", k = i === "success", x = c(J[Me], a, {
    [J[`${Me}--error`]]: p,
    [J[`${Me}--success`]]: k
  }), C = !(p && (m || s)), S = () => y(!h);
  return u === "single" ? /* @__PURE__ */ t("div", { className: x, children: /* @__PURE__ */ g("div", { className: J[`${Me}__wrapper`], children: [
    /* @__PURE__ */ t("div", { className: J[`${Lt}`], children: /* @__PURE__ */ t(
      hd,
      {
        title: p && l || r,
        progressValue: o,
        status: i,
        icon: n,
        size: d
      }
    ) }),
    i === "error" && /* @__PURE__ */ t(
      wr,
      {
        status: i,
        onCloseButtonClick: s,
        onRetryButtonClick: m
      }
    )
  ] }) }) : /* @__PURE__ */ g("div", { className: x, children: [
    /* @__PURE__ */ t(
      "div",
      {
        className: J[`${Me}__wrapper`],
        onClick: S,
        children: /* @__PURE__ */ g("div", { className: J[`${Lt}`], children: [
          /* @__PURE__ */ t("div", { className: J[`${Lt}__icon`], children: bd(i, o) }),
          /* @__PURE__ */ t("div", { className: J[`${Lt}__title`], children: /* @__PURE__ */ t(T, { size: "sm", as: "div", children: p ? l : r }) }),
          C && /* @__PURE__ */ t(
            "button",
            {
              className: J[`${Lt}__collapse-button`],
              type: "button",
              "aria-label": "Collapse button",
              onClick: S,
              children: h ? /* @__PURE__ */ t(O, { source: ja }) : /* @__PURE__ */ t(O, { source: Xt })
            }
          ),
          i === "error" && /* @__PURE__ */ t("div", { className: J[`${Lt}__actions-container`], children: /* @__PURE__ */ t(
            wr,
            {
              status: i,
              onCloseButtonClick: s,
              onRetryButtonClick: m
            }
          ) })
        ] })
      }
    ),
    /* @__PURE__ */ t(k_, { component: null, children: h && /* @__PURE__ */ t(
      C_,
      {
        timeout: fd,
        classNames: {
          enter: J[`${Me}__files--enter`],
          enterActive: J[`${Me}__files--enter-active`],
          exit: J[`${Me}__files--exit`],
          exitActive: J[`${Me}__files--exit-active`],
          exitDone: J[`${Me}__files--exit-done`]
        },
        children: /* @__PURE__ */ t("div", { className: J[`${Me}__files`], children: /* @__PURE__ */ t("div", { className: J[`${Me}__files-wrapper`], children: /* @__PURE__ */ t("div", { className: J[`${Me}__files__list`], children: e }) }) })
      }
    ) })
  ] });
}, nm = ({
  children: e,
  id: a,
  root: o,
  preserveTabOrder: r
}) => /* @__PURE__ */ t(ha, { id: a, root: o, preserveTabOrder: r, children: e }), vd = "lc-Stepper-module__stepper__counter___K59ri", yd = "lc-Stepper-module__stepper__steps__container___sYhuT", kd = "lc-Stepper-module__stepper__step___mCyT-", ua = {
  stepper__counter: vd,
  stepper__steps__container: yd,
  stepper__step: kd,
  "stepper__step--completed": "lc-Stepper-module__stepper__step--completed___unE6n",
  "stepper__step--active": "lc-Stepper-module__stepper__step--active___uirCz"
}, ma = "stepper", cm = ({
  activeStep: e,
  steps: a,
  className: o,
  "data-testid": r = "stepper",
  ..._
}) => {
  const l = Math.round(Math.max(1, a)), i = Math.round(
    Math.min(Math.max(1, e), l)
  ), n = c(ua[ma], o);
  return /* @__PURE__ */ g(
    "div",
    {
      className: n,
      "data-testid": r,
      "aria-label": "Stepper",
      ..._,
      children: [
        /* @__PURE__ */ g(T, { size: "sm", className: ua[`${ma}__counter`], children: [
          i,
          "/",
          l
        ] }),
        /* @__PURE__ */ t(
          "div",
          {
            className: ua[`${ma}__steps__container`],
            "data-testid": `${r}-container`,
            children: Array.from({ length: l }, (d, u) => {
              const s = u + 1, m = s <= i, h = s > i;
              return /* @__PURE__ */ t(
                "div",
                {
                  "aria-completed": m,
                  className: c(ua[`${ma}__step`], {
                    [ua[`${ma}__step--completed`]]: m,
                    [ua[`${ma}__step--active`]]: h
                  })
                },
                s
              );
            })
          }
        )
      ]
    }
  );
}, hr = {
  "system-message-timestamp__value": "lc-SystemMessageTimestamp-module__system-message-timestamp__value___2E9S5",
  "system-message-timestamp__tooltip-wrapper": "lc-SystemMessageTimestamp-module__system-message-timestamp__tooltip-wrapper___OQVQr",
  "system-message-timestamp__tooltip-text": "lc-SystemMessageTimestamp-module__system-message-timestamp__tooltip-text___vMLWM"
}, fr = "system-message-timestamp", Cd = ({
  timestamp: e,
  timestampWithSeconds: a
}) => /* @__PURE__ */ t(
  Yt,
  {
    "data-testid": "system-message-timestamp",
    placement: "top",
    kind: "invert",
    withFadeAnimation: !0,
    hoverOnDelay: 600,
    hoverOffDelay: 0,
    className: c(hr[`${fr}__tooltip-wrapper`]),
    triggerRenderer: () => /* @__PURE__ */ g(
      T,
      {
        size: "xs",
        className: hr[`${fr}__value`],
        "data-testid": "system-message-timestamp-value",
        children: [
          "• ",
          e
        ]
      }
    ),
    children: /* @__PURE__ */ t(
      T,
      {
        size: "xs",
        className: c(hr[`${fr}__tooltip-text`]),
        "data-testid": "system-message-timestamp-tooltip-text",
        children: a
      }
    )
  }
), ee = {
  "system-message__wrapper": "lc-SystemMessage-module__system-message__wrapper___ZvByq",
  "system-message__header-wrapper": "lc-SystemMessage-module__system-message__header-wrapper___L2mJw",
  "system-message__header-wrapper--alignment-left": "lc-SystemMessage-module__system-message__header-wrapper--alignment-left___nbtk7",
  "system-message__header-wrapper--alignment-right": "lc-SystemMessage-module__system-message__header-wrapper--alignment-right___dWNNV",
  "system-message__header-wrapper-title--kind-info": "lc-SystemMessage-module__system-message__header-wrapper-title--kind-info___zTZIc",
  "system-message__header-wrapper-title--kind-positive": "lc-SystemMessage-module__system-message__header-wrapper-title--kind-positive___HOpPL",
  "system-message__header-wrapper-title--kind-warning": "lc-SystemMessage-module__system-message__header-wrapper-title--kind-warning___cMR-S",
  "system-message__header-wrapper-title--kind-error": "lc-SystemMessage-module__system-message__header-wrapper-title--kind-error___9W4N4",
  "system-message__header-wrapper-title--kind-default": "lc-SystemMessage-module__system-message__header-wrapper-title--kind-default___7Sz-W",
  "system-message__header-wrapper-title--bold": "lc-SystemMessage-module__system-message__header-wrapper-title--bold___Xgx6h",
  "system-message__header-wrapper-source": "lc-SystemMessage-module__system-message__header-wrapper-source___UFPCI",
  "system-message__header-wrapper-icon": "lc-SystemMessage-module__system-message__header-wrapper-icon___Fsoym",
  "system-message__details-wrapper": "lc-SystemMessage-module__system-message__details-wrapper___72AyK",
  "system-message__details-wrapper--alignment-left": "lc-SystemMessage-module__system-message__details-wrapper--alignment-left___0l8HF",
  "system-message__details-wrapper--alignment-left-margin": "lc-SystemMessage-module__system-message__details-wrapper--alignment-left-margin___K6M-H",
  "system-message__details-wrapper--alignment-right": "lc-SystemMessage-module__system-message__details-wrapper--alignment-right___me9LA",
  "system-message__details-toggle": "lc-SystemMessage-module__system-message__details-toggle___bGMIk",
  "system-message__details-line": "lc-SystemMessage-module__system-message__details-line___NBSiv",
  "system-message__details-first-line": "lc-SystemMessage-module__system-message__details-first-line___DZpbU",
  "system-message__details-first-line--alignment-left": "lc-SystemMessage-module__system-message__details-first-line--alignment-left___eId9x",
  "system-message__details-first-line--alignment-right": "lc-SystemMessage-module__system-message__details-first-line--alignment-right___d-Ur9",
  "system-message__actions-wrapper": "lc-SystemMessage-module__system-message__actions-wrapper___ZeV9m",
  "system-message__actions-wrapper--alignment-left": "lc-SystemMessage-module__system-message__actions-wrapper--alignment-left___nXIND",
  "system-message__actions-wrapper--alignment-left-margin": "lc-SystemMessage-module__system-message__actions-wrapper--alignment-left-margin___PDu3-",
  "system-message__actions-wrapper--alignment-right": "lc-SystemMessage-module__system-message__actions-wrapper--alignment-right___F-y9M",
  "system-message__actions-wrapper-menu-trigger": "lc-SystemMessage-module__system-message__actions-wrapper-menu-trigger___y41Gz",
  "system-message__action-item": "lc-SystemMessage-module__system-message__action-item___uVowH"
}, te = "system-message", sm = ({
  children: e,
  source: a,
  alignment: o = "right",
  kind: r = "default",
  iconSource: _,
  titleBold: l = !1,
  details: i,
  timestamp: n,
  timestampWithSeconds: d,
  actions: u
}) => {
  const [s, m] = b.useState(!1), h = c(
    ee[`${te}__header-wrapper-title`],
    ee[`${te}__header-wrapper-title--kind-${r}`],
    {
      [ee[`${te}__header-wrapper-title--bold`]]: l
    }
  ), y = c(
    ee[`${te}__header-wrapper`],
    ee[`${te}__header-wrapper--alignment-${o}`]
  ), p = c(
    ee[`${te}__details-wrapper`],
    ee[`${te}__details-wrapper--alignment-${o}`],
    {
      [ee[`${te}__details-wrapper--alignment-left-margin`]]: o === "left" && _
    }
  ), k = c(
    ee[`${te}__details-line`],
    ee[`${te}__details-first-line`],
    ee[`${te}__details-first-line--alignment-${o}`]
  ), x = c(
    ee[`${te}__actions-wrapper`],
    ee[`${te}__actions-wrapper--alignment-${o}`],
    {
      [ee[`${te}__actions-wrapper--alignment-left-margin`]]: o === "left" && _
    }
  ), C = (w, f) => {
    let v = "primary";
    switch (f) {
      case "info":
        v = "primary";
        break;
      case "positive":
        v = "positive";
        break;
      case "warning":
        v = "warning";
        break;
      case "error":
        v = "error";
        break;
      case "default":
        v = "subtle";
        break;
      default:
        v = "subtle";
        break;
    }
    return /* @__PURE__ */ t(
      O,
      {
        size: "small",
        "data-testid": "system-message-header-icon",
        source: w,
        kind: v
      }
    );
  }, S = (w) => w.slice(2).map((f) => ({
    key: f.label,
    element: /* @__PURE__ */ t(
      Xa,
      {
        leftNode: f.icon ? /* @__PURE__ */ t(O, { source: f.icon, kind: "primary" }) : void 0,
        children: f.label
      }
    ),
    onClick: f.callback
  })), N = (w) => /* @__PURE__ */ g("div", { className: x, children: [
    w.slice(0, 2).map((f) => /* @__PURE__ */ t(
      T,
      {
        className: ee[`${te}__action-item`],
        underline: !0,
        size: "xs",
        onClick: f.callback,
        children: f.label
      },
      f.label
    )),
    w.length > 2 && /* @__PURE__ */ t(
      Er,
      {
        placement: "bottom-end",
        options: S(w),
        triggerRenderer: /* @__PURE__ */ t(
          L,
          {
            kind: "plain",
            size: "xcompact",
            "data-testid": "system-message-actions-menu-trigger",
            className: ee[`${te}__actions-wrapper-menu-trigger`],
            icon: /* @__PURE__ */ t(O, { source: xl, kind: "primary" })
          }
        )
      }
    )
  ] }), $ = (w) => /* @__PURE__ */ g(
    "div",
    {
      "data-testid": "system-message-details",
      className: p,
      children: [
        /* @__PURE__ */ g("div", { className: k, children: [
          w.slice(0, 1).map((f, v) => /* @__PURE__ */ t(T, { as: "div", size: "xs", children: f }, `detail-first-${v}`)),
          w.length > 1 && /* @__PURE__ */ t(
            L,
            {
              kind: "plain",
              size: "xcompact",
              "data-testid": "system-message-details-toggle",
              className: ee[`${te}__details-toggle`],
              onClick: () => m(!s),
              icon: /* @__PURE__ */ t(
                O,
                {
                  source: s ? ja : Xt,
                  kind: "primary"
                }
              )
            }
          )
        ] }),
        s && w.slice(1).map((f) => /* @__PURE__ */ t(
          "div",
          {
            className: ee[`${te}__details-line`],
            children: /* @__PURE__ */ t(T, { as: "div", size: "xs", children: f })
          },
          `detail-${w.indexOf(f)}`
        ))
      ]
    }
  );
  return /* @__PURE__ */ g(
    "div",
    {
      "data-testid": "system-message",
      className: c(ee[`${te}__wrapper`]),
      children: [
        /* @__PURE__ */ g(
          "div",
          {
            "data-testid": "system-message-header",
            className: y,
            children: [
              _ && /* @__PURE__ */ t("div", { className: ee[`${te}__header-wrapper-icon`], children: C(_, r) }),
              /* @__PURE__ */ t(
                T,
                {
                  as: "div",
                  size: "xs",
                  "data-testid": "system-message-title",
                  className: h,
                  children: e
                }
              ),
              a && /* @__PURE__ */ g(
                T,
                {
                  as: "div",
                  size: "xs",
                  "data-testid": "system-message-source",
                  className: ee[`${te}__header-wrapper-source`],
                  children: [
                    "• ",
                    a
                  ]
                }
              ),
              n && d && /* @__PURE__ */ t(
                Cd,
                {
                  timestamp: n,
                  timestampWithSeconds: d
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ g(W, { children: [
          i && $(i),
          u && N(u)
        ] })
      ]
    }
  );
};
export {
  sd as ANIMATION_TIME,
  Zd as Accordion,
  _i as AccordionAnimatedLabel,
  li as AccordionMultilineElement,
  jd as AccordionPromo,
  au as ActionBar,
  ou as ActionCard,
  Er as ActionMenu,
  Jd as ActionMenuItem,
  Iu as ActionModalContent,
  ru as Alert,
  kr as AnimatedTextContainer,
  _u as AppFrame,
  ti as AppFrameProvider,
  gu as AutoComplete,
  Br as Avatar,
  To as Badge,
  L as Button,
  fu as Card,
  Go as Checkbox,
  pc as DatePicker,
  bu as DatePickerRangeCalendarsWrapper,
  Fd as DesignToken,
  vu as DetailsCard,
  yu as DetailsCardInfo,
  Lr as Display,
  em as EmailTagInput,
  ku as EmptyState,
  du as ExpirationCounter,
  Fo as FieldDescription,
  Ir as FieldError,
  Cu as FieldGroup,
  hd as FileUploadProgress,
  wr as FileUploadProgressActions,
  nm as FloatingPortal,
  wu as Form,
  $u as FormField,
  Su as FormGroup,
  Uu as GallerySelectableCard,
  zu as GridCol,
  Hu as GridRow,
  qu as GridWrapper,
  Xd as HEADING_SIZES,
  ce as Heading,
  O as Icon,
  eu as Info,
  fn as Input,
  D_ as InputComponent,
  mu as InputPromo,
  Oi as Interactive,
  Lu as InteractiveSelectableCard,
  Nu as InviteAgents,
  xu as Link,
  Xa as ListItem,
  Tr as Loader,
  uu as MobileNavigation,
  Eu as Modal,
  Pc as ModalBase,
  o_ as ModalCloseButton,
  Bu as ModalHeader,
  Tu as ModalPortal,
  su as Navigation,
  nu as NavigationGroup,
  cu as NavigationItem,
  I_ as NavigationTopBar,
  un as NavigationTopBarAlert,
  dn as NavigationTopBarTitle,
  Au as NumericInput,
  Du as OnboardingChecklist,
  Ou as OverflowTooltipText,
  pu as Picker,
  M_ as PickerList,
  qc as Popover,
  Pu as ProductSwitcher,
  Vc as ProductSwitcherProducts,
  rs as ProgressBar,
  os as ProgressCircle,
  Ru as PromoBannerV2,
  _s as RadioButton,
  Ld as RadiusToken,
  q_ as RangeDatePicker,
  Fu as RangeDatePickerV2,
  tu as Reports,
  Ji as SIDE_NAVIGATION_ACTIVE_ITEM_TEST_ID,
  ji as SIDE_NAVIGATION_ITEM_TEST_ID,
  Qi as SIDE_NAVIGATION_PARENT_ICON_TEST_ID,
  ss as SearchInput,
  hu as SegmentedControl,
  Dr as SelectableCard,
  Ud as ShadowToken,
  lu as SideNavigation,
  iu as SideNavigationGroup,
  en as SideNavigationItem,
  Qd as Simple,
  Wu as SkeletonAvatar,
  Ku as SkeletonText,
  Vu as SkeletonWrapper,
  Gd as SpacingToken,
  Yu as StatusBadge,
  cm as Stepper,
  Xu as Switch,
  sm as SystemMessage,
  Zu as Tab,
  Qu as Table,
  Ju as TabsList,
  ju as TabsWrapper,
  R_ as Tag,
  ed as TagInput,
  T as Text,
  am as Textarea,
  Kt as ThemeClassName,
  Kd as ThemeProvider,
  Gu as ThumbnailSelectableCard,
  cd as Toast,
  tm as ToastWrapper,
  Yt as Tooltip,
  zd as TransitionDelayToken,
  qd as TransitionDurationToken,
  Hd as TransitionTimingToken,
  om as UpdateBadge,
  im as UploadBar,
  rm as UserGuide,
  _m as UserGuideBubbleStep,
  lm as UserGuideStep,
  Cn as generateAvatarColor,
  Yd as getDesignTokenWithOpacity,
  Vd as getThemeClassName,
  ra as useAnimations,
  xr as useAppFrame,
  Mu as useProductSwitcher,
  xs as useTable,
  Wd as useTheme
};
